const portfolio = [
    {
        "iso_code": "USA",
        "country": "United States",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 800000, "eur" : 742300}
        },
        "business_opportunity": 75,
        "climate_resilience": 71,
        "economic_freedom": 72,
        "education": 77,
        "lifestyle": 64,
        "private_healthcare": 55,
        "safety_security": 51,
        "climate_resilience_score": 1,
        "safety_and_security": 0.455251328,
        "total_business_opportunity": 0.870339526,
        "open_for_business": 0.54056696,
        "entrepreneurship": 0.954243119,
        "gdp_2021": 1,
        "gdp_per_capita": 0.398098511,
        "gdp_growth_annual_percentage_2021": 0.47922999,
        "haq": 0.798484849,
        "domestic_private_health_expenditure_per_capita": 0.817932877,
        "domestic_private_health_expenditure": 0.55513308,
        "global_health_security_index": 1,
        "insurance_companies_number": 0.029801325,
        "number_of_private_hospitals": 0.024651163,
        "health_care_system": 0.319,
        "health_care_index": 0.285097192,
        "insurance_companies_number_vs_population_density": 0.00725058,
        "number_of_private_hospitals_vs_population_density": 0.048273811,
        "land_area": 0.558557271,
        "innovation_index": 0.916831683,
        "number_of_universities_in_top_1000": 1,
        "number_of_top_tier_international_schools": 1,
        "education_index": 0.942028986,
        "quality_index": 0.87890625,
        "opportunity_index": 0.964562943,
        "school_enrollment_secondary": 0.092387904,
        "school_enrollment_primary": 0.089914075,
        "best_countries_for_education": 0.702,
        "economic_freedom_index": 0.848894349,
        "demographic_pressures_indicator": 0.482758621,
        "cost_of_living": 0.211452678,
        "happiness_index": 0.852049911,
        "human_development_index": 0.947368421,
        "standard_of_living_index_by_world_population_review": 0.852614428,
        "ccpi": 0.316155989,
        "population_density_per_km2": 0.001296381,
        "quality_of_life": 0.464924012
    },
    {
        "iso_code": "DEU",
        "country": "Germany",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 72,
        "climate_resilience": 70,
        "economic_freedom": 76,
        "education": 62,
        "lifestyle": 63,
        "private_healthcare": 65,
        "safety_security": 71,
        "climate_resilience_score": 0.994174757,
        "safety_and_security": 0.854924397,
        "total_business_opportunity": 0.816527867,
        "open_for_business": 0.756272401,
        "entrepreneurship": 1,
        "gdp_2021": 0.183642648,
        "gdp_per_capita": 0.291522541,
        "gdp_growth_annual_percentage_2021": 0.42289767,
        "haq": 0.875757576,
        "domestic_private_health_expenditure_per_capita": 0.184169681,
        "domestic_private_health_expenditure": 0.235622624,
        "global_health_security_index": 0.826377296,
        "insurance_companies_number": 0.877483444,
        "number_of_private_hospitals": 0.013627907,
        "health_care_system": 0.981,
        "health_care_index": 0.42937365,
        "insurance_companies_number_vs_population_density": 0.032337587,
        "number_of_private_hospitals_vs_population_density": 0.004065511,
        "land_area": 0.021333721,
        "innovation_index": 0.837623762,
        "number_of_universities_in_top_1000": 0.276243094,
        "number_of_top_tier_international_schools": 0.042730589,
        "education_index": 1,
        "quality_index": 0.830078125,
        "opportunity_index": 0.69119136,
        "school_enrollment_secondary": 0.099478624,
        "school_enrollment_primary": 0.051657119,
        "best_countries_for_education": 0.975,
        "economic_freedom_index": 0.898034398,
        "demographic_pressures_indicator": 0.149425287,
        "cost_of_living": 0.07624745,
        "happiness_index": 0.814616756,
        "human_development_index": 0.98245614,
        "standard_of_living_index_by_world_population_review": 0.884461561,
        "ccpi": 0.771239554,
        "population_density_per_km2": 0.008953532,
        "quality_of_life": 0.855927052
    },
    {
        "iso_code": "GBR",
        "country": "United Kingdom",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 61400, "eur" : 56900}
        },
        "business_opportunity": 65,
        "climate_resilience": 69,
        "economic_freedom": 73,
        "education": 78,
        "lifestyle": 69,
        "private_healthcare": 66,
        "safety_security": 67,
        "climate_resilience_score": 0.976699029,
        "safety_and_security": 0.771148345,
        "total_business_opportunity": 0.723894939,
        "open_for_business": 0.686868687,
        "entrepreneurship": 0.895756881,
        "gdp_2021": 0.138580254,
        "gdp_per_capita": 0.271531753,
        "gdp_growth_annual_percentage_2021": 0.515096251,
        "haq": 0.848484849,
        "domestic_private_health_expenditure_per_capita": 0.134330384,
        "domestic_private_health_expenditure": 0.214828897,
        "global_health_security_index": 0.85475793,
        "insurance_companies_number": 0.149006623,
        "number_of_private_hospitals": 0.011976744,
        "health_care_system": 0.895,
        "health_care_index": 0.633045356,
        "insurance_companies_number_vs_population_density": 0.004640371,
        "number_of_private_hospitals_vs_population_density": 0.003057396,
        "land_area": 0.014772638,
        "innovation_index": 0.887128713,
        "number_of_universities_in_top_1000": 0.55801105,
        "number_of_top_tier_international_schools": 0.055237103,
        "education_index": 0.985507246,
        "quality_index": 1,
        "opportunity_index": 1,
        "school_enrollment_secondary": 0.778623566,
        "school_enrollment_primary": 0.290609656,
        "best_countries_for_education": 0.96,
        "economic_freedom_index": 0.856265356,
        "demographic_pressures_indicator": 0.298850575,
        "cost_of_living": 0.44531277,
        "happiness_index": 0.83600713,
        "human_development_index": 0.947368421,
        "standard_of_living_index_by_world_population_review": 0.875870241,
        "ccpi": 0.937674095,
        "population_density_per_km2": 0.010486101,
        "quality_of_life": 0.714407295
    },
    {
        "iso_code": "CHE",
        "country": "Switzerland",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 271000, "eur" : 251500}
        },
        "business_opportunity": 78,
        "climate_resilience": 68,
        "economic_freedom": 84,
        "education": 62,
        "lifestyle": 82,
        "private_healthcare": 70,
        "safety_security": 73,
        "climate_resilience_score": 0.957281553,
        "safety_and_security": 0.897834083,
        "total_business_opportunity": 0.986162716,
        "open_for_business": 1,
        "entrepreneurship": 0.815940367,
        "gdp_2021": 0.035345387,
        "gdp_per_capita": 0.537445333,
        "gdp_growth_annual_percentage_2021": 0.439108409,
        "haq": 0.957575758,
        "domestic_private_health_expenditure_per_capita": 1,
        "domestic_private_health_expenditure": 0.777685361,
        "global_health_security_index": 0.714524207,
        "insurance_companies_number": 0.07615894,
        "number_of_private_hospitals": 0.006581395,
        "health_care_system": 0.955,
        "health_care_index": 0.428293737,
        "insurance_companies_number_vs_population_density": 0.003045244,
        "number_of_private_hospitals_vs_population_density": 0.002131914,
        "land_area": 0.00241289,
        "innovation_index": 1,
        "number_of_universities_in_top_1000": 0.060773481,
        "number_of_top_tier_international_schools": 0.028139656,
        "education_index": 0.942028986,
        "quality_index": 0.806640625,
        "opportunity_index": 0.67364158,
        "school_enrollment_secondary": 0.124713243,
        "school_enrollment_primary": 0.05636252,
        "best_countries_for_education": 0.983,
        "economic_freedom_index": 0.997542998,
        "demographic_pressures_indicator": 0.16091954,
        "cost_of_living": 1,
        "happiness_index": 0.918003565,
        "human_development_index": 1,
        "standard_of_living_index_by_world_population_review": 0.930973189,
        "ccpi": 0.739380223,
        "population_density_per_km2": 0.008276862,
        "quality_of_life": 0.914893617
    },
    {
        "iso_code": "CAN",
        "country": "Canada",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 0, "eur" : 0}
        },
        "business_opportunity": 72,
        "climate_resilience": 68,
        "economic_freedom": 77,
        "education": 60,
        "lifestyle": 70,
        "private_healthcare": 65,
        "safety_security": 72,
        "climate_resilience_score": 0.955339806,
        "safety_and_security": 0.884756845,
        "total_business_opportunity": 0.836386932,
        "open_for_business": 0.919517758,
        "entrepreneurship": 0.852293578,
        "gdp_2021": 0.086567025,
        "gdp_per_capita": 0.298726635,
        "gdp_growth_annual_percentage_2021": 0.456737589,
        "haq": 0.893939394,
        "domestic_private_health_expenditure_per_capita": 0.229041515,
        "domestic_private_health_expenditure": 0.325451521,
        "global_health_security_index": 0.898163606,
        "insurance_companies_number": 0.054635762,
        "number_of_private_hospitals": 0.001046512,
        "health_care_system": 0.959,
        "health_care_index": 0.350323974,
        "insurance_companies_number_vs_population_density": 0.112238979,
        "number_of_private_hospitals_vs_population_density": 0.017435423,
        "land_area": 0.547454416,
        "innovation_index": 0.754455446,
        "number_of_universities_in_top_1000": 0.165745856,
        "number_of_top_tier_international_schools": 0.199062012,
        "education_index": 0.927536232,
        "quality_index": 0.8359375,
        "opportunity_index": 0.703678704,
        "school_enrollment_secondary": 0.086131387,
        "school_enrollment_primary": 0.063829787,
        "best_countries_for_education": 0.978,
        "economic_freedom_index": 0.904176904,
        "demographic_pressures_indicator": 0.022988506,
        "cost_of_living": 0.516240188,
        "happiness_index": 0.848484849,
        "human_development_index": 0.947368421,
        "standard_of_living_index_by_world_population_review": 0.870241446,
        "ccpi": 0.118384401,
        "population_density_per_km2": 0.0000809,
        "quality_of_life": 1
    },
    {
        "iso_code": "FRA",
        "country": "France",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 58,
        "climate_resilience": 68,
        "economic_freedom": 66,
        "education": 62,
        "lifestyle": 64,
        "private_healthcare": 64,
        "safety_security": 62,
        "climate_resilience_score": 0.953398058,
        "safety_and_security": 0.677973028,
        "total_business_opportunity": 0.671236387,
        "open_for_business": 0.640273705,
        "entrepreneurship": 0.698623853,
        "gdp_2021": 0.127735473,
        "gdp_per_capita": 0.249532391,
        "gdp_growth_annual_percentage_2021": 0.505369808,
        "haq": 0.898484849,
        "domestic_private_health_expenditure_per_capita": 0.168491221,
        "domestic_private_health_expenditure": 0.264377376,
        "global_health_security_index": 0.766277129,
        "insurance_companies_number": 0.471854305,
        "number_of_private_hospitals": 0.023534884,
        "health_care_system": 0.691,
        "health_care_index": 0.71187905,
        "insurance_companies_number_vs_population_density": 0.03349768,
        "number_of_private_hospitals_vs_population_density": 0.01356823,
        "land_area": 0.033434751,
        "innovation_index": 0.792079208,
        "number_of_universities_in_top_1000": 0.220994475,
        "number_of_top_tier_international_schools": 0.012506514,
        "education_index": 0.826086957,
        "quality_index": 0.837890625,
        "opportunity_index": 0.882213972,
        "school_enrollment_secondary": 0.261835245,
        "school_enrollment_primary": 0.153948445,
        "best_countries_for_education": 0.921,
        "economic_freedom_index": 0.772727273,
        "demographic_pressures_indicator": 0.24137931,
        "cost_of_living": 0.431550192,
        "happiness_index": 0.798573975,
        "human_development_index": 0.894736842,
        "standard_of_living_index_by_world_population_review": 0.89660791,
        "ccpi": 0.727367688,
        "population_density_per_km2": 0.004599607,
        "quality_of_life": 0.583951368
    },
    {
        "iso_code": "JPN",
        "country": "Japan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 62,
        "climate_resilience": 68,
        "economic_freedom": 70,
        "education": 58,
        "lifestyle": 71,
        "private_healthcare": 69,
        "safety_security": 73,
        "climate_resilience_score": 0.94368932,
        "safety_and_security": 0.90641602,
        "total_business_opportunity": 0.572325432,
        "open_for_business": 0.6419029,
        "entrepreneurship": 0.999885321,
        "gdp_2021": 0.214704769,
        "gdp_per_capita": 0.225125668,
        "gdp_growth_annual_percentage_2021": 0.397163121,
        "haq": 0.915151515,
        "domestic_private_health_expenditure_per_capita": 0.106739466,
        "domestic_private_health_expenditure": 0.162785171,
        "global_health_security_index": 0.742904841,
        "insurance_companies_number": 0.089403974,
        "number_of_private_hospitals": 0.194697674,
        "health_care_system": 0.874,
        "health_care_index": 0.827429806,
        "insurance_companies_number_vs_population_density": 0.002320186,
        "number_of_private_hospitals_vs_population_density": 0.040126262,
        "land_area": 0.022256974,
        "innovation_index": 0.782178218,
        "number_of_universities_in_top_1000": 0.138121547,
        "number_of_top_tier_international_schools": 0.052110474,
        "education_index": 0.869565217,
        "quality_index": 0.8046875,
        "opportunity_index": 0.651366858,
        "school_enrollment_secondary": 0.215015641,
        "school_enrollment_primary": 0.012172668,
        "best_countries_for_education": 0.929,
        "economic_freedom_index": 0.821867322,
        "demographic_pressures_indicator": 0.563218391,
        "cost_of_living": 0.443134272,
        "happiness_index": 0.696969697,
        "human_development_index": 0.929824561,
        "standard_of_living_index_by_world_population_review": 0.884017183,
        "ccpi": 0.510097493,
        "population_density_per_km2": 0.01301203,
        "quality_of_life": 0.716474164
    },
    {
        "iso_code": "AUS",
        "country": "Australia",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 1672100, "eur" : 1551400}
        },
        "business_opportunity": 64,
        "climate_resilience": 68,
        "economic_freedom": 78,
        "education": 67,
        "lifestyle": 74,
        "private_healthcare": 74,
        "safety_security": 69,
        "climate_resilience_score": 0.939805825,
        "safety_and_security": 0.812832039,
        "total_business_opportunity": 0.776553491,
        "open_for_business": 0.797002281,
        "entrepreneurship": 0.7125,
        "gdp_2021": 0.067080985,
        "gdp_per_capita": 0.344173258,
        "gdp_growth_annual_percentage_2021": 0.394326241,
        "haq": 0.927272727,
        "domestic_private_health_expenditure_per_capita": 0.233751304,
        "domestic_private_health_expenditure": 0.307509506,
        "global_health_security_index": 0.919866444,
        "insurance_companies_number": 0.061258278,
        "number_of_private_hospitals": 0.013976744,
        "health_care_system": 0.835,
        "health_care_index": 0.76825054,
        "insurance_companies_number_vs_population_density": 0.160382831,
        "number_of_private_hospitals_vs_population_density": 0.296831876,
        "land_area": 0.469688028,
        "innovation_index": 0.659405941,
        "number_of_universities_in_top_1000": 0.20441989,
        "number_of_top_tier_international_schools": 0.107347577,
        "education_index": 0.971014493,
        "quality_index": 0.849609375,
        "opportunity_index": 0.923388458,
        "school_enrollment_secondary": 0.549217935,
        "school_enrollment_primary": 0.303805237,
        "best_countries_for_education": 0.91,
        "economic_freedom_index": 0.917690418,
        "demographic_pressures_indicator": 0.275862069,
        "cost_of_living": 0.567156541,
        "happiness_index": 0.878787879,
        "human_development_index": 0.964912281,
        "standard_of_living_index_by_world_population_review": 0.839579322,
        "ccpi": 0.188544568,
        "population_density_per_km2": 0.0000459,
        "quality_of_life": 0.905775076
    },
    {
        "iso_code": "KOR",
        "country": "South Korea",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 60,
        "climate_resilience": 67,
        "economic_freedom": 75,
        "education": 56,
        "lifestyle": 57,
        "private_healthcare": 68,
        "safety_security": 64,
        "climate_resilience_score": 0.922330097,
        "safety_and_security": 0.725378014,
        "total_business_opportunity": 0.686867393,
        "open_for_business": 0.598566308,
        "entrepreneurship": 0.858256881,
        "gdp_2021": 0.078207859,
        "gdp_per_capita": 0.1990236,
        "gdp_growth_annual_percentage_2021": 0.445795339,
        "haq": 0.866666667,
        "domestic_private_health_expenditure_per_capita": 0.161364787,
        "domestic_private_health_expenditure": 0.451877376,
        "global_health_security_index": 0.824707846,
        "insurance_companies_number": 0.03807947,
        "number_of_private_hospitals": 0.070883721,
        "health_care_system": 0.557,
        "health_care_index": 1,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.009486192,
        "land_area": 0.005954713,
        "innovation_index": 0.877227723,
        "number_of_universities_in_top_1000": 0.20441989,
        "number_of_top_tier_international_schools": 0.012506514,
        "education_index": 0.898550725,
        "quality_index": 0.74609375,
        "opportunity_index": 0.450219372,
        "school_enrollment_secondary": 0.319708029,
        "school_enrollment_primary": 0.015855155,
        "best_countries_for_education": 0.74,
        "economic_freedom_index": 0.87960688,
        "demographic_pressures_indicator": 0.172413793,
        "cost_of_living": 0.248798368,
        "happiness_index": 0.700534759,
        "human_development_index": 0.929824561,
        "standard_of_living_index_by_world_population_review": 0.860909495,
        "ccpi": 0.130745125,
        "population_density_per_km2": 0.020067318,
        "quality_of_life": 0.491671733
    },
    {
        "iso_code": "NOR",
        "country": "Norway",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 70,
        "climate_resilience": 64,
        "economic_freedom": 77,
        "education": 53,
        "lifestyle": 75,
        "private_healthcare": 64,
        "safety_security": 71,
        "climate_resilience_score": 0.873786408,
        "safety_and_security": 0.853698406,
        "total_business_opportunity": 0.909801409,
        "open_for_business": 0.911697621,
        "entrepreneurship": 0.645756881,
        "gdp_2021": 0.020976394,
        "gdp_per_capita": 0.512915751,
        "gdp_growth_annual_percentage_2021": 0.443768997,
        "haq": 0.937878788,
        "domestic_private_health_expenditure_per_capita": 0.172533193,
        "domestic_private_health_expenditure": 0.139496198,
        "global_health_security_index": 0.737896494,
        "insurance_companies_number": 0.125827815,
        "number_of_private_hospitals": 0.000255814,
        "health_care_system": 0.912,
        "health_care_index": 0.52462203,
        "insurance_companies_number_vs_population_density": 0.074390951,
        "number_of_private_hospitals_vs_population_density": 0.001222959,
        "land_area": 0.02229409,
        "innovation_index": 0.700990099,
        "number_of_universities_in_top_1000": 0.033149171,
        "number_of_top_tier_international_schools": 0.022407504,
        "education_index": 0.985507246,
        "quality_index": 0.7421875,
        "opportunity_index": 0.44718191,
        "school_enrollment_secondary": 0.074244004,
        "school_enrollment_primary": 0.035085925,
        "best_countries_for_education": 0.946,
        "economic_freedom_index": 0.907862408,
        "demographic_pressures_indicator": 0.045977011,
        "cost_of_living": 0.655451433,
        "happiness_index": 0.923351159,
        "human_development_index": 1,
        "standard_of_living_index_by_world_population_review": 0.965782847,
        "ccpi": 0.941155989,
        "population_density_per_km2": 0.000481111,
        "quality_of_life": 0.920851064
    },
    {
        "iso_code": "LUX",
        "country": "Luxembourg",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 538900, "eur" : 500000}
        },
        "business_opportunity": 48,
        "climate_resilience": 63,
        "economic_freedom": 81,
        "education": 41,
        "lifestyle": 59,
        "private_healthcare": 38,
        "safety_security": 65,
        "climate_resilience_score": 0.858252427,
        "safety_and_security": 0.729668982,
        "total_business_opportunity": 0.843305573,
        "open_for_business": 0.507983056,
        "entrepreneurship": 0.136651376,
        "gdp_2021": 0.003767941,
        "gdp_per_capita": 0.780887314,
        "gdp_growth_annual_percentage_2021": 0.503951368,
        "haq": 0.91969697,
        "domestic_private_health_expenditure_per_capita": 0.120804796,
        "domestic_private_health_expenditure": 0.123098859,
        "global_health_security_index": 0.540901503,
        "insurance_companies_number": 0.122516556,
        "number_of_private_hospitals": 0,
        "health_care_system": 0.0648,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.004060325,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.000148353,
        "innovation_index": 0.673267327,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.811594203,
        "quality_index": 0.720703125,
        "opportunity_index": 0.419844752,
        "school_enrollment_secondary": 0.195099062,
        "school_enrollment_primary": 0.124590835,
        "best_countries_for_education": 0.0624,
        "economic_freedom_index": 0.953316953,
        "demographic_pressures_indicator": 0.183908046,
        "cost_of_living": 0.53788167,
        "happiness_index": 0.930481283,
        "human_development_index": 0.929824561,
        "standard_of_living_index_by_world_population_review": 0.792919568,
        "ccpi": 0.723711699,
        "population_density_per_km2": 0.009905122,
        "quality_of_life": 0.140279635
    },
    {
        "iso_code": "NLD",
        "country": "Netherlands",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 70,
        "climate_resilience": 62,
        "economic_freedom": 80,
        "education": 62,
        "lifestyle": 76,
        "private_healthcare": 69,
        "safety_security": 70,
        "climate_resilience_score": 0.831067961,
        "safety_and_security": 0.830404577,
        "total_business_opportunity": 0.926841768,
        "open_for_business": 0.849136527,
        "entrepreneurship": 0.726834862,
        "gdp_2021": 0.04426606,
        "gdp_per_capita": 0.333374094,
        "gdp_growth_annual_percentage_2021": 0.466464032,
        "haq": 0.922727273,
        "domestic_private_health_expenditure_per_capita": 0.276595291,
        "domestic_private_health_expenditure": 0.375831749,
        "global_health_security_index": 0.813021703,
        "insurance_companies_number": 0.099337748,
        "number_of_private_hospitals": 0.013209302,
        "health_care_system": 0.932,
        "health_care_index": 0.599136069,
        "insurance_companies_number_vs_population_density": 0.001740139,
        "number_of_private_hospitals_vs_population_density": 0.001801385,
        "land_area": 0.002055922,
        "innovation_index": 0.863366337,
        "number_of_universities_in_top_1000": 0.071823204,
        "number_of_top_tier_international_schools": 0.016154247,
        "education_index": 0.956521739,
        "quality_index": 0.845703125,
        "opportunity_index": 0.912926088,
        "school_enrollment_secondary": 0.067153285,
        "school_enrollment_primary": 0.003784779,
        "best_countries_for_education": 0.928,
        "economic_freedom_index": 0.93980344,
        "demographic_pressures_indicator": 0.172413793,
        "cost_of_living": 0.698329818,
        "happiness_index": 0.914438503,
        "human_development_index": 0.964912281,
        "standard_of_living_index_by_world_population_review": 0.920456229,
        "ccpi": 0.71744429,
        "population_density_per_km2": 0.019692529,
        "quality_of_life": 0.890942249
    },
    {
        "iso_code": "ITA",
        "country": "Italy",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 269500, "eur" : 250000}
        },
        "business_opportunity": 48,
        "climate_resilience": 62,
        "economic_freedom": 65,
        "education": 41,
        "lifestyle": 64,
        "private_healthcare": 46,
        "safety_security": 67,
        "climate_resilience_score": 0.823300971,
        "safety_and_security": 0.780956273,
        "total_business_opportunity": 0.551953876,
        "open_for_business": 0.596611274,
        "entrepreneurship": 0.518922018,
        "gdp_2021": 0.091312129,
        "gdp_per_capita": 0.203598714,
        "gdp_growth_annual_percentage_2021": 0.498885512,
        "haq": 0.910606061,
        "domestic_private_health_expenditure_per_capita": 0.114949959,
        "domestic_private_health_expenditure": 0.280893536,
        "global_health_security_index": 0.59933222,
        "insurance_companies_number": 0.319536424,
        "number_of_private_hospitals": 0.011093023,
        "health_care_system": 0.422,
        "health_care_index": 0.259395248,
        "insurance_companies_number_vs_population_density": 0.014066125,
        "number_of_private_hospitals_vs_population_density": 0.003966352,
        "land_area": 0.018179882,
        "innovation_index": 0.607920792,
        "number_of_universities_in_top_1000": 0.270718232,
        "number_of_top_tier_international_schools": 0.019280875,
        "education_index": 0.782608696,
        "quality_index": 0.583984375,
        "opportunity_index": 0.201484981,
        "school_enrollment_secondary": 0.071428571,
        "school_enrollment_primary": 0.061170213,
        "best_countries_for_education": 0.501,
        "economic_freedom_index": 0.766584767,
        "demographic_pressures_indicator": 0.413793103,
        "cost_of_living": 0.499925654,
        "happiness_index": 0.764705882,
        "human_development_index": 0.877192983,
        "standard_of_living_index_by_world_population_review": 0.819137906,
        "ccpi": 0.629526462,
        "population_density_per_km2": 0.0074521,
        "quality_of_life": 0.442431611
    },
    {
        "iso_code": "SWE",
        "country": "Sweden",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 73,
        "climate_resilience": 61,
        "economic_freedom": 78,
        "education": 66,
        "lifestyle": 75,
        "private_healthcare": 63,
        "safety_security": 69,
        "climate_resilience_score": 0.815533981,
        "safety_and_security": 0.813240703,
        "total_business_opportunity": 0.970659833,
        "open_for_business": 0.917888563,
        "entrepreneurship": 0.758600917,
        "gdp_2021": 0.027281866,
        "gdp_per_capita": 0.345930869,
        "gdp_growth_annual_percentage_2021": 0.461600811,
        "haq": 0.937878788,
        "domestic_private_health_expenditure_per_capita": 0.130117646,
        "domestic_private_health_expenditure": 0.150665399,
        "global_health_security_index": 0.816360601,
        "insurance_companies_number": 0.529801325,
        "number_of_private_hospitals": 0.000348837,
        "health_care_system": 1,
        "health_care_index": 0.298488121,
        "insurance_companies_number_vs_population_density": 0.181409513,
        "number_of_private_hospitals_vs_population_density": 0.000975062,
        "land_area": 0.024871027,
        "innovation_index": 0.952475248,
        "number_of_universities_in_top_1000": 0.066298343,
        "number_of_top_tier_international_schools": 0.019280875,
        "education_index": 0.971014493,
        "quality_index": 0.841796875,
        "opportunity_index": 0.904488694,
        "school_enrollment_secondary": 0.185922836,
        "school_enrollment_primary": 0.108121931,
        "best_countries_for_education": 1,
        "economic_freedom_index": 0.92014742,
        "demographic_pressures_indicator": 0.229885058,
        "cost_of_living": 0.431031502,
        "happiness_index": 0.937611408,
        "human_development_index": 0.98245614,
        "standard_of_living_index_by_world_population_review": 0.956895275,
        "ccpi": 0.957346797,
        "population_density_per_km2": 0.000889695,
        "quality_of_life": 0.939452888
    },
    {
        "iso_code": "DNK",
        "country": "Denmark",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 73,
        "climate_resilience": 60,
        "economic_freedom": 78,
        "education": 62,
        "lifestyle": 76,
        "private_healthcare": 73,
        "safety_security": 74,
        "climate_resilience_score": 0.796116505,
        "safety_and_security": 0.922762566,
        "total_business_opportunity": 1,
        "open_for_business": 0.932877159,
        "entrepreneurship": 0.713876147,
        "gdp_2021": 0.017265638,
        "gdp_per_capita": 0.389539974,
        "gdp_growth_annual_percentage_2021": 0.459371834,
        "haq": 0.865151515,
        "domestic_private_health_expenditure_per_capita": 0.15236755,
        "domestic_private_health_expenditure": 0.169557985,
        "global_health_security_index": 0.808013356,
        "insurance_companies_number": 0.009933775,
        "number_of_private_hospitals": 0.007418605,
        "health_care_system": 0.978,
        "health_care_index": 0.900431965,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.00360277,
        "land_area": 0.002442442,
        "innovation_index": 0.837623762,
        "number_of_universities_in_top_1000": 0.038674033,
        "number_of_top_tier_international_schools": 0.010422095,
        "education_index": 0.971014493,
        "quality_index": 0.8359375,
        "opportunity_index": 0.755315559,
        "school_enrollment_secondary": 0.162148071,
        "school_enrollment_primary": 0.174611293,
        "best_countries_for_education": 0.977,
        "economic_freedom_index": 0.921375921,
        "demographic_pressures_indicator": 0.149425287,
        "cost_of_living": 0.487741623,
        "happiness_index": 0.983957219,
        "human_development_index": 0.964912281,
        "standard_of_living_index_by_world_population_review": 0.986224263,
        "ccpi": 1,
        "population_density_per_km2": 0.00547867,
        "quality_of_life": 0.964620061
    },
    {
        "iso_code": "SGP",
        "country": "Singapore",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 7488800, "eur" : 6948300}
        },
        "business_opportunity": 71,
        "climate_resilience": 60,
        "economic_freedom": 84,
        "education": 52,
        "lifestyle": 64,
        "private_healthcare": 52,
        "safety_security": 73,
        "climate_resilience_score": 0.784466019,
        "safety_and_security": 0.910502656,
        "total_business_opportunity": 0.975784753,
        "open_for_business": 0.755620723,
        "entrepreneurship": 0.772133028,
        "gdp_2021": 0.017260531,
        "gdp_per_capita": 0.418314319,
        "gdp_growth_annual_percentage_2021": 0.518541033,
        "haq": 0.874242424,
        "domestic_private_health_expenditure_per_capita": 0.199306873,
        "domestic_private_health_expenditure": 0.562737643,
        "global_health_security_index": 0.69115192,
        "insurance_companies_number": 0.054635762,
        "number_of_private_hospitals": 0.000186047,
        "health_care_system": 0.479,
        "health_care_index": 0.348164147,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000433,
        "innovation_index": 0.847524753,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.020323085,
        "education_index": 0.971014493,
        "quality_index": 0.76171875,
        "opportunity_index": 0.508268647,
        "school_enrollment_secondary": 0.052971846,
        "school_enrollment_primary": 0.040507365,
        "best_countries_for_education": 0.578,
        "economic_freedom_index": 1,
        "demographic_pressures_indicator": 0.149425287,
        "cost_of_living": 0.507688717,
        "happiness_index": 0.786096257,
        "human_development_index": 0.964912281,
        "standard_of_living_index_by_world_population_review": 0.830839876,
        "ccpi": 0.54178273,
        "population_density_per_km2": 0.291999654,
        "quality_of_life": 0.572644377
    },
    {
        "iso_code": "IRL",
        "country": "Ireland",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 534600, "eur" : 500000}
        },
        "business_opportunity": 66,
        "climate_resilience": 59,
        "economic_freedom": 82,
        "education": 48,
        "lifestyle": 68,
        "private_healthcare": 46,
        "safety_security": 74,
        "climate_resilience_score": 0.782524272,
        "safety_and_security": 0.926031876,
        "total_business_opportunity": 0.865727098,
        "open_for_business": 0.857934181,
        "entrepreneurship": 0.500688073,
        "gdp_2021": 0.021677495,
        "gdp_per_capita": 0.570276779,
        "gdp_growth_annual_percentage_2021": 0.637487335,
        "haq": 0.906060606,
        "domestic_private_health_expenditure_per_capita": 0.209830332,
        "domestic_private_health_expenditure": 0.273051331,
        "global_health_security_index": 0.656093489,
        "insurance_companies_number": 0.332781457,
        "number_of_private_hospitals": 0.000418605,
        "health_care_system": 0.593,
        "health_care_index": 0.026565875,
        "insurance_companies_number_vs_population_density": 0.03987819,
        "number_of_private_hospitals_vs_population_density": 0.000413162,
        "land_area": 0.004206516,
        "innovation_index": 0.706930693,
        "number_of_universities_in_top_1000": 0.049723757,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.971014493,
        "quality_index": 0.6953125,
        "opportunity_index": 0.362807965,
        "school_enrollment_secondary": 0.001251303,
        "school_enrollment_primary": 0.00613748,
        "best_countries_for_education": 0.72,
        "economic_freedom_index": 0.970515971,
        "demographic_pressures_indicator": 0.206896552,
        "cost_of_living": 0.565455237,
        "happiness_index": 0.828877005,
        "human_development_index": 1,
        "standard_of_living_index_by_world_population_review": 0.83261739,
        "ccpi": 0.498433148,
        "population_density_per_km2": 0.00269035,
        "quality_of_life": 0.66006079
    },
    {
        "iso_code": "AUT",
        "country": "Austria",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 0, "eur" : 0}
        },
        "business_opportunity": 61,
        "climate_resilience": 59,
        "economic_freedom": 74,
        "education": 47,
        "lifestyle": 70,
        "private_healthcare": 66,
        "safety_security": 74,
        "climate_resilience_score": 0.774757282,
        "safety_and_security": 0.921127912,
        "total_business_opportunity": 0.74913517,
        "open_for_business": 0.798957315,
        "entrepreneurship": 0.637729358,
        "gdp_2021": 0.020743547,
        "gdp_per_capita": 0.305740588,
        "gdp_growth_annual_percentage_2021": 0.455116515,
        "haq": 0.903030303,
        "domestic_private_health_expenditure_per_capita": 0.215154574,
        "domestic_private_health_expenditure": 0.291706274,
        "global_health_security_index": 0.682804675,
        "insurance_companies_number": 0.178807947,
        "number_of_private_hospitals": 0.000813953,
        "health_care_system": 0.749,
        "health_care_index": 0.840172786,
        "insurance_companies_number_vs_population_density": 0.01450116,
        "number_of_private_hospitals_vs_population_density": 0.000528847,
        "land_area": 0.005038787,
        "innovation_index": 0.710891089,
        "number_of_universities_in_top_1000": 0.060773481,
        "number_of_top_tier_international_schools": 0.009379885,
        "education_index": 0.898550725,
        "quality_index": 0.591796875,
        "opportunity_index": 0.205534931,
        "school_enrollment_secondary": 0.108967675,
        "school_enrollment_primary": 0.06403437,
        "best_countries_for_education": 0.845,
        "economic_freedom_index": 0.86977887,
        "demographic_pressures_indicator": 0.298850575,
        "cost_of_living": 0.464097998,
        "happiness_index": 0.873440285,
        "human_development_index": 0.929824561,
        "standard_of_living_index_by_world_population_review": 0.843874982,
        "ccpi": 0.576601671,
        "population_density_per_km2": 0.004039892,
        "quality_of_life": 0.764255319
    },
    {
        "iso_code": "ESP",
        "country": "Spain",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 538900, "eur" : 500000}
        },
        "business_opportunity": 47,
        "climate_resilience": 59,
        "economic_freedom": 68,
        "education": 47,
        "lifestyle": 61,
        "private_healthcare": 57,
        "safety_security": 68,
        "climate_resilience_score": 0.768932039,
        "safety_and_security": 0.79730282,
        "total_business_opportunity": 0.566688021,
        "open_for_business": 0.63506028,
        "entrepreneurship": 0.445412844,
        "gdp_2021": 0.061976483,
        "gdp_per_capita": 0.172261001,
        "gdp_growth_annual_percentage_2021": 0.468287741,
        "haq": 0.924242424,
        "domestic_private_health_expenditure_per_capita": 0.120864259,
        "domestic_private_health_expenditure": 0.320104563,
        "global_health_security_index": 0.749582638,
        "insurance_companies_number": 0.342715232,
        "number_of_private_hospitals": 0.010488372,
        "health_care_system": 0.341,
        "health_care_index": 0.696328294,
        "insurance_companies_number_vs_population_density": 0.031757541,
        "number_of_private_hospitals_vs_population_density": 0.007866598,
        "land_area": 0.030506626,
        "innovation_index": 0.601980198,
        "number_of_universities_in_top_1000": 0.276243094,
        "number_of_top_tier_international_schools": 0.087545597,
        "education_index": 0.84057971,
        "quality_index": 0.568359375,
        "opportunity_index": 0.187310159,
        "school_enrollment_secondary": 0.314285714,
        "school_enrollment_primary": 0.322013093,
        "best_countries_for_education": 0.54,
        "economic_freedom_index": 0.800982801,
        "demographic_pressures_indicator": 0.264367816,
        "cost_of_living": 0.411345482,
        "happiness_index": 0.764705882,
        "human_development_index": 0.894736842,
        "standard_of_living_index_by_world_population_review": 0.830543623,
        "ccpi": 0.611420613,
        "population_density_per_km2": 0.003515872,
        "quality_of_life": 0.476595745
    },
    {
        "iso_code": "FIN",
        "country": "Finland",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 66,
        "climate_resilience": 59,
        "economic_freedom": 78,
        "education": 58,
        "lifestyle": 80,
        "private_healthcare": 68,
        "safety_security": 71,
        "climate_resilience_score": 0.766990291,
        "safety_and_security": 0.864323662,
        "total_business_opportunity": 0.910826393,
        "open_for_business": 0.879439557,
        "entrepreneurship": 0.605848624,
        "gdp_2021": 0.013006247,
        "gdp_per_capita": 0.309860936,
        "gdp_growth_annual_percentage_2021": 0.434650456,
        "haq": 0.924242424,
        "domestic_private_health_expenditure_per_capita": 0.133943111,
        "domestic_private_health_expenditure": 0.206630228,
        "global_health_security_index": 0.916527546,
        "insurance_companies_number": 0.074503311,
        "number_of_private_hospitals": 0.000837209,
        "health_care_system": 0.884,
        "health_care_index": 0.587041037,
        "insurance_companies_number_vs_population_density": 0.035817865,
        "number_of_private_hospitals_vs_population_density": 0.003255714,
        "land_area": 0.018557854,
        "innovation_index": 0.859405941,
        "number_of_universities_in_top_1000": 0.060773481,
        "number_of_top_tier_international_schools": 0.00990099,
        "education_index": 0.985507246,
        "quality_index": 0.77734375,
        "opportunity_index": 0.557543031,
        "school_enrollment_secondary": 0.152346194,
        "school_enrollment_primary": 0.018821604,
        "best_countries_for_education": 0.921,
        "economic_freedom_index": 0.925061425,
        "demographic_pressures_indicator": 0.08045977,
        "cost_of_living": 0.902002144,
        "happiness_index": 1,
        "human_development_index": 0.964912281,
        "standard_of_living_index_by_world_population_review": 1,
        "ccpi": 0.751740947,
        "population_density_per_km2": 0.000610977,
        "quality_of_life": 0.856899696
    },
    {
        "iso_code": "RUS",
        "country": "Russian Federation",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 57,
        "economic_freedom": 56,
        "education": 35,
        "lifestyle": 51,
        "private_healthcare": 43,
        "safety_security": 35,
        "climate_resilience_score": 0.737864078,
        "safety_and_security": 0.114017164,
        "total_business_opportunity": 0.549186419,
        "open_for_business": 0,
        "entrepreneurship": 0.481307339,
        "gdp_2021": 0.077219254,
        "gdp_per_capita": 0.068814611,
        "gdp_growth_annual_percentage_2021": 0.462006079,
        "haq": 0.653030303,
        "domestic_private_health_expenditure_per_capita": 0.038115901,
        "domestic_private_health_expenditure": 0.432628327,
        "global_health_security_index": 0.552587646,
        "insurance_companies_number": 1,
        "number_of_private_hospitals": 0.123255814,
        "health_care_system": 0.219,
        "health_care_index": 0.115334773,
        "insurance_companies_number_vs_population_density": 1,
        "number_of_private_hospitals_vs_population_density": 1,
        "land_area": 1,
        "innovation_index": 0.427722772,
        "number_of_universities_in_top_1000": 0.099447514,
        "number_of_top_tier_international_schools": 0.026055237,
        "education_index": 0.826086957,
        "quality_index": 0.619140625,
        "opportunity_index": 0.233547081,
        "school_enrollment_secondary": 0.012721585,
        "school_enrollment_primary": 0.008387889,
        "best_countries_for_education": 0.321,
        "economic_freedom_index": 0.652334152,
        "demographic_pressures_indicator": 0.436781609,
        "cost_of_living": 0.311041184,
        "happiness_index": 0.582887701,
        "human_development_index": 0.754385965,
        "standard_of_living_index_by_world_population_review": 0.748185454,
        "ccpi": 0.269846797,
        "population_density_per_km2": 0.000251378,
        "quality_of_life": 0.237933131
    },
    {
        "iso_code": "CHN",
        "country": "China",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 63,
        "climate_resilience": 56,
        "economic_freedom": 48,
        "education": 40,
        "lifestyle": 56,
        "private_healthcare": 35,
        "safety_security": 60,
        "climate_resilience_score": 0.722330097,
        "safety_and_security": 0.630976706,
        "total_business_opportunity": 0.794234465,
        "open_for_business": 0.517106549,
        "entrepreneurship": 0.743119266,
        "gdp_2021": 0.771176339,
        "gdp_per_capita": 0.071025836,
        "gdp_growth_annual_percentage_2021": 0.528672746,
        "haq": 0.690909091,
        "domestic_private_health_expenditure_per_capita": 0.03533028,
        "domestic_private_health_expenditure": 0.494058935,
        "global_health_security_index": 0.525876461,
        "insurance_companies_number": 0.389072848,
        "number_of_private_hospitals": 0.241860465,
        "health_care_system": 0.194,
        "health_care_index": 0.193952484,
        "insurance_companies_number_vs_population_density": 0.022766821,
        "number_of_private_hospitals_vs_population_density": 0.114693682,
        "land_area": 0.575488644,
        "innovation_index": 0.788118812,
        "number_of_universities_in_top_1000": 0.403314917,
        "number_of_top_tier_international_schools": 0.137050547,
        "education_index": 0.594202899,
        "quality_index": 0.455078125,
        "opportunity_index": 0.113061087,
        "school_enrollment_secondary": 0.13274244,
        "school_enrollment_primary": 0.081730769,
        "best_countries_for_education": 0.39,
        "economic_freedom_index": 0.552825553,
        "demographic_pressures_indicator": 0.563218391,
        "cost_of_living": 0.335246724,
        "happiness_index": 0.65597148,
        "human_development_index": 0.649122807,
        "standard_of_living_index_by_world_population_review": 0.759146793,
        "ccpi": 0.573990251,
        "population_density_per_km2": 0.005609295,
        "quality_of_life": 0.404012158
    },
    {
        "iso_code": "NZL",
        "country": "New Zealand",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 3105600, "eur" : 2881200}
        },
        "business_opportunity": 60,
        "climate_resilience": 56,
        "economic_freedom": 81,
        "education": 50,
        "lifestyle": 68,
        "private_healthcare": 61,
        "safety_security": 75,
        "climate_resilience_score": 0.712621359,
        "safety_and_security": 0.933796486,
        "total_business_opportunity": 0.643049327,
        "open_for_business": 0.921146953,
        "entrepreneurship": 0.579243119,
        "gdp_2021": 0.010868325,
        "gdp_per_capita": 0.279991357,
        "gdp_growth_annual_percentage_2021": 0.458561297,
        "haq": 0.872727273,
        "domestic_private_health_expenditure_per_capita": 0.156319564,
        "domestic_private_health_expenditure": 0.261406844,
        "global_health_security_index": 0.776293823,
        "insurance_companies_number": 0.165562914,
        "number_of_private_hospitals": 0.001674419,
        "health_care_system": 0.8,
        "health_care_index": 0.484665227,
        "insurance_companies_number_vs_population_density": 0.074535963,
        "number_of_private_hospitals_vs_population_density": 0.006114793,
        "land_area": 0.016078137,
        "innovation_index": 0.643564356,
        "number_of_universities_in_top_1000": 0.044198895,
        "number_of_top_tier_international_schools": 0.014069828,
        "education_index": 0.985507246,
        "quality_index": 0.7109375,
        "opportunity_index": 0.391832602,
        "school_enrollment_secondary": 0.094369135,
        "school_enrollment_primary": 0.019435352,
        "best_countries_for_education": 0.843,
        "economic_freedom_index": 0.953316953,
        "demographic_pressures_indicator": 0,
        "cost_of_living": 0.564597669,
        "happiness_index": 0.884135472,
        "human_development_index": 0.947368421,
        "standard_of_living_index_by_world_population_review": 0.806843431,
        "ccpi": 0.605849582,
        "population_density_per_km2": 0.000657304,
        "quality_of_life": 0.852279635
    },
    {
        "iso_code": "ISL",
        "country": "Iceland",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 42,
        "climate_resilience": 56,
        "economic_freedom": 77,
        "education": 42,
        "lifestyle": 59,
        "private_healthcare": 38,
        "safety_security": 78,
        "climate_resilience_score": 0.712621359,
        "safety_and_security": 1,
        "total_business_opportunity": 0.812684177,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.001104357,
        "gdp_per_capita": 0.392888002,
        "gdp_growth_annual_percentage_2021": 0.439311044,
        "haq": 0.984848485,
        "domestic_private_health_expenditure_per_capita": 0.163122763,
        "domestic_private_health_expenditure": 0.174310837,
        "global_health_security_index": 0.542570952,
        "insurance_companies_number": 0.018211921,
        "number_of_private_hospitals": 0,
        "health_care_system": 0.0696,
        "health_care_index": 0.217710583,
        "insurance_companies_number_vs_population_density": 0.043213457,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.006156827,
        "innovation_index": 0.728712871,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.985507246,
        "quality_index": 0.6875,
        "opportunity_index": 0.348633142,
        "school_enrollment_secondary": 0.147653806,
        "school_enrollment_primary": 0.028436989,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.909090909,
        "demographic_pressures_indicator": 0.057471264,
        "cost_of_living": 0.605311387,
        "happiness_index": 0.959001783,
        "human_development_index": 0.98245614,
        "standard_of_living_index_by_world_population_review": 0.791142053,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.0000589,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "BEL",
        "country": "Belgium",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 61,
        "climate_resilience": 54,
        "economic_freedom": 70,
        "education": 59,
        "lifestyle": 71,
        "private_healthcare": 64,
        "safety_security": 69,
        "climate_resilience_score": 0.683495146,
        "safety_and_security": 0.828769922,
        "total_business_opportunity": 0.742088405,
        "open_for_business": 0.80058651,
        "entrepreneurship": 0.61353211,
        "gdp_2021": 0.026083448,
        "gdp_per_capita": 0.297091825,
        "gdp_growth_annual_percentage_2021": 0.490780142,
        "haq": 0.898484849,
        "domestic_private_health_expenditure_per_capita": 0.175050468,
        "domestic_private_health_expenditure": 0.246910646,
        "global_health_security_index": 0.722871452,
        "insurance_companies_number": 0.170529801,
        "number_of_private_hospitals": 0.002372093,
        "health_care_system": 0.757,
        "health_care_index": 0.695680346,
        "insurance_companies_number_vs_population_density": 0.003915313,
        "number_of_private_hospitals_vs_population_density": 0.000446215,
        "land_area": 0.001848922,
        "innovation_index": 0.677227723,
        "number_of_universities_in_top_1000": 0.049723757,
        "number_of_top_tier_international_schools": 0.006253257,
        "education_index": 0.942028986,
        "quality_index": 0.7265625,
        "opportunity_index": 0.434019575,
        "school_enrollment_secondary": 0.611783107,
        "school_enrollment_primary": 0.554623568,
        "best_countries_for_education": 0.803,
        "economic_freedom_index": 0.818181818,
        "demographic_pressures_indicator": 0.367816092,
        "cost_of_living": 0.402849338,
        "happiness_index": 0.830659537,
        "human_development_index": 0.947368421,
        "standard_of_living_index_by_world_population_review": 0.962524071,
        "ccpi": 0.464310585,
        "population_density_per_km2": 0.014450428,
        "quality_of_life": 0.732765957
    },
    {
        "iso_code": "ISR",
        "country": "Israel",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 46,
        "climate_resilience": 51,
        "economic_freedom": 68,
        "education": 51,
        "lifestyle": 65,
        "private_healthcare": 48,
        "safety_security": 48,
        "climate_resilience_score": 0.619417476,
        "safety_and_security": 0.399673069,
        "total_business_opportunity": 0.700960923,
        "open_for_business": 0.397523623,
        "entrepreneurship": 0.459747706,
        "gdp_2021": 0.020939615,
        "gdp_per_capita": 0.295144824,
        "gdp_growth_annual_percentage_2021": 0.53029382,
        "haq": 0.862121212,
        "domestic_private_health_expenditure_per_capita": 0.174041118,
        "domestic_private_health_expenditure": 0.364781369,
        "global_health_security_index": 0.520868114,
        "insurance_companies_number": 0.009933775,
        "number_of_private_hospitals": 0.004232558,
        "health_care_system": 0.514,
        "health_care_index": 0.382937365,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0.000694112,
        "land_area": 0.001321349,
        "innovation_index": 0.76039604,
        "number_of_universities_in_top_1000": 0.038674033,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.913043478,
        "quality_index": 0.779296875,
        "opportunity_index": 0.568342896,
        "school_enrollment_secondary": 0.125234619,
        "school_enrollment_primary": 0.23762275,
        "best_countries_for_education": 0.444,
        "economic_freedom_index": 0.798525799,
        "demographic_pressures_indicator": 0.436781609,
        "cost_of_living": 0.579031087,
        "happiness_index": 0.962566845,
        "human_development_index": 0.929824561,
        "standard_of_living_index_by_world_population_review": 0.783291364,
        "ccpi": 0.462848189,
        "population_density_per_km2": 0.016350191,
        "quality_of_life": 0.209483283
    },
    {
        "iso_code": "ARE",
        "country": "United Arab Emirates",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 0, "eur" : 0}
        },
        "business_opportunity": 52,
        "climate_resilience": 50,
        "economic_freedom": 70,
        "education": 38,
        "lifestyle": 60,
        "private_healthcare": 38,
        "safety_security": 63,
        "climate_resilience_score": 0.59223301,
        "safety_and_security": 0.690232938,
        "total_business_opportunity": 0.854836643,
        "open_for_business": 0.440534376,
        "entrepreneurship": 0.530389908,
        "gdp_2021": 0.007541218,
        "gdp_per_capita": 0.166526633,
        "gdp_growth_annual_percentage_2021": 0.549017224,
        "haq": 0.660606061,
        "domestic_private_health_expenditure_per_capita": 0.133435386,
        "domestic_private_health_expenditure": 0.537785171,
        "global_health_security_index": 0.393989983,
        "insurance_companies_number": 0.102649007,
        "number_of_private_hospitals": 0.001046512,
        "health_care_system": 0.23,
        "health_care_index": 0.422678186,
        "insurance_companies_number_vs_population_density": 0.00638051,
        "number_of_private_hospitals_vs_population_density": 0.000528847,
        "land_area": 0.004336577,
        "innovation_index": 0.554455446,
        "number_of_universities_in_top_1000": 0.027624309,
        "number_of_top_tier_international_schools": 0.027618551,
        "education_index": 0.797101449,
        "quality_index": 0.72265625,
        "opportunity_index": 0.431319609,
        "school_enrollment_secondary": 0.056704901,
        "school_enrollment_primary": 0.047217676,
        "best_countries_for_education": 0.147,
        "economic_freedom_index": 0.825552826,
        "demographic_pressures_indicator": 0.298850575,
        "cost_of_living": 0.472872506,
        "happiness_index": 0.811051693,
        "human_development_index": 0.877192983,
        "standard_of_living_index_by_world_population_review": 0.773811287,
        "ccpi": 0.512465181,
        "population_density_per_km2": 0.005260708,
        "quality_of_life": 0.342492401
    },
    {
        "iso_code": "POL",
        "country": "Poland",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 36,
        "climate_resilience": 49,
        "economic_freedom": 69,
        "education": 40,
        "lifestyle": 52,
        "private_healthcare": 38,
        "safety_security": 69,
        "climate_resilience_score": 0.586407767,
        "safety_and_security": 0.818144667,
        "total_business_opportunity": 0.40256246,
        "open_for_business": 0.57445422,
        "entrepreneurship": 0.244036697,
        "gdp_2021": 0.029308753,
        "gdp_per_capita": 0.101493104,
        "gdp_growth_annual_percentage_2021": 0.480445795,
        "haq": 0.772727273,
        "domestic_private_health_expenditure_per_capita": 0.043569743,
        "domestic_private_health_expenditure": 0.310361217,
        "global_health_security_index": 0.662771286,
        "insurance_companies_number": 0.097682119,
        "number_of_private_hospitals": 0.008209302,
        "health_care_system": 0.209,
        "health_care_index": 0.142548596,
        "insurance_companies_number_vs_population_density": 0.006960557,
        "number_of_private_hospitals_vs_population_density": 0.00472657,
        "land_area": 0.018695243,
        "innovation_index": 0.493069307,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.033350703,
        "education_index": 0.898550725,
        "quality_index": 0.65234375,
        "opportunity_index": 0.287546406,
        "school_enrollment_secondary": 0.117205422,
        "school_enrollment_primary": 0.063318331,
        "best_countries_for_education": 0.378,
        "economic_freedom_index": 0.807125307,
        "demographic_pressures_indicator": 0.321839081,
        "cost_of_living": 0.201597566,
        "happiness_index": 0.677361854,
        "human_development_index": 0.859649123,
        "standard_of_living_index_by_world_population_review": 0.744630425,
        "ccpi": 0.372562674,
        "population_density_per_km2": 0.004604543,
        "quality_of_life": 0.333738602
    },
    {
        "iso_code": "SVN",
        "country": "Slovenia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 37,
        "climate_resilience": 48,
        "economic_freedom": 71,
        "education": 41,
        "lifestyle": 52,
        "private_healthcare": 42,
        "safety_security": 74,
        "climate_resilience_score": 0.561165049,
        "safety_and_security": 0.914589293,
        "total_business_opportunity": 0.563997438,
        "open_for_business": 0.610296514,
        "entrepreneurship": 0.062385321,
        "gdp_2021": 0.002672775,
        "gdp_per_capita": 0.166986382,
        "gdp_growth_annual_percentage_2021": 0.528672746,
        "haq": 0.890909091,
        "domestic_private_health_expenditure_per_capita": 0.092896741,
        "domestic_private_health_expenditure": 0.299310837,
        "global_health_security_index": 0.864774624,
        "insurance_companies_number": 0.021523179,
        "number_of_private_hospitals": 0.000232558,
        "health_care_system": 0.066,
        "health_care_index": 0.160475162,
        "insurance_companies_number_vs_population_density": 0.001740139,
        "number_of_private_hospitals_vs_population_density": 0.000165265,
        "land_area": 0.001229537,
        "innovation_index": 0.576237624,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.956521739,
        "quality_index": 0.7578125,
        "opportunity_index": 0.479919001,
        "school_enrollment_secondary": 0.041188738,
        "school_enrollment_primary": 0.009206219,
        "best_countries_for_education": 0.094,
        "economic_freedom_index": 0.829238329,
        "demographic_pressures_indicator": 0.298850575,
        "cost_of_living": 0.29703655,
        "happiness_index": 0.816399287,
        "human_development_index": 0.929824561,
        "standard_of_living_index_by_world_population_review": 0.669826692,
        "ccpi": 0.418697772,
        "population_density_per_km2": 0.003892179,
        "quality_of_life": 0.10881459
    },
    {
        "iso_code": "CZE",
        "country": "Czech Republic",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 40,
        "climate_resilience": 48,
        "economic_freedom": 74,
        "education": 42,
        "lifestyle": 47,
        "private_healthcare": 45,
        "safety_security": 74,
        "climate_resilience_score": 0.561165049,
        "safety_and_security": 0.913771966,
        "total_business_opportunity": 0.690070468,
        "open_for_business": 0.51678071,
        "entrepreneurship": 0.21456422,
        "gdp_2021": 0.012275061,
        "gdp_per_capita": 0.150714849,
        "gdp_growth_annual_percentage_2021": 0.432016211,
        "haq": 0.851515152,
        "domestic_private_health_expenditure_per_capita": 0.051437179,
        "domestic_private_health_expenditure": 0.190826996,
        "global_health_security_index": 0.614357262,
        "insurance_companies_number": 0.044701987,
        "number_of_private_hospitals": 0.004348837,
        "health_care_system": 0.175,
        "health_care_index": 0.55161987,
        "insurance_companies_number_vs_population_density": 0.00275522,
        "number_of_private_hospitals_vs_population_density": 0.002231073,
        "land_area": 0.004713939,
        "innovation_index": 0.673267327,
        "number_of_universities_in_top_1000": 0.022099448,
        "number_of_top_tier_international_schools": 0.008858781,
        "education_index": 0.927536232,
        "quality_index": 0.685546875,
        "opportunity_index": 0.332433345,
        "school_enrollment_secondary": 0.103962461,
        "school_enrollment_primary": 0.02700491,
        "best_countries_for_education": 0.284,
        "economic_freedom_index": 0.877149877,
        "demographic_pressures_indicator": 0.252873563,
        "cost_of_living": 0.258480584,
        "happiness_index": 0.848484849,
        "human_development_index": 0.575438597,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.39902507,
        "population_density_per_km2": 0.005183624,
        "quality_of_life": 0.285957447
    },
    {
        "iso_code": "BRA",
        "country": "Brazil",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 23,
        "climate_resilience": 48,
        "economic_freedom": 53,
        "education": 29,
        "lifestyle": 55,
        "private_healthcare": 30,
        "safety_security": 51,
        "climate_resilience_score": 0.559223301,
        "safety_and_security": 0.445034736,
        "total_business_opportunity": 0.292248559,
        "open_for_business": 0.321928967,
        "entrepreneurship": 0.127408257,
        "gdp_2021": 0.069965017,
        "gdp_per_capita": 0.041983117,
        "gdp_growth_annual_percentage_2021": 0.457953394,
        "haq": 0.55,
        "domestic_private_health_expenditure_per_capita": 0.076329383,
        "domestic_private_health_expenditure": 0.673360266,
        "global_health_security_index": 0.587646077,
        "insurance_companies_number": 0.264900662,
        "number_of_private_hospitals": 0.097627907,
        "health_care_system": 0.021,
        "health_care_index": 0.084017279,
        "insurance_companies_number_vs_population_density": 0.090632251,
        "number_of_private_hospitals_vs_population_density": 0.270984482,
        "land_area": 0.510362468,
        "innovation_index": 0.38019802,
        "number_of_universities_in_top_1000": 0.055248619,
        "number_of_top_tier_international_schools": 0.026055237,
        "education_index": 0.637681159,
        "quality_index": 0.56640625,
        "opportunity_index": 0.180897739,
        "school_enrollment_secondary": 0.14358707,
        "school_enrollment_primary": 0.186272504,
        "best_countries_for_education": 0.006,
        "economic_freedom_index": 0.617936118,
        "demographic_pressures_indicator": 0.885057471,
        "cost_of_living": 0.210588195,
        "happiness_index": 0.682709447,
        "human_development_index": 0.666666667,
        "standard_of_living_index_by_world_population_review": 0.752925493,
        "ccpi": 0.620299443,
        "population_density_per_km2": 0.000890834,
        "quality_of_life": 0.100790274
    },
    {
        "iso_code": "PRT",
        "country": "Portugal",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 215600, "eur" : 200000}
        },
        "business_opportunity": 44,
        "climate_resilience": 48,
        "economic_freedom": 71,
        "education": 38,
        "lifestyle": 58,
        "private_healthcare": 44,
        "safety_security": 74,
        "climate_resilience_score": 0.553398058,
        "safety_and_security": 0.920719248,
        "total_business_opportunity": 0.545163357,
        "open_for_business": 0.704463995,
        "entrepreneurship": 0.317775229,
        "gdp_2021": 0.010863757,
        "gdp_per_capita": 0.13851362,
        "gdp_growth_annual_percentage_2021": 0.463221885,
        "haq": 0.846969697,
        "domestic_private_health_expenditure_per_capita": 0.131585929,
        "domestic_private_health_expenditure": 0.434648289,
        "global_health_security_index": 0.646076795,
        "insurance_companies_number": 0.157284768,
        "number_of_private_hospitals": 0.005232558,
        "health_care_system": 0.206,
        "health_care_index": 0.37062635,
        "insurance_companies_number_vs_population_density": 0.012180974,
        "number_of_private_hospitals_vs_population_density": 0.003305293,
        "land_area": 0.00559357,
        "innovation_index": 0.578217822,
        "number_of_universities_in_top_1000": 0.066298343,
        "number_of_top_tier_international_schools": 0.006774362,
        "education_index": 0.753623188,
        "quality_index": 0.626953125,
        "opportunity_index": 0.25683429,
        "school_enrollment_secondary": 0.179666319,
        "school_enrollment_primary": 0.130012275,
        "best_countries_for_education": 0.283,
        "economic_freedom_index": 0.832923833,
        "demographic_pressures_indicator": 0.344827586,
        "cost_of_living": 0.331138698,
        "happiness_index": 0.713012478,
        "human_development_index": 0.824561404,
        "standard_of_living_index_by_world_population_review": 0.812175974,
        "ccpi": 0.729108635,
        "population_density_per_km2": 0.004187985,
        "quality_of_life": 0.461641337
    },
    {
        "iso_code": "SAU",
        "country": "Saudi Arabia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 32,
        "climate_resilience": 47,
        "economic_freedom": 56,
        "education": 31,
        "lifestyle": 54,
        "private_healthcare": 34,
        "safety_security": 54,
        "climate_resilience_score": 0.547572816,
        "safety_and_security": 0.517368206,
        "total_business_opportunity": 0.703010891,
        "open_for_business": 0.143695015,
        "entrepreneurship": 0.238302752,
        "gdp_2021": 0.036244425,
        "gdp_per_capita": 0.134614603,
        "gdp_growth_annual_percentage_2021": 0.429989868,
        "haq": 0.76969697,
        "domestic_private_health_expenditure_per_capita": 0.061276049,
        "domestic_private_health_expenditure": 0.33733365,
        "global_health_security_index": 0.482470785,
        "insurance_companies_number": 0.056291391,
        "number_of_private_hospitals": 0.001395349,
        "health_care_system": 0.199,
        "health_care_index": 0.129805616,
        "insurance_companies_number_vs_population_density": 0.030017401,
        "number_of_private_hospitals_vs_population_density": 0.006032161,
        "land_area": 0.131263765,
        "innovation_index": 0.332673267,
        "number_of_universities_in_top_1000": 0.060773481,
        "number_of_top_tier_international_schools": 0.014590933,
        "education_index": 0.782608696,
        "quality_index": 0.61328125,
        "opportunity_index": 0.212284846,
        "school_enrollment_secondary": 0.122523462,
        "school_enrollment_primary": 0.090323241,
        "best_countries_for_education": 0.106,
        "economic_freedom_index": 0.644963145,
        "demographic_pressures_indicator": 0.379310345,
        "cost_of_living": 0.367578409,
        "happiness_index": 0.76114082,
        "human_development_index": 0.807017544,
        "standard_of_living_index_by_world_population_review": 0.68434306,
        "ccpi": 0.087395543,
        "population_density_per_km2": 0.000543006,
        "quality_of_life": 0.212158055
    },
    {
        "iso_code": "QAT",
        "country": "Qatar",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 44,
        "climate_resilience": 47,
        "economic_freedom": 68,
        "education": 31,
        "lifestyle": 53,
        "private_healthcare": 39,
        "safety_security": 69,
        "climate_resilience_score": 0.539805825,
        "safety_and_security": 0.825909277,
        "total_business_opportunity": 0.793081358,
        "open_for_business": 0.426523298,
        "entrepreneurship": 0.284059633,
        "gdp_2021": 0.007806027,
        "gdp_per_capita": 0.351909547,
        "gdp_growth_annual_percentage_2021": 0.395136778,
        "haq": 0.857575758,
        "domestic_private_health_expenditure_per_capita": 0.074461629,
        "domestic_private_health_expenditure": 0.294676806,
        "global_health_security_index": 0.54590985,
        "insurance_companies_number": 0.01986755,
        "number_of_private_hospitals": 0.000139535,
        "health_care_system": 0.162,
        "health_care_index": 0.277969762,
        "insurance_companies_number_vs_population_density": 0.000725058,
        "number_of_private_hospitals_vs_population_density": 0.0000331,
        "land_area": 0.000701572,
        "innovation_index": 0.326732673,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.009379885,
        "education_index": 0.594202899,
        "quality_index": 0.396484375,
        "opportunity_index": 0.10158623,
        "school_enrollment_secondary": 0.511887383,
        "school_enrollment_primary": 0.653641571,
        "best_countries_for_education": 0.062,
        "economic_freedom_index": 0.794840295,
        "demographic_pressures_indicator": 0.206896552,
        "cost_of_living": 0.439676337,
        "happiness_index": 0.74688057,
        "human_development_index": 0.807017544,
        "standard_of_living_index_by_world_population_review": 0.750851726,
        "ccpi": 0.208077994,
        "population_density_per_km2": 0.00960362,
        "quality_of_life": 0.205957447
    },
    {
        "iso_code": "EST",
        "country": "Estonia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 41,
        "climate_resilience": 46,
        "economic_freedom": 80,
        "education": 39,
        "lifestyle": 52,
        "private_healthcare": 38,
        "safety_security": 67,
        "climate_resilience_score": 0.52815534,
        "safety_and_security": 0.773191663,
        "total_business_opportunity": 0.730813581,
        "open_for_business": 0.572173346,
        "entrepreneurship": 0.089678899,
        "gdp_2021": 0.001574177,
        "gdp_per_capita": 0.155916075,
        "gdp_growth_annual_percentage_2021": 0.533535968,
        "haq": 0.8,
        "domestic_private_health_expenditure_per_capita": 0.06172736,
        "domestic_private_health_expenditure": 0.274714829,
        "global_health_security_index": 0.659432387,
        "insurance_companies_number": 0.01986755,
        "number_of_private_hospitals": 0.000697674,
        "health_care_system": 0.086,
        "health_care_index": 0.278185745,
        "insurance_companies_number_vs_population_density": 0.005655452,
        "number_of_private_hospitals_vs_population_density": 0.001619594,
        "land_area": 0.002654327,
        "innovation_index": 0.691089109,
        "number_of_universities_in_top_1000": 0.016574586,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.913043478,
        "quality_index": 0.64453125,
        "opportunity_index": 0.28079649,
        "school_enrollment_secondary": 0.03806048,
        "school_enrollment_primary": 0.059840426,
        "best_countries_for_education": 0.124,
        "economic_freedom_index": 0.945945946,
        "demographic_pressures_indicator": 0.218390805,
        "cost_of_living": 0.369826066,
        "happiness_index": 0.778966132,
        "human_development_index": 0.877192983,
        "standard_of_living_index_by_world_population_review": 0.760183677,
        "ccpi": 0.622388579,
        "population_density_per_km2": 0.001079937,
        "quality_of_life": 0.134103344
    },
    {
        "iso_code": "TUR",
        "country": "Türkiye",
        "cpi": true, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": 400000, "eur": 371100},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 28,
        "climate_resilience": 46,
        "economic_freedom": 57,
        "education": 32,
        "lifestyle": 43,
        "private_healthcare": 30,
        "safety_security": 44,
        "climate_resilience_score": 0.526213592,
        "safety_and_security": 0.314262362,
        "total_business_opportunity": 0.377834721,
        "open_for_business": 0.37504073,
        "entrepreneurship": 0.150802752,
        "gdp_2021": 0.035449963,
        "gdp_per_capita": 0.053904497,
        "gdp_growth_annual_percentage_2021": 0.587031408,
        "haq": 0.721212121,
        "domestic_private_health_expenditure_per_capita": 0.012761714,
        "domestic_private_health_expenditure": 0.233365019,
        "global_health_security_index": 0.567612688,
        "insurance_companies_number": 0.100993378,
        "number_of_private_hospitals": 0.01327907,
        "health_care_system": 0.08,
        "health_care_index": 0.076457883,
        "insurance_companies_number_vs_population_density": 0.007975638,
        "number_of_private_hospitals_vs_population_density": 0.008544184,
        "land_area": 0.046994913,
        "innovation_index": 0.461386139,
        "number_of_universities_in_top_1000": 0.364640884,
        "number_of_top_tier_international_schools": 0.058363731,
        "education_index": 0.695652174,
        "quality_index": 0.515625,
        "opportunity_index": 0.149848127,
        "school_enrollment_secondary": 0.080604797,
        "school_enrollment_primary": 0.046849427,
        "best_countries_for_education": 0.064,
        "economic_freedom_index": 0.662162162,
        "demographic_pressures_indicator": 0.425287356,
        "cost_of_living": 0.119298731,
        "happiness_index": 0.390374332,
        "human_development_index": 0.754385965,
        "standard_of_living_index_by_world_population_review": 0.698711302,
        "ccpi": 0.544916435,
        "population_density_per_km2": 0.004114698,
        "quality_of_life": 0.165106383
    },
    {
        "iso_code": "IND",
        "country": "India",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 41,
        "climate_resilience": 46,
        "economic_freedom": 54,
        "education": 33,
        "lifestyle": 44,
        "private_healthcare": 27,
        "safety_security": 48,
        "climate_resilience_score": 0.514563107,
        "safety_and_security": 0.398855742,
        "total_business_opportunity": 0.56450993,
        "open_for_business": 0.567937439,
        "entrepreneurship": 0.264105505,
        "gdp_2021": 0.137994843,
        "gdp_per_capita": 0.011764852,
        "gdp_growth_annual_percentage_2021": 0.545694022,
        "haq": 0.245454546,
        "domestic_private_health_expenditure_per_capita": 0.005863985,
        "domestic_private_health_expenditure": 0.759743346,
        "global_health_security_index": 0.447412354,
        "insurance_companies_number": 0.094370861,
        "number_of_private_hospitals": 1,
        "health_care_system": 0.006,
        "health_care_index": 0.425053996,
        "insurance_companies_number_vs_population_density": 0.001740139,
        "number_of_private_hospitals_vs_population_density": 0.151630336,
        "land_area": 0.181548101,
        "innovation_index": 0.423762376,
        "number_of_universities_in_top_1000": 0.193370166,
        "number_of_top_tier_international_schools": 0.106305367,
        "education_index": 0.449275362,
        "quality_index": 0.626953125,
        "opportunity_index": 0.271684104,
        "school_enrollment_secondary": 0.532221064,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.03,
        "economic_freedom_index": 0.625307125,
        "demographic_pressures_indicator": 0.816091954,
        "cost_of_living": 0.191742453,
        "happiness_index": 0.245989305,
        "human_development_index": 0.456140351,
        "standard_of_living_index_by_world_population_review": 0.761368686,
        "ccpi": 0.869951254,
        "population_density_per_km2": 0.017714922,
        "quality_of_life": 0.173617021
    },
    {
        "iso_code": "CHL",
        "country": "Chile",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 34,
        "climate_resilience": 45,
        "economic_freedom": 74,
        "education": 39,
        "lifestyle": 53,
        "private_healthcare": 36,
        "safety_security": 63,
        "climate_resilience_score": 0.510679612,
        "safety_and_security": 0.70044953,
        "total_business_opportunity": 0.505829596,
        "open_for_business": 0.538611926,
        "entrepreneurship": 0.074770642,
        "gdp_2021": 0.013784784,
        "gdp_per_capita": 0.093778666,
        "gdp_growth_annual_percentage_2021": 0.600810537,
        "haq": 0.718181818,
        "domestic_private_health_expenditure_per_capita": 0.102372734,
        "domestic_private_health_expenditure": 0.55418251,
        "global_health_security_index": 0.671118531,
        "insurance_companies_number": 0.114238411,
        "number_of_private_hospitals": 0.005348837,
        "health_care_system": 0.02,
        "health_care_index": 0.206263499,
        "insurance_companies_number_vs_population_density": 0.038718097,
        "number_of_private_hospitals_vs_population_density": 0.014708556,
        "land_area": 0.045401324,
        "innovation_index": 0.398019802,
        "number_of_universities_in_top_1000": 0.027624309,
        "number_of_top_tier_international_schools": 0.015112038,
        "education_index": 0.811594203,
        "quality_index": 0.501953125,
        "opportunity_index": 0.145798178,
        "school_enrollment_secondary": 0.644629823,
        "school_enrollment_primary": 0.640343699,
        "best_countries_for_education": 0.036,
        "economic_freedom_index": 0.877149877,
        "demographic_pressures_indicator": 0.563218391,
        "cost_of_living": 0.246723607,
        "happiness_index": 0.759358289,
        "human_development_index": 0.807017544,
        "standard_of_living_index_by_world_population_review": 0.679454896,
        "ccpi": 0.875348189,
        "population_density_per_km2": 0.000899948,
        "quality_of_life": 0.138601824
    },
    {
        "iso_code": "GRC",
        "country": "Greece",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 269500, "eur" : 250000}
        },
        "business_opportunity": 36,
        "climate_resilience": 45,
        "economic_freedom": 62,
        "education": 36,
        "lifestyle": 55,
        "private_healthcare": 42,
        "safety_security": 63,
        "climate_resilience_score": 0.495145631,
        "safety_and_security": 0.701266857,
        "total_business_opportunity": 0.452402306,
        "open_for_business": 0.566308244,
        "entrepreneurship": 0.183027523,
        "gdp_2021": 0.009400641,
        "gdp_per_capita": 0.115535194,
        "gdp_growth_annual_percentage_2021": 0.533333333,
        "haq": 0.884848485,
        "domestic_private_health_expenditure_per_capita": 0.117784371,
        "domestic_private_health_expenditure": 0.585788973,
        "global_health_security_index": 0.592654424,
        "insurance_companies_number": 0.109271523,
        "number_of_private_hospitals": 0.006511628,
        "health_care_system": 0.089,
        "health_care_index": 0.339308855,
        "insurance_companies_number_vs_population_density": 0.011600928,
        "number_of_private_hospitals_vs_population_density": 0.005585946,
        "land_area": 0.00787083,
        "innovation_index": 0.421782178,
        "number_of_universities_in_top_1000": 0.055248619,
        "number_of_top_tier_international_schools": 0.00990099,
        "education_index": 0.869565217,
        "quality_index": 0.685546875,
        "opportunity_index": 0.334120824,
        "school_enrollment_secondary": 0.04535975,
        "school_enrollment_primary": 0.059533552,
        "best_countries_for_education": 0.193,
        "economic_freedom_index": 0.718673219,
        "demographic_pressures_indicator": 0.356321839,
        "cost_of_living": 0.345819358,
        "happiness_index": 0.698752228,
        "human_development_index": 0.877192983,
        "standard_of_living_index_by_world_population_review": 0.767886239,
        "ccpi": 0.678795265,
        "population_density_per_km2": 0.003060582,
        "quality_of_life": 0.28231003
    },
    {
        "iso_code": "LTU",
        "country": "Lithuania",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 38,
        "climate_resilience": 45,
        "economic_freedom": 76,
        "education": 36,
        "lifestyle": 51,
        "private_healthcare": 38,
        "safety_security": 66,
        "climate_resilience_score": 0.495145631,
        "safety_and_security": 0.747854516,
        "total_business_opportunity": 0.65983344,
        "open_for_business": 0.558488107,
        "entrepreneurship": 0.087270642,
        "gdp_2021": 0.00284574,
        "gdp_per_capita": 0.133735394,
        "gdp_growth_annual_percentage_2021": 0.465653495,
        "haq": 0.727272727,
        "domestic_private_health_expenditure_per_capita": 0.071583001,
        "domestic_private_health_expenditure": 0.381535171,
        "global_health_security_index": 0.726210351,
        "insurance_companies_number": 0.033112583,
        "number_of_private_hospitals": 0.000255814,
        "health_care_system": 0.046,
        "health_care_index": 0.278185745,
        "insurance_companies_number_vs_population_density": 0.006525522,
        "number_of_private_hospitals_vs_population_density": 0.000413162,
        "land_area": 0.003824269,
        "innovation_index": 0.493069307,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.007295466,
        "education_index": 0.942028986,
        "quality_index": 0.61328125,
        "opportunity_index": 0.226797165,
        "school_enrollment_secondary": 0.035140772,
        "school_enrollment_primary": 0.037234043,
        "best_countries_for_education": 0.16,
        "economic_freedom_index": 0.894348894,
        "demographic_pressures_indicator": 0.298850575,
        "cost_of_living": 0.260209551,
        "happiness_index": 0.834224599,
        "human_development_index": 0.859649123,
        "standard_of_living_index_by_world_population_review": 0.681380536,
        "ccpi": 0.794916435,
        "population_density_per_km2": 0.001613451,
        "quality_of_life": 0.10662614
    },
    {
        "iso_code": "MEX",
        "country": "Mexico",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 27,
        "climate_resilience": 44,
        "economic_freedom": 64,
        "education": 27,
        "lifestyle": 52,
        "private_healthcare": 34,
        "safety_security": 48,
        "climate_resilience_score": 0.491262136,
        "safety_and_security": 0.384961177,
        "total_business_opportunity": 0.34657271,
        "open_for_business": 0.451938742,
        "entrepreneurship": 0.108715596,
        "gdp_2021": 0.056225982,
        "gdp_per_capita": 0.055863605,
        "gdp_growth_annual_percentage_2021": 0.461600811,
        "haq": 0.515151515,
        "domestic_private_health_expenditure_per_capita": 0.041179018,
        "domestic_private_health_expenditure": 0.573312738,
        "global_health_security_index": 0.684474124,
        "insurance_companies_number": 0.185430464,
        "number_of_private_hospitals": 0.069488372,
        "health_care_system": 0.023,
        "health_care_index": 0.289848812,
        "insurance_companies_number_vs_population_density": 0.024216937,
        "number_of_private_hospitals_vs_population_density": 0.073691517,
        "land_area": 0.118700925,
        "innovation_index": 0.386138614,
        "number_of_universities_in_top_1000": 0.016574586,
        "number_of_top_tier_international_schools": 0.060969255,
        "education_index": 0.652173913,
        "quality_index": 0.490234375,
        "opportunity_index": 0.141073237,
        "school_enrollment_secondary": 0.137434828,
        "school_enrollment_primary": 0.097688216,
        "best_countries_for_education": 0.02,
        "economic_freedom_index": 0.745700246,
        "demographic_pressures_indicator": 0.67816092,
        "cost_of_living": 0.192888758,
        "happiness_index": 0.679144385,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.739297882,
        "ccpi": 0.641016713,
        "population_density_per_km2": 0.002463275,
        "quality_of_life": 0.155136778
    },
    {
        "iso_code": "MLT",
        "country": "Malta",
        "cpi": false,
        "cbn": true,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": 795400, "eur": 738000},
            "rpi": {"usd" : 188600, "eur" : 175000}
        },
        "business_opportunity": 33,
        "climate_resilience": 44,
        "economic_freedom": 72,
        "education": 39,
        "lifestyle": 58,
        "private_healthcare": 35,
        "safety_security": 65,
        "climate_resilience_score": 0.473786408,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000744764,
        "gdp_per_capita": 0.190373914,
        "gdp_growth_annual_percentage_2021": 0.555015198,
        "haq": 0.856060606,
        "domestic_private_health_expenditure_per_capita": 0.141789202,
        "domestic_private_health_expenditure": 0.409220532,
        "global_health_security_index": 0.404006678,
        "insurance_companies_number": 0.127483444,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000725058,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000195,
        "innovation_index": 0.635643564,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.84057971,
        "quality_index": 0.474609375,
        "opportunity_index": 0.119811002,
        "school_enrollment_secondary": 0.372471324,
        "school_enrollment_primary": 0.438727496,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.841523342,
        "demographic_pressures_indicator": 0.310344828,
        "cost_of_living": 0.61767696,
        "happiness_index": 0.759358289,
        "human_development_index": 0.894736842,
        "standard_of_living_index_by_world_population_review": 0.762701822,
        "ccpi": 0.78255571,
        "population_density_per_km2": 0.061252651,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "CYP",
        "country": "Cyprus",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 323300, "eur" : 300000}
        },
        "business_opportunity": 34,
        "climate_resilience": 43,
        "economic_freedom": 73,
        "education": 39,
        "lifestyle": 54,
        "private_healthcare": 31,
        "safety_security": 62,
        "climate_resilience_score": 0.469902913,
        "safety_and_security": 0.674703719,
        "total_business_opportunity": 0.55554132,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.001202652,
        "gdp_per_capita": 0.176197377,
        "gdp_growth_annual_percentage_2021": 0.475987842,
        "haq": 0.859090909,
        "domestic_private_health_expenditure_per_capita": 0.131200181,
        "domestic_private_health_expenditure": 0.485384981,
        "global_health_security_index": 0.432387312,
        "insurance_companies_number": 0.102649007,
        "number_of_private_hospitals": 0.001744186,
        "health_care_system": 0.0696,
        "health_care_index": 0.047300216,
        "insurance_companies_number_vs_population_density": 0.006815545,
        "number_of_private_hospitals_vs_population_density": 0.000942009,
        "land_area": 0.000564184,
        "innovation_index": 0.627722772,
        "number_of_universities_in_top_1000": 0.016574586,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.84057971,
        "quality_index": 0.658203125,
        "opportunity_index": 0.320620992,
        "school_enrollment_secondary": 0.193534932,
        "school_enrollment_primary": 0.097585925,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.858722359,
        "demographic_pressures_indicator": 0.275862069,
        "cost_of_living": 0.465989488,
        "happiness_index": 0.729055259,
        "human_development_index": 0.877192983,
        "standard_of_living_index_by_world_population_review": 0.767886239,
        "ccpi": 0.54474234,
        "population_density_per_km2": 0.004914399,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MYS",
        "country": "Malaysia",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 223900, "eur" : 208100}
        },
        "business_opportunity": 44,
        "climate_resilience": 43,
        "economic_freedom": 68,
        "education": 30,
        "lifestyle": 51,
        "private_healthcare": 35,
        "safety_security": 71,
        "climate_resilience_score": 0.46407767,
        "safety_and_security": 0.851246424,
        "total_business_opportunity": 0.600128123,
        "open_for_business": 0.816552623,
        "entrepreneurship": 0.165022936,
        "gdp_2021": 0.016204456,
        "gdp_per_capita": 0.064192625,
        "gdp_growth_annual_percentage_2021": 0.427760892,
        "haq": 0.575757576,
        "domestic_private_health_expenditure_per_capita": 0.031236468,
        "domestic_private_health_expenditure": 0.538973384,
        "global_health_security_index": 0.674457429,
        "insurance_companies_number": 0.05794702,
        "number_of_private_hospitals": 0.005813953,
        "health_care_system": 0.068,
        "health_care_index": 0.273866091,
        "insurance_companies_number_vs_population_density": 0.005075406,
        "number_of_private_hospitals_vs_population_density": 0.004148143,
        "land_area": 0.020061805,
        "innovation_index": 0.532673267,
        "number_of_universities_in_top_1000": 0.082872928,
        "number_of_top_tier_international_schools": 0.018759771,
        "education_index": 0.695652174,
        "quality_index": 0.46875,
        "opportunity_index": 0.115423557,
        "school_enrollment_secondary": 0.092387904,
        "school_enrollment_primary": 0.114259411,
        "best_countries_for_education": 0.066,
        "economic_freedom_index": 0.7997543,
        "demographic_pressures_indicator": 0.425287356,
        "cost_of_living": 0.203426813,
        "happiness_index": 0.682709447,
        "human_development_index": 0.736842105,
        "standard_of_living_index_by_world_population_review": 0.752332988,
        "ccpi": 0.252611421,
        "population_density_per_km2": 0.003706874,
        "quality_of_life": 0.260182371
    },
    {
        "iso_code": "LVA",
        "country": "Latvia",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 64700, "eur" : 60000}
        },
        "business_opportunity": 35,
        "climate_resilience": 43,
        "economic_freedom": 75,
        "education": 35,
        "lifestyle": 51,
        "private_healthcare": 37,
        "safety_security": 67,
        "climate_resilience_score": 0.460194175,
        "safety_and_security": 0.768696363,
        "total_business_opportunity": 0.56963485,
        "open_for_business": 0.574780059,
        "entrepreneurship": 0.06353211,
        "gdp_2021": 0.001687658,
        "gdp_per_capita": 0.117643162,
        "gdp_growth_annual_percentage_2021": 0.455116515,
        "haq": 0.743939394,
        "domestic_private_health_expenditure_per_capita": 0.069102319,
        "domestic_private_health_expenditure": 0.436430608,
        "global_health_security_index": 0.766277129,
        "insurance_companies_number": 0.028145695,
        "number_of_private_hospitals": 0.000325581,
        "health_care_system": 0.051,
        "health_care_index": 0.156155508,
        "insurance_companies_number_vs_population_density": 0.00812065,
        "number_of_private_hospitals_vs_population_density": 0.000760217,
        "land_area": 0.003791296,
        "innovation_index": 0.495049505,
        "number_of_universities_in_top_1000": 0.016574586,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.913043478,
        "quality_index": 0.64453125,
        "opportunity_index": 0.275734053,
        "school_enrollment_secondary": 0.038164755,
        "school_enrollment_primary": 0.024345336,
        "best_countries_for_education": 0.099,
        "economic_freedom_index": 0.882063882,
        "demographic_pressures_indicator": 0.252873563,
        "cost_of_living": 0.342522217,
        "happiness_index": 0.743315508,
        "human_development_index": 0.842105263,
        "standard_of_living_index_by_world_population_review": 0.727744038,
        "ccpi": 0.670264624,
        "population_density_per_km2": 0.001070444,
        "quality_of_life": 0.121945289
    },
    {
        "iso_code": "BRN",
        "country": "Brunei",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 43,
        "economic_freedom": 65,
        "education": 24,
        "lifestyle": 40,
        "private_healthcare": 30,
        "safety_security": 65,
        "climate_resilience_score": 0.458252427,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000606342,
        "gdp_per_capita": 0.181525556,
        "gdp_growth_annual_percentage_2021": 0.331712259,
        "haq": 0.627272727,
        "domestic_private_health_expenditure_per_capita": 0.005229711,
        "domestic_private_health_expenditure": 0.038498099,
        "global_health_security_index": 0.459098498,
        "insurance_companies_number": 0.021523179,
        "number_of_private_hospitals": 0.069767442,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.002320186,
        "number_of_private_hospitals_vs_population_density": 0.059181279,
        "land_area": 0.000321768,
        "innovation_index": 0.261386139,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.652173913,
        "quality_index": 0.2421875,
        "opportunity_index": 0.06716166,
        "school_enrollment_secondary": 0.160896768,
        "school_enrollment_primary": 0.421337971,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.759213759,
        "demographic_pressures_indicator": 0.16091954,
        "cost_of_living": 0.281475846,
        "happiness_index": 0.684135472,
        "human_development_index": 0.557894737,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.003100073,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SVK",
        "country": "Slovakia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 43,
        "economic_freedom": 70,
        "education": 34,
        "lifestyle": 48,
        "private_healthcare": 34,
        "safety_security": 70,
        "climate_resilience_score": 0.454368932,
        "safety_and_security": 0.839803841,
        "total_business_opportunity": 0.404612428,
        "open_for_business": 0.585532747,
        "entrepreneurship": 0.070756881,
        "gdp_2021": 0.004992495,
        "gdp_per_capita": 0.120212643,
        "gdp_growth_annual_percentage_2021": 0.425531915,
        "haq": 0.757575758,
        "domestic_private_health_expenditure_per_capita": 0.042758604,
        "domestic_private_health_expenditure": 0.222671103,
        "global_health_security_index": 0.641068447,
        "insurance_companies_number": 0.021523179,
        "number_of_private_hospitals": 0.001162791,
        "health_care_system": 0.08,
        "health_care_index": 0.130885529,
        "insurance_companies_number_vs_population_density": 0.001595128,
        "number_of_private_hospitals_vs_population_density": 0.000727165,
        "land_area": 0.002935821,
        "innovation_index": 0.499009901,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.004689943,
        "education_index": 0.84057971,
        "quality_index": 0.5859375,
        "opportunity_index": 0.205534931,
        "school_enrollment_secondary": 0.123044838,
        "school_enrollment_primary": 0.082242226,
        "best_countries_for_education": 0.116,
        "economic_freedom_index": 0.819410319,
        "demographic_pressures_indicator": 0.183908046,
        "cost_of_living": 0.246723607,
        "happiness_index": 0.755793226,
        "human_development_index": 0.824561404,
        "standard_of_living_index_by_world_population_review": 0.733669086,
        "ccpi": 0.54735376,
        "population_density_per_km2": 0.004221021,
        "quality_of_life": 0.137386018
    },
    {
        "iso_code": "IDN",
        "country": "Indonesia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 37,
        "climate_resilience": 42,
        "economic_freedom": 64,
        "education": 25,
        "lifestyle": 51,
        "private_healthcare": 24,
        "safety_security": 64,
        "climate_resilience_score": 0.452427185,
        "safety_and_security": 0.716796077,
        "total_business_opportunity": 0.529660474,
        "open_for_business": 0.701531444,
        "entrepreneurship": 0.091857798,
        "gdp_2021": 0.051575404,
        "gdp_per_capita": 0.023378366,
        "gdp_growth_annual_percentage_2021": 0.439108409,
        "haq": 0.312121212,
        "domestic_private_health_expenditure_per_capita": 0.008663329,
        "domestic_private_health_expenditure": 0.571173954,
        "global_health_security_index": 0.574290484,
        "insurance_companies_number": 0.119205298,
        "number_of_private_hospitals": 0.04155814,
        "health_care_system": 0.02,
        "health_care_index": 0.141036717,
        "insurance_companies_number_vs_population_density": 0.007105568,
        "number_of_private_hospitals_vs_population_density": 0.020063131,
        "land_area": 0.114644533,
        "innovation_index": 0.23960396,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.033350703,
        "education_index": 0.579710145,
        "quality_index": 0.37890625,
        "opportunity_index": 0.094836315,
        "school_enrollment_secondary": 0.438477581,
        "school_enrollment_primary": 0.233735679,
        "best_countries_for_education": 0.019,
        "economic_freedom_index": 0.754299754,
        "demographic_pressures_indicator": 0.689655172,
        "cost_of_living": 0.317957053,
        "happiness_index": 0.579322638,
        "human_development_index": 0.578947368,
        "standard_of_living_index_by_world_population_review": 0.700785069,
        "ccpi": 0.66051532,
        "population_density_per_km2": 0.005508288,
        "quality_of_life": 0.182370821
    },
    {
        "iso_code": "KAZ",
        "country": "Kazakhstan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 26,
        "climate_resilience": 42,
        "economic_freedom": 64,
        "education": 26,
        "lifestyle": 45,
        "private_healthcare": 23,
        "safety_security": 59,
        "climate_resilience_score": 0.446601942,
        "safety_and_security": 0.606048222,
        "total_business_opportunity": 0.541191544,
        "open_for_business": 0.339524275,
        "entrepreneurship": 0.008600917,
        "gdp_2021": 0.008294959,
        "gdp_per_capita": 0.056527019,
        "gdp_growth_annual_percentage_2021": 0.445390071,
        "haq": 0.492424242,
        "domestic_private_health_expenditure_per_capita": 0.016085554,
        "domestic_private_health_expenditure": 0.447005703,
        "global_health_security_index": 0.502504174,
        "insurance_companies_number": 0.044701987,
        "number_of_private_hospitals": 0.003162791,
        "health_care_system": 0.023,
        "health_care_index": 0.017278618,
        "insurance_companies_number_vs_population_density": 0.055684455,
        "number_of_private_hospitals_vs_population_density": 0.031929135,
        "land_area": 0.164848328,
        "innovation_index": 0.269306931,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.006774362,
        "education_index": 0.84057971,
        "quality_index": 0.46875,
        "opportunity_index": 0.117786028,
        "school_enrollment_secondary": 0.047966632,
        "school_enrollment_primary": 0.009308511,
        "best_countries_for_education": 0.023,
        "economic_freedom_index": 0.754299754,
        "demographic_pressures_indicator": 0.356321839,
        "cost_of_living": 0.150765932,
        "happiness_index": 0.727272727,
        "human_development_index": 0.771929825,
        "standard_of_living_index_by_world_population_review": 0.650274034,
        "ccpi": 0,
        "population_density_per_km2": 0.000186065,
        "quality_of_life": 0.045471125
    },
    {
        "iso_code": "HUN",
        "country": "Hungary",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 36,
        "climate_resilience": 42,
        "economic_freedom": 67,
        "education": 41,
        "lifestyle": 50,
        "private_healthcare": 36,
        "safety_security": 72,
        "climate_resilience_score": 0.446601942,
        "safety_and_security": 0.875766244,
        "total_business_opportunity": 0.562844331,
        "open_for_business": 0.51678071,
        "entrepreneurship": 0.166857798,
        "gdp_2021": 0.007923862,
        "gdp_per_capita": 0.106864926,
        "gdp_growth_annual_percentage_2021": 0.508206687,
        "haq": 0.772727273,
        "domestic_private_health_expenditure_per_capita": 0.051275562,
        "domestic_private_health_expenditure": 0.351473384,
        "global_health_security_index": 0.641068447,
        "insurance_companies_number": 0.03807947,
        "number_of_private_hospitals": 0.000209302,
        "health_care_system": 0.119,
        "health_care_index": 0.150107991,
        "insurance_companies_number_vs_population_density": 0.003190255,
        "number_of_private_hospitals_vs_population_density": 0.000132212,
        "land_area": 0.005572467,
        "innovation_index": 0.548514852,
        "number_of_universities_in_top_1000": 0.027624309,
        "number_of_top_tier_international_schools": 0.005211047,
        "education_index": 0.826086957,
        "quality_index": 0.69140625,
        "opportunity_index": 0.353020587,
        "school_enrollment_secondary": 0.233055266,
        "school_enrollment_primary": 0.179112111,
        "best_countries_for_education": 0.211,
        "economic_freedom_index": 0.785012285,
        "demographic_pressures_indicator": 0.287356322,
        "cost_of_living": 0.192088247,
        "happiness_index": 0.721925134,
        "human_development_index": 0.807017544,
        "standard_of_living_index_by_world_population_review": 0.765960598,
        "ccpi": 0.368732591,
        "population_density_per_km2": 0.003959011,
        "quality_of_life": 0.236838906
    },
    {
        "iso_code": "THA",
        "country": "Thailand",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 19000, "eur" : 17600}
        },
        "business_opportunity": 41,
        "climate_resilience": 41,
        "economic_freedom": 63,
        "education": 29,
        "lifestyle": 53,
        "private_healthcare": 44,
        "safety_security": 58,
        "climate_resilience_score": 0.431067961,
        "safety_and_security": 0.595014303,
        "total_business_opportunity": 0.598590647,
        "open_for_business": 0.771260997,
        "entrepreneurship": 0.129243119,
        "gdp_2021": 0.02200025,
        "gdp_per_capita": 0.040337469,
        "gdp_growth_annual_percentage_2021": 0.396149949,
        "haq": 0.639393939,
        "domestic_private_health_expenditure_per_capita": 0.012159459,
        "domestic_private_health_expenditure": 0.306440114,
        "global_health_security_index": 0.871452421,
        "insurance_companies_number": 0.086092715,
        "number_of_private_hospitals": 0.008604651,
        "health_care_system": 0.026,
        "health_care_index": 0.585313175,
        "insurance_companies_number_vs_population_density": 0.005510441,
        "number_of_private_hospitals_vs_population_density": 0.004462146,
        "land_area": 0.031195801,
        "innovation_index": 0.43960396,
        "number_of_universities_in_top_1000": 0.093922652,
        "number_of_top_tier_international_schools": 0.015112038,
        "education_index": 0.623188406,
        "quality_index": 0.5234375,
        "opportunity_index": 0.150523119,
        "school_enrollment_secondary": 0.109176225,
        "school_enrollment_primary": 0.220233224,
        "best_countries_for_education": 0.033,
        "economic_freedom_index": 0.73955774,
        "demographic_pressures_indicator": 0.586206897,
        "cost_of_living": 0.282860749,
        "happiness_index": 0.616755793,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.757517405,
        "ccpi": 0.622910864,
        "population_density_per_km2": 0.005117931,
        "quality_of_life": 0.23331307
    },
    {
        "iso_code": "BLR",
        "country": "Belarus",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 26,
        "climate_resilience": 41,
        "economic_freedom": 53,
        "education": 30,
        "lifestyle": 46,
        "private_healthcare": 28,
        "safety_security": 55,
        "climate_resilience_score": 0.431067961,
        "safety_and_security": 0.529219452,
        "total_business_opportunity": 0.575912876,
        "open_for_business": 0.27696318,
        "entrepreneurship": 0.050458716,
        "gdp_2021": 0.002963803,
        "gdp_per_capita": 0.040742827,
        "gdp_growth_annual_percentage_2021": 0.415197568,
        "haq": 0.693939394,
        "domestic_private_health_expenditure_per_capita": 0.017364775,
        "domestic_private_health_expenditure": 0.321292776,
        "global_health_security_index": 0.465776294,
        "insurance_companies_number": 0.016556291,
        "number_of_private_hospitals": 0.000093,
        "health_care_system": 0.035,
        "health_care_index": 0.119222462,
        "insurance_companies_number_vs_population_density": 0.003190255,
        "number_of_private_hospitals_vs_population_density": 0.000148738,
        "land_area": 0.012394283,
        "innovation_index": 0.348514852,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.855072464,
        "quality_index": 0.559375,
        "opportunity_index": 0.28079649,
        "school_enrollment_secondary": 0.003858186,
        "school_enrollment_primary": 0.001125205,
        "best_countries_for_education": 0.079,
        "economic_freedom_index": 0.614250614,
        "demographic_pressures_indicator": 0.436781609,
        "cost_of_living": 0.210415298,
        "happiness_index": 0.648841355,
        "human_development_index": 0.754385965,
        "standard_of_living_index_by_world_population_review": 0.66523478,
        "ccpi": 0.477541783,
        "population_density_per_km2": 0.001666233,
        "quality_of_life": 0.044620061
    },
    {
        "iso_code": "BRB",
        "country": "Barbados",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 41,
        "economic_freedom": 71,
        "education": 24,
        "lifestyle": 52,
        "private_healthcare": 29,
        "safety_security": 65,
        "climate_resilience_score": 0.423300971,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000210371,
        "gdp_per_capita": 0.096840619,
        "gdp_growth_annual_percentage_2021": 0.392705167,
        "haq": 0.578787879,
        "domestic_private_health_expenditure_per_capita": 0.094029591,
        "domestic_private_health_expenditure": 0.615969582,
        "global_health_security_index": 0.315525877,
        "insurance_companies_number": 0.683774834,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.008990719,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000262,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.768115942,
        "quality_index": 0.185546875,
        "opportunity_index": 0.047924401,
        "school_enrollment_secondary": 0.068821689,
        "school_enrollment_primary": 0.138400164,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.839066339,
        "demographic_pressures_indicator": 0.310344828,
        "cost_of_living": 0.645423424,
        "happiness_index": 0.684135472,
        "human_development_index": 0.736842105,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.025325747,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "KNA",
        "country": "St. Kitts and Nevis",
        "cpi": true, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": 125000, "eur": 116000},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 30,
        "climate_resilience": 41,
        "economic_freedom": 64,
        "education": 28,
        "lifestyle": 50,
        "private_healthcare": 28,
        "safety_security": 65,
        "climate_resilience_score": 0.421359223,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000397,
        "gdp_per_capita": 0.103737018,
        "gdp_growth_annual_percentage_2021": 0.34366768,
        "haq": 0.616969697,
        "domestic_private_health_expenditure_per_capita": 0.083576268,
        "domestic_private_health_expenditure": 0.573906844,
        "global_health_security_index": 0.262103506,
        "insurance_companies_number": 0.034768212,
        "number_of_private_hospitals": 0,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001450116,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000158,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.608695652,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.235933264,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.394847678,
        "happiness_index": 0.684135472,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.007739172,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "HRV",
        "country": "Croatia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 34,
        "climate_resilience": 40,
        "economic_freedom": 68,
        "education": 32,
        "lifestyle": 53,
        "private_healthcare": 34,
        "safety_security": 71,
        "climate_resilience_score": 0.411650485,
        "safety_and_security": 0.863914998,
        "total_business_opportunity": 0.452914798,
        "open_for_business": 0.559465624,
        "entrepreneurship": 0.108142202,
        "gdp_2021": 0.002947233,
        "gdp_per_capita": 0.098943975,
        "gdp_growth_annual_percentage_2021": 0.576089159,
        "haq": 0.803030303,
        "domestic_private_health_expenditure_per_capita": 0.028668878,
        "domestic_private_health_expenditure": 0.19023289,
        "global_health_security_index": 0.547579299,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.000372093,
        "health_care_system": 0.09,
        "health_care_index": 0.213606911,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.000380109,
        "land_area": 0.003455456,
        "innovation_index": 0.441584158,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.811594203,
        "quality_index": 0.625,
        "opportunity_index": 0.251096861,
        "school_enrollment_secondary": 0.022940563,
        "school_enrollment_primary": 0.006342062,
        "best_countries_for_education": 0.066,
        "economic_freedom_index": 0.793611794,
        "demographic_pressures_indicator": 0.436781609,
        "cost_of_living": 0.26971887,
        "happiness_index": 0.732620321,
        "human_development_index": 0.807017544,
        "standard_of_living_index_by_world_population_review": 0.719300844,
        "ccpi": 0.639449861,
        "population_density_per_km2": 0.002535043,
        "quality_of_life": 0.191367781
    },
    {
        "iso_code": "GEO",
        "country": "Georgia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 40,
        "economic_freedom": 72,
        "education": 32,
        "lifestyle": 46,
        "private_healthcare": 28,
        "safety_security": 59,
        "climate_resilience_score": 0.40776699,
        "safety_and_security": 0.608500204,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00081045,
        "gdp_per_capita": 0.027705687,
        "gdp_growth_annual_percentage_2021": 0.574265451,
        "haq": 0.507575758,
        "domestic_private_health_expenditure_per_capita": 0.025448718,
        "domestic_private_health_expenditure": 0.668013308,
        "global_health_security_index": 0.611018364,
        "insurance_companies_number": 0.049668874,
        "number_of_private_hospitals": 0.001418605,
        "health_care_system": 0.0696,
        "health_care_index": 0.030669546,
        "insurance_companies_number_vs_population_density": 0.006670534,
        "number_of_private_hospitals_vs_population_density": 0.001553488,
        "land_area": 0.004243153,
        "innovation_index": 0.344554455,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.884057971,
        "quality_index": 0.603515625,
        "opportunity_index": 0.210934863,
        "school_enrollment_secondary": 0.105005214,
        "school_enrollment_primary": 0.105666939,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.845208845,
        "demographic_pressures_indicator": 0.425287356,
        "cost_of_living": 0.452816487,
        "happiness_index": 0.486631016,
        "human_development_index": 0.736842105,
        "standard_of_living_index_by_world_population_review": 0.550733225,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002382394,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "KWT",
        "country": "Kuwait",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 38,
        "climate_resilience": 40,
        "economic_freedom": 58,
        "education": 29,
        "lifestyle": 50,
        "private_healthcare": 28,
        "safety_security": 65,
        "climate_resilience_score": 0.403883495,
        "safety_and_security": 0.741724561,
        "total_business_opportunity": 0.705112108,
        "open_for_business": 0.438970349,
        "entrepreneurship": 0.166284404,
        "gdp_2021": 0.005053675,
        "gdp_per_capita": 0.107414821,
        "gdp_growth_annual_percentage_2021": 0.487740628,
        "haq": 0.809090909,
        "domestic_private_health_expenditure_per_capita": 0.03437582,
        "domestic_private_health_expenditure": 0.12595057,
        "global_health_security_index": 0.347245409,
        "insurance_companies_number": 0.069536424,
        "number_of_private_hospitals": 0.00027907,
        "health_care_system": 0.1528,
        "health_care_index": 0.057667387,
        "insurance_companies_number_vs_population_density": 0.002465197,
        "number_of_private_hospitals_vs_population_density": 0.0000826,
        "land_area": 0.001088093,
        "innovation_index": 0.295049505,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.565217391,
        "quality_index": 0.580078125,
        "opportunity_index": 0.195747553,
        "school_enrollment_secondary": 0.119290928,
        "school_enrollment_primary": 0.428089198,
        "best_countries_for_education": 0.126,
        "economic_freedom_index": 0.679361179,
        "demographic_pressures_indicator": 0.390804598,
        "cost_of_living": 0.356513019,
        "happiness_index": 0.700534759,
        "human_development_index": 0.736842105,
        "standard_of_living_index_by_world_population_review": 0.708635758,
        "ccpi": 0.468976323,
        "population_density_per_km2": 0.009142255,
        "quality_of_life": 0.112607903
    },
    {
        "iso_code": "BGR",
        "country": "Bulgaria",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 28,
        "climate_resilience": 40,
        "economic_freedom": 71,
        "education": 32,
        "lifestyle": 49,
        "private_healthcare": 32,
        "safety_security": 69,
        "climate_resilience_score": 0.401941748,
        "safety_and_security": 0.822639967,
        "total_business_opportunity": 0.376809737,
        "open_for_business": 0.464646465,
        "entrepreneurship": 0.086238532,
        "gdp_2021": 0.003487906,
        "gdp_per_capita": 0.065713916,
        "gdp_growth_annual_percentage_2021": 0.449037487,
        "haq": 0.648484849,
        "domestic_private_health_expenditure_per_capita": 0.042874481,
        "domestic_private_health_expenditure": 0.456273764,
        "global_health_security_index": 0.732888147,
        "insurance_companies_number": 0.086092715,
        "number_of_private_hospitals": 0.000418605,
        "health_care_system": 0.036,
        "health_care_index": 0.069546436,
        "insurance_companies_number_vs_population_density": 0.011890951,
        "number_of_private_hospitals_vs_population_density": 0.000462741,
        "land_area": 0.006628835,
        "innovation_index": 0.542574257,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.004689943,
        "education_index": 0.768115942,
        "quality_index": 0.5546875,
        "opportunity_index": 0.166722916,
        "school_enrollment_secondary": 0.05265902,
        "school_enrollment_primary": 0.015139116,
        "best_countries_for_education": 0.104,
        "economic_freedom_index": 0.835380835,
        "demographic_pressures_indicator": 0.505747126,
        "cost_of_living": 0.239117881,
        "happiness_index": 0.577540107,
        "human_development_index": 0.754385965,
        "standard_of_living_index_by_world_population_review": 0.709672641,
        "ccpi": 0.513231198,
        "population_density_per_km2": 0.00233189,
        "quality_of_life": 0.147963526
    },
    {
        "iso_code": "GRD",
        "country": "Grenada",
        "cpi": true, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": 150000, "eur": 139200},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 31,
        "climate_resilience": 40,
        "economic_freedom": 64,
        "education": 34,
        "lifestyle": 46,
        "private_healthcare": 24,
        "safety_security": 65,
        "climate_resilience_score": 0.398058252,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000461,
        "gdp_per_capita": 0.055876289,
        "gdp_growth_annual_percentage_2021": 0.472137791,
        "haq": 0.45,
        "domestic_private_health_expenditure_per_capita": 0.04708112,
        "domestic_private_health_expenditure": 0.66634981,
        "global_health_security_index": 0.178631052,
        "insurance_companies_number": 0.018211921,
        "number_of_private_hospitals": 0.000093,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000435035,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.0000207,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.753623188,
        "quality_index": 0.17578125,
        "opportunity_index": 0.039149511,
        "school_enrollment_secondary": 0.657142857,
        "school_enrollment_primary": 0.791939444,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.356321839,
        "cost_of_living": 0.335246724,
        "happiness_index": 0.684135472,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.012540792,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "OMN",
        "country": "Oman",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 40,
        "economic_freedom": 57,
        "education": 26,
        "lifestyle": 49,
        "private_healthcare": 30,
        "safety_security": 62,
        "climate_resilience_score": 0.398058252,
        "safety_and_security": 0.68042501,
        "total_business_opportunity": 0.597386291,
        "open_for_business": 0.402737048,
        "entrepreneurship": 0.045642202,
        "gdp_2021": 0.003731318,
        "gdp_per_capita": 0.093412339,
        "gdp_growth_annual_percentage_2021": 0.504275583,
        "haq": 0.734848485,
        "domestic_private_health_expenditure_per_capita": 0.012325651,
        "domestic_private_health_expenditure": 0.132129278,
        "global_health_security_index": 0.385642738,
        "insurance_companies_number": 0.033112583,
        "number_of_private_hospitals": 0.000232558,
        "health_care_system": 0.032,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.017256381,
        "number_of_private_hospitals_vs_population_density": 0.000975062,
        "land_area": 0.018898579,
        "innovation_index": 0.285148515,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.003647733,
        "education_index": 0.68115942,
        "quality_index": 0.4609375,
        "opportunity_index": 0.114748566,
        "school_enrollment_secondary": 0.135349322,
        "school_enrollment_primary": 0.20212766,
        "best_countries_for_education": 0.026,
        "economic_freedom_index": 0.658476659,
        "demographic_pressures_indicator": 0.344827586,
        "cost_of_living": 0.302569245,
        "happiness_index": 0.832442068,
        "human_development_index": 0.736842105,
        "standard_of_living_index_by_world_population_review": 0.663161013,
        "ccpi": 0.437604457,
        "population_density_per_km2": 0.000559714,
        "quality_of_life": 0.054954407
    },
    {
        "iso_code": "URY",
        "country": "Uruguay",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 40,
        "economic_freedom": 70,
        "education": 29,
        "lifestyle": 49,
        "private_healthcare": 28,
        "safety_security": 64,
        "climate_resilience_score": 0.396116505,
        "safety_and_security": 0.718839395,
        "total_business_opportunity": 0.598129404,
        "open_for_business": 0.522319974,
        "entrepreneurship": 0.031307339,
        "gdp_2021": 0.002576811,
        "gdp_per_capita": 0.096763998,
        "gdp_growth_annual_percentage_2021": 0.452887538,
        "haq": 0.657575758,
        "domestic_private_health_expenditure_per_capita": 0.08399556,
        "domestic_private_health_expenditure": 0.367870722,
        "global_health_security_index": 0.405676127,
        "insurance_companies_number": 0.016556291,
        "number_of_private_hospitals": 0.000162791,
        "health_care_system": 0.01,
        "health_care_index": 0.228293737,
        "insurance_companies_number_vs_population_density": 0.00725058,
        "number_of_private_hospitals_vs_population_density": 0.000578426,
        "land_area": 0.010686997,
        "innovation_index": 0.340594059,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.005732152,
        "education_index": 0.753623188,
        "quality_index": 0.556640625,
        "opportunity_index": 0.168747891,
        "school_enrollment_secondary": 0.119603754,
        "school_enrollment_primary": 0.185556465,
        "best_countries_for_education": 0.02,
        "economic_freedom_index": 0.823095823,
        "demographic_pressures_indicator": 0.275862069,
        "cost_of_living": 0.378298005,
        "happiness_index": 0.770053476,
        "human_development_index": 0.754385965,
        "standard_of_living_index_by_world_population_review": 0.666716042,
        "ccpi": 0.432938719,
        "population_density_per_km2": 0.000674771,
        "quality_of_life": 0.102492401
    },
    {
        "iso_code": "MUS",
        "country": "Mauritius",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 375000, "eur" : 347900}
        },
        "business_opportunity": 31,
        "climate_resilience": 39,
        "economic_freedom": 71,
        "education": 31,
        "lifestyle": 43,
        "private_healthcare": 30,
        "safety_security": 69,
        "climate_resilience_score": 0.388349515,
        "safety_and_security": 0.810788721,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000482412,
        "gdp_per_capita": 0.049439269,
        "gdp_growth_annual_percentage_2021": 0.446200608,
        "haq": 0.562121212,
        "domestic_private_health_expenditure_per_capita": 0.054494197,
        "domestic_private_health_expenditure": 0.596839354,
        "global_health_security_index": 0.395659432,
        "insurance_companies_number": 0.029801325,
        "number_of_private_hospitals": 0.000418605,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000435035,
        "number_of_private_hospitals_vs_population_density": 0.0000496,
        "land_area": 0.000123928,
        "innovation_index": 0.4,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.710144928,
        "quality_index": 0.291015625,
        "opportunity_index": 0.074249072,
        "school_enrollment_secondary": 0.58915537,
        "school_enrollment_primary": 0.35413257,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.834152334,
        "demographic_pressures_indicator": 0.195402299,
        "cost_of_living": 0.255826619,
        "happiness_index": 0.67201426,
        "human_development_index": 0.719298246,
        "standard_of_living_index_by_world_population_review": 0.613242483,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.023601037,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "CRI",
        "country": "Costa Rica",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 38,
        "climate_resilience": 39,
        "economic_freedom": 65,
        "education": 22,
        "lifestyle": 50,
        "private_healthcare": 26,
        "safety_security": 65,
        "climate_resilience_score": 0.386407767,
        "safety_and_security": 0.744585206,
        "total_business_opportunity": 0.598129404,
        "open_for_business": 0.704138156,
        "entrepreneurship": 0.026605505,
        "gdp_2021": 0.002792626,
        "gdp_per_capita": 0.070750773,
        "gdp_growth_annual_percentage_2021": 0.517933131,
        "haq": 0.671212121,
        "domestic_private_health_expenditure_per_capita": 0.038003074,
        "domestic_private_health_expenditure": 0.297290875,
        "global_health_security_index": 0.414023372,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.008,
        "health_care_index": 0.142764579,
        "insurance_companies_number_vs_population_density": 0.000725058,
        "number_of_private_hospitals_vs_population_density": 0.0000496,
        "land_area": 0.003117785,
        "innovation_index": 0.386138614,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.025534132,
        "education_index": 0.695652174,
        "quality_index": 0.171875,
        "opportunity_index": 0.033412082,
        "school_enrollment_secondary": 0.090302398,
        "school_enrollment_primary": 0.091141571,
        "best_countries_for_education": 0.015,
        "economic_freedom_index": 0.766584767,
        "demographic_pressures_indicator": 0.218390805,
        "cost_of_living": 0.508143435,
        "happiness_index": 0.754010695,
        "human_development_index": 0.736842105,
        "standard_of_living_index_by_world_population_review": 0.66523478,
        "ccpi": 0.432938719,
        "population_density_per_km2": 0.003740669,
        "quality_of_life": 0.134346505
    },
    {
        "iso_code": "ROU",
        "country": "Romania",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 28,
        "climate_resilience": 39,
        "economic_freedom": 67,
        "education": 29,
        "lifestyle": 50,
        "private_healthcare": 27,
        "safety_security": 67,
        "climate_resilience_score": 0.382524272,
        "safety_and_security": 0.782182264,
        "total_business_opportunity": 0.400256246,
        "open_for_business": 0.463994787,
        "entrepreneurship": 0.072477064,
        "gdp_2021": 0.012351018,
        "gdp_per_capita": 0.084318206,
        "gdp_growth_annual_percentage_2021": 0.483485309,
        "haq": 0.693939394,
        "domestic_private_health_expenditure_per_capita": 0.021778773,
        "domestic_private_health_expenditure": 0.206986692,
        "global_health_security_index": 0.495826377,
        "insurance_companies_number": 0.016556291,
        "number_of_private_hospitals": 0.003023256,
        "health_care_system": 0.051,
        "health_care_index": 0.062634989,
        "insurance_companies_number_vs_population_density": 0.001740139,
        "number_of_private_hospitals_vs_population_density": 0.002578129,
        "land_area": 0.014049056,
        "innovation_index": 0.407920792,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.005211047,
        "education_index": 0.753623188,
        "quality_index": 0.5625,
        "opportunity_index": 0.169760378,
        "school_enrollment_secondary": 0.012200209,
        "school_enrollment_primary": 0.014013912,
        "best_countries_for_education": 0.067,
        "economic_freedom_index": 0.787469288,
        "demographic_pressures_indicator": 0.402298851,
        "cost_of_living": 0.197793838,
        "happiness_index": 0.778966132,
        "human_development_index": 0.771929825,
        "standard_of_living_index_by_world_population_review": 0.704043845,
        "ccpi": 0.577994429,
        "population_density_per_km2": 0.003073493,
        "quality_of_life": 0.137264438
    },
    {
        "iso_code": "MNE",
        "country": "Montenegro",
        "cpi": true, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": 473800, "eur": 450000},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 32,
        "climate_resilience": 39,
        "economic_freedom": 58,
        "education": 25,
        "lifestyle": 39,
        "private_healthcare": 35,
        "safety_security": 64,
        "climate_resilience_score": 0.378640777,
        "safety_and_security": 0.716387413,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000249872,
        "gdp_per_capita": 0.052638494,
        "gdp_growth_annual_percentage_2021": 0.61621074,
        "haq": 0.789393939,
        "domestic_private_health_expenditure_per_capita": 0.043312069,
        "domestic_private_health_expenditure": 0.436311787,
        "global_health_security_index": 0.469115192,
        "insurance_companies_number": 0.006622517,
        "number_of_private_hospitals": 0.000325581,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001305104,
        "number_of_private_hospitals_vs_population_density": 0.000495794,
        "land_area": 0.000821253,
        "innovation_index": 0.403960396,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.797101449,
        "quality_index": 0.3203125,
        "opportunity_index": 0.084373945,
        "school_enrollment_secondary": 0.002502607,
        "school_enrollment_primary": 0.003682488,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.673218673,
        "demographic_pressures_indicator": 0.356321839,
        "cost_of_living": 0.352536395,
        "happiness_index": 0.631016043,
        "human_development_index": 0.771929825,
        "standard_of_living_index_by_world_population_review": 0.103836469,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.00166965,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "ARM",
        "country": "Armenia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 38,
        "economic_freedom": 65,
        "education": 26,
        "lifestyle": 40,
        "private_healthcare": 40,
        "safety_security": 60,
        "climate_resilience_score": 0.374757282,
        "safety_and_security": 0.638332652,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00060002,
        "gdp_per_capita": 0.025558804,
        "gdp_growth_annual_percentage_2021": 0.479837893,
        "haq": 0.589393939,
        "domestic_private_health_expenditure_per_capita": 0.068600694,
        "domestic_private_health_expenditure": 1,
        "global_health_security_index": 0.76460768,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000725058,
        "number_of_private_hospitals_vs_population_density": 0.0000331,
        "land_area": 0.001738401,
        "innovation_index": 0.324752475,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.710144928,
        "quality_index": 0.4828125,
        "opportunity_index": 0.24400945,
        "school_enrollment_secondary": 0.024817518,
        "school_enrollment_primary": 0.023629296,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.765356265,
        "demographic_pressures_indicator": 0.321839081,
        "cost_of_living": 0.248452574,
        "happiness_index": 0.556149733,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.445415494,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.00387737,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "ARG",
        "country": "Argentina",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 19,
        "climate_resilience": 38,
        "economic_freedom": 50,
        "education": 32,
        "lifestyle": 49,
        "private_healthcare": 36,
        "safety_security": 62,
        "climate_resilience_score": 0.366990291,
        "safety_and_security": 0.67143441,
        "total_business_opportunity": 0.157335042,
        "open_for_business": 0.278592375,
        "entrepreneurship": 0.100458716,
        "gdp_2021": 0.021370187,
        "gdp_per_capita": 0.060492049,
        "gdp_growth_annual_percentage_2021": 0.572239108,
        "haq": 0.603030303,
        "domestic_private_health_expenditure_per_capita": 0.053340001,
        "domestic_private_health_expenditure": 0.415280418,
        "global_health_security_index": 0.641068447,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.081395349,
        "health_care_system": 0.031,
        "health_care_index": 0.318142549,
        "insurance_companies_number_vs_population_density": 0.002610209,
        "number_of_private_hospitals_vs_population_density": 0.345568428,
        "land_area": 0.167107001,
        "innovation_index": 0.293069307,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.027618551,
        "education_index": 0.884057971,
        "quality_index": 0.47265625,
        "opportunity_index": 0.119811002,
        "school_enrollment_secondary": 0.280500521,
        "school_enrollment_primary": 0.270969722,
        "best_countries_for_education": 0.058,
        "economic_freedom_index": 0.578624079,
        "demographic_pressures_indicator": 0.494252874,
        "cost_of_living": 0.12777067,
        "happiness_index": 0.664884136,
        "human_development_index": 0.807017544,
        "standard_of_living_index_by_world_population_review": 0.746259813,
        "ccpi": 0.48485376,
        "population_density_per_km2": 0.000554398,
        "quality_of_life": 0.088145897
    },
    {
        "iso_code": "MKD",
        "country": "North Macedonia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 38,
        "economic_freedom": 66,
        "education": 26,
        "lifestyle": 42,
        "private_healthcare": 29,
        "safety_security": 66,
        "climate_resilience_score": 0.365048544,
        "safety_and_security": 0.756027789,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000600806,
        "gdp_per_capita": 0.037382808,
        "gdp_growth_annual_percentage_2021": 0.444579534,
        "haq": 0.718181818,
        "domestic_private_health_expenditure_per_capita": 0.026744711,
        "domestic_private_health_expenditure": 0.458531369,
        "global_health_security_index": 0.437395659,
        "insurance_companies_number": 0.026490066,
        "number_of_private_hospitals": 0.008418605,
        "health_care_system": 0.0696,
        "health_care_index": 0.10237581,
        "insurance_companies_number_vs_population_density": 0.002900232,
        "number_of_private_hospitals_vs_population_density": 0.007304698,
        "land_area": 0.00153995,
        "innovation_index": 0.378217822,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.652173913,
        "quality_index": 0.4828125,
        "opportunity_index": 0.24400945,
        "school_enrollment_secondary": 0.014807091,
        "school_enrollment_primary": 0.006546645,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.77027027,
        "demographic_pressures_indicator": 0.367816092,
        "cost_of_living": 0.14298558,
        "happiness_index": 0.59714795,
        "human_development_index": 0.666666667,
        "standard_of_living_index_by_world_population_review": 0.599466746,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.003027926,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "LCA",
        "country": "St. Lucia",
        "cpi": true, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": 100000, "eur": 92800},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 31,
        "climate_resilience": 38,
        "economic_freedom": 64,
        "education": 26,
        "lifestyle": 48,
        "private_healthcare": 27,
        "safety_security": 65,
        "climate_resilience_score": 0.363106796,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000074,
        "gdp_per_capita": 0.053814501,
        "gdp_growth_annual_percentage_2021": 0.498074975,
        "haq": 0.513636364,
        "domestic_private_health_expenditure_per_capita": 0.038891972,
        "domestic_private_health_expenditure": 0.58365019,
        "global_health_security_index": 0.312186978,
        "insurance_companies_number": 0.029801325,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.00087007,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000372,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.608695652,
        "quality_index": 0.53203125,
        "opportunity_index": 0.256901789,
        "school_enrollment_secondary": 0.031386861,
        "school_enrollment_primary": 0.063113748,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.753071253,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.351153221,
        "happiness_index": 0.684135472,
        "human_development_index": 0.649122807,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.01139782,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "BHR",
        "country": "Bahrain",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 37,
        "climate_resilience": 38,
        "economic_freedom": 62,
        "education": 31,
        "lifestyle": 51,
        "private_healthcare": 32,
        "safety_security": 58,
        "climate_resilience_score": 0.361165049,
        "safety_and_security": 0.600326931,
        "total_business_opportunity": 0.657655349,
        "open_for_business": 0.505571848,
        "entrepreneurship": 0.146376147,
        "gdp_2021": 0.001687489,
        "gdp_per_capita": 0.126810918,
        "gdp_growth_annual_percentage_2021": 0.40952381,
        "haq": 0.763636364,
        "domestic_private_health_expenditure_per_capita": 0.057906469,
        "domestic_private_health_expenditure": 0.455798479,
        "global_health_security_index": 0.338898164,
        "insurance_companies_number": 0.248344371,
        "number_of_private_hospitals": 0.000511628,
        "health_care_system": 0.0878,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001015081,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.0000476,
        "innovation_index": 0.273267327,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.008337676,
        "education_index": 0.753623188,
        "quality_index": 0.529296875,
        "opportunity_index": 0.154235572,
        "school_enrollment_secondary": 0.26548488,
        "school_enrollment_primary": 0.377557283,
        "best_countries_for_education": 0.083,
        "economic_freedom_index": 0.724815725,
        "demographic_pressures_indicator": 0.356321839,
        "cost_of_living": 0.375704554,
        "happiness_index": 0.711229947,
        "human_development_index": 0.807017544,
        "standard_of_living_index_by_world_population_review": 0.669678566,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.08503026,
        "quality_of_life": 0.145702128
    },
    {
        "iso_code": "DMA",
        "country": "Dominica",
        "cpi": true, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": 100000, "eur": 92800},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 31,
        "climate_resilience": 38,
        "economic_freedom": 54,
        "education": 26,
        "lifestyle": 40,
        "private_healthcare": 22,
        "safety_security": 65,
        "climate_resilience_score": 0.359223301,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000021,
        "gdp_per_capita": 0.042220359,
        "gdp_growth_annual_percentage_2021": 0.496859169,
        "haq": 0.446969697,
        "domestic_private_health_expenditure_per_capita": 0.022782023,
        "domestic_private_health_expenditure": 0.384743346,
        "global_health_security_index": 0.173622705,
        "insurance_companies_number": 0.033112583,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.003045244,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.0000458,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.550724638,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.13632951,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.631449631,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.459732356,
        "happiness_index": 0.684135472,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.039105318,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.003572831,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "UKR",
        "country": "Ukraine",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 26,
        "climate_resilience": 37,
        "economic_freedom": 54,
        "education": 31,
        "lifestyle": 42,
        "private_healthcare": 26,
        "safety_security": 41,
        "climate_resilience_score": 0.355339806,
        "safety_and_security": 0.23825092,
        "total_business_opportunity": 0.552081999,
        "open_for_business": 0.240795047,
        "entrepreneurship": 0.074426606,
        "gdp_2021": 0.008698126,
        "gdp_per_capita": 0.026513307,
        "gdp_growth_annual_percentage_2021": 0.433232016,
        "haq": 0.668181818,
        "domestic_private_health_expenditure_per_capita": 0.020043667,
        "domestic_private_health_expenditure": 0.618940114,
        "global_health_security_index": 0.38230384,
        "insurance_companies_number": 0.185430464,
        "number_of_private_hospitals": 0.003837209,
        "health_care_system": 0.042,
        "health_care_index": 0.020734341,
        "insurance_companies_number_vs_population_density": 0.021461717,
        "number_of_private_hospitals_vs_population_density": 0.00360277,
        "land_area": 0.03537914,
        "innovation_index": 0.407920792,
        "number_of_universities_in_top_1000": 0.055248619,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.797101449,
        "quality_index": 0.528125,
        "opportunity_index": 0.254134323,
        "school_enrollment_secondary": 0.004796663,
        "school_enrollment_primary": 0.008694763,
        "best_countries_for_education": 0.105,
        "economic_freedom_index": 0.627764128,
        "demographic_pressures_indicator": 0.402298851,
        "cost_of_living": 0.112901553,
        "happiness_index": 0.557932264,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.700785069,
        "ccpi": 0.716747911,
        "population_density_per_km2": 0.002790218,
        "quality_of_life": 0.072826748
    },
    {
        "iso_code": "BHS",
        "country": "Bahamas",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 37,
        "economic_freedom": 69,
        "education": 27,
        "lifestyle": 57,
        "private_healthcare": 28,
        "safety_security": 65,
        "climate_resilience_score": 0.339805825,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00048467,
        "gdp_per_capita": 0.16144333,
        "gdp_growth_annual_percentage_2021": 0.642350557,
        "haq": 0.616969697,
        "domestic_private_health_expenditure_per_capita": 0.144676978,
        "domestic_private_health_expenditure": 0.535765209,
        "global_health_security_index": 0.235392321,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001160093,
        "number_of_private_hospitals_vs_population_density": 0.0000826,
        "land_area": 0.000611201,
        "innovation_index": 0.356039604,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.710144928,
        "quality_index": 0.29296875,
        "opportunity_index": 0.075261559,
        "school_enrollment_secondary": 0.294786236,
        "school_enrollment_primary": 0.231894435,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.807125307,
        "demographic_pressures_indicator": 0.609195402,
        "cost_of_living": 0.660638335,
        "happiness_index": 0.684135472,
        "human_development_index": 0.736842105,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001424348,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MNG",
        "country": "Mongolia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 23,
        "climate_resilience": 36,
        "economic_freedom": 64,
        "education": 29,
        "lifestyle": 41,
        "private_healthcare": 28,
        "safety_security": 65,
        "climate_resilience_score": 0.33592233,
        "safety_and_security": 0.727012669,
        "total_business_opportunity": 0.182575272,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000653805,
        "gdp_per_capita": 0.024779969,
        "gdp_growth_annual_percentage_2021": 0.393110436,
        "haq": 0.453030303,
        "domestic_private_health_expenditure_per_capita": 0.008943873,
        "domestic_private_health_expenditure": 0.425499049,
        "global_health_security_index": 0.417362271,
        "insurance_companies_number": 0.024834437,
        "number_of_private_hospitals": 0.005581395,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.101798144,
        "number_of_private_hospitals_vs_population_density": 0.18552612,
        "land_area": 0.095088659,
        "innovation_index": 0.38019802,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.710144928,
        "quality_index": 0.4828125,
        "opportunity_index": 0.24400945,
        "school_enrollment_secondary": 0.166882169,
        "school_enrollment_primary": 0.059226678,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.748157248,
        "demographic_pressures_indicator": 0.425287356,
        "cost_of_living": 0.207994744,
        "happiness_index": 0.631016043,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.478299511,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MAR",
        "country": "Morocco",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 34,
        "climate_resilience": 36,
        "economic_freedom": 59,
        "education": 24,
        "lifestyle": 41,
        "private_healthcare": 20,
        "safety_security": 61,
        "climate_resilience_score": 0.333980583,
        "safety_and_security": 0.647731917,
        "total_business_opportunity": 0.592901986,
        "open_for_business": 0.573802542,
        "entrepreneurship": 0.027637615,
        "gdp_2021": 0.005768914,
        "gdp_per_capita": 0.018794661,
        "gdp_growth_annual_percentage_2021": 0.513677812,
        "haq": 0.495454546,
        "domestic_private_health_expenditure_per_capita": 0.015193606,
        "domestic_private_health_expenditure": 0.676924905,
        "global_health_security_index": 0.293823038,
        "insurance_companies_number": 0.03807947,
        "number_of_private_hospitals": 0.008372093,
        "health_care_system": 0.027,
        "health_care_index": 0.012742981,
        "insurance_companies_number_vs_population_density": 0.003915313,
        "number_of_private_hospitals_vs_population_density": 0.007106381,
        "land_area": 0.027251824,
        "innovation_index": 0.283168317,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.007816571,
        "education_index": 0.463768116,
        "quality_index": 0.5515625,
        "opportunity_index": 0.271684104,
        "school_enrollment_secondary": 0.106777894,
        "school_enrollment_primary": 0.173997545,
        "best_countries_for_education": 0.022,
        "economic_freedom_index": 0.69041769,
        "demographic_pressures_indicator": 0.390804598,
        "cost_of_living": 0.131401501,
        "happiness_index": 0.561497326,
        "human_development_index": 0.52631579,
        "standard_of_living_index_by_world_population_review": 0.713079544,
        "ccpi": 0.911733983,
        "population_density_per_km2": 0.003096276,
        "quality_of_life": 0.124741641
    },
    {
        "iso_code": "ZAF",
        "country": "South Africa",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 24,
        "climate_resilience": 36,
        "economic_freedom": 56,
        "education": 24,
        "lifestyle": 49,
        "private_healthcare": 23,
        "safety_security": 54,
        "climate_resilience_score": 0.332038835,
        "safety_and_security": 0.519411524,
        "total_business_opportunity": 0.285714286,
        "open_for_business": 0.386770935,
        "entrepreneurship": 0.121444954,
        "gdp_2021": 0.018258943,
        "gdp_per_capita": 0.038958523,
        "gdp_growth_annual_percentage_2021": 0.463829787,
        "haq": 0.354545455,
        "domestic_private_health_expenditure_per_capita": 0.032867894,
        "domestic_private_health_expenditure": 0.447956274,
        "global_health_security_index": 0.497495826,
        "insurance_companies_number": 0.091059603,
        "number_of_private_hospitals": 0.005,
        "health_care_system": 0.02,
        "health_care_index": 0.134557235,
        "insurance_companies_number_vs_population_density": 0.016096288,
        "number_of_private_hospitals_vs_population_density": 0.007172487,
        "land_area": 0.074073348,
        "innovation_index": 0.35049505,
        "number_of_universities_in_top_1000": 0.055248619,
        "number_of_top_tier_international_schools": 0.006253257,
        "education_index": 0.68115942,
        "quality_index": 0.35546875,
        "opportunity_index": 0.094836315,
        "school_enrollment_secondary": 0.051616267,
        "school_enrollment_primary": 0.04858838,
        "best_countries_for_education": 0.036,
        "economic_freedom_index": 0.653562654,
        "demographic_pressures_indicator": 0.75862069,
        "cost_of_living": 0.224247035,
        "happiness_index": 0.609625668,
        "human_development_index": 0.561403509,
        "standard_of_living_index_by_world_population_review": 0.687157458,
        "ccpi": 0.555362117,
        "population_density_per_km2": 0.001798377,
        "quality_of_life": 0.072583587
    },
    {
        "iso_code": "AZE",
        "country": "Azerbaijan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 27,
        "climate_resilience": 36,
        "economic_freedom": 62,
        "education": 22,
        "lifestyle": 38,
        "private_healthcare": 22,
        "safety_security": 51,
        "climate_resilience_score": 0.330097087,
        "safety_and_security": 0.456477319,
        "total_business_opportunity": 0.529762973,
        "open_for_business": 0.370153144,
        "entrepreneurship": 0.0125,
        "gdp_2021": 0.002372543,
        "gdp_per_capita": 0.029675346,
        "gdp_growth_annual_percentage_2021": 0.47781155,
        "haq": 0.543939394,
        "domestic_private_health_expenditure_per_capita": 0.019423116,
        "domestic_private_health_expenditure": 0.77851711,
        "global_health_security_index": 0.312186978,
        "insurance_companies_number": 0.052980132,
        "number_of_private_hospitals": 0.015255814,
        "health_care_system": 0.013,
        "health_care_index": 0.009935205,
        "insurance_companies_number_vs_population_density": 0.003770302,
        "number_of_private_hospitals_vs_population_density": 0.008825133,
        "land_area": 0.005046969,
        "innovation_index": 0.265346535,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.003647733,
        "education_index": 0.666666667,
        "quality_index": 0.390625,
        "opportunity_index": 0.095511306,
        "school_enrollment_secondary": 0.133472367,
        "school_enrollment_primary": 0.007160393,
        "best_countries_for_education": 0.007,
        "economic_freedom_index": 0.71990172,
        "demographic_pressures_indicator": 0.298850575,
        "cost_of_living": 0.154223867,
        "happiness_index": 0.532976827,
        "human_development_index": 0.649122807,
        "standard_of_living_index_by_world_population_review": 0.584505999,
        "ccpi": 0.432938719,
        "population_density_per_km2": 0.004579481,
        "quality_of_life": 0.039148936
    },
    {
        "iso_code": "SRB",
        "country": "Serbia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 36,
        "economic_freedom": 65,
        "education": 28,
        "lifestyle": 44,
        "private_healthcare": 28,
        "safety_security": 63,
        "climate_resilience_score": 0.32815534,
        "safety_and_security": 0.703718839,
        "total_business_opportunity": 0.598129404,
        "open_for_business": 0.411534702,
        "entrepreneurship": 0.0375,
        "gdp_2021": 0.002739821,
        "gdp_per_capita": 0.051761995,
        "gdp_growth_annual_percentage_2021": 0.51408308,
        "haq": 0.709090909,
        "domestic_private_health_expenditure_per_capita": 0.038513847,
        "domestic_private_health_expenditure": 0.446411597,
        "global_health_security_index": 0.484140234,
        "insurance_companies_number": 0.011589404,
        "number_of_private_hospitals": 0.00127907,
        "health_care_system": 0.03,
        "health_care_index": 0.042116631,
        "insurance_companies_number_vs_population_density": 0.001305104,
        "number_of_private_hospitals_vs_population_density": 0.001156853,
        "land_area": 0.005340432,
        "innovation_index": 0.396039604,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.003647733,
        "education_index": 0.768115942,
        "quality_index": 0.55078125,
        "opportunity_index": 0.16638542,
        "school_enrollment_secondary": 0.007090719,
        "school_enrollment_primary": 0.001943535,
        "best_countries_for_education": 0.038,
        "economic_freedom_index": 0.764127764,
        "demographic_pressures_indicator": 0.356321839,
        "cost_of_living": 0.174625679,
        "happiness_index": 0.725490196,
        "human_development_index": 0.736842105,
        "standard_of_living_index_by_world_population_review": 0.630721375,
        "ccpi": 0.432938719,
        "population_density_per_km2": 0.002890086,
        "quality_of_life": 0.03100304
    },
    {
        "iso_code": "IRN",
        "country": "Iran",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 36,
        "economic_freedom": 42,
        "education": 30,
        "lifestyle": 44,
        "private_healthcare": 24,
        "safety_security": 46,
        "climate_resilience_score": 0.32815534,
        "safety_and_security": 0.354311402,
        "total_business_opportunity": 0.465086483,
        "open_for_business": 0.476637341,
        "entrepreneurship": 0.075917431,
        "gdp_2021": 0.022352713,
        "gdp_per_capita": 0.028079268,
        "gdp_growth_annual_percentage_2021": 0.532077001,
        "haq": 0.643939394,
        "domestic_private_health_expenditure_per_capita": 0.035621497,
        "domestic_private_health_expenditure": 0.570817491,
        "global_health_security_index": 0.342237062,
        "insurance_companies_number": 0.003311258,
        "number_of_private_hospitals": 0.00044186,
        "health_care_system": 0.0184,
        "health_care_index": 0.040172786,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.000594953,
        "land_area": 0.099454878,
        "innovation_index": 0.354455446,
        "number_of_universities_in_top_1000": 0.171270718,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.739130435,
        "quality_index": 0.403125,
        "opportunity_index": 0.169085386,
        "school_enrollment_secondary": 0.257518248,
        "school_enrollment_primary": 0.148567921,
        "best_countries_for_education": 0.022,
        "economic_freedom_index": 0.484029484,
        "demographic_pressures_indicator": 0.597701149,
        "cost_of_living": 0.173934092,
        "happiness_index": 0.465240642,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.615168123,
        "ccpi": 0.111942897,
        "population_density_per_km2": 0.001900902,
        "quality_of_life": 0.115866261
    },
    {
        "iso_code": "SYC",
        "country": "Seychelles",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 36,
        "economic_freedom": 61,
        "education": 27,
        "lifestyle": 39,
        "private_healthcare": 26,
        "safety_security": 65,
        "climate_resilience_score": 0.32815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000547,
        "gdp_per_capita": 0.07535212,
        "gdp_growth_annual_percentage_2021": 0.401823708,
        "haq": 0.568181818,
        "domestic_private_health_expenditure_per_capita": 0.034325505,
        "domestic_private_health_expenditure": 0.29503327,
        "global_health_security_index": 0.263772955,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.000325581,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000290023,
        "number_of_private_hospitals_vs_population_density": 0.0000992,
        "land_area": 0.0000281,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.695652174,
        "quality_index": 0.48828125,
        "opportunity_index": 0.131623355,
        "school_enrollment_secondary": 0.133576642,
        "school_enrollment_primary": 0.119067103,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.713759214,
        "demographic_pressures_indicator": 0.367816092,
        "cost_of_living": 0.39852692,
        "happiness_index": 0.684135472,
        "human_development_index": 0.719298246,
        "standard_of_living_index_by_world_population_review": 0.047252259,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.008107884,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "TUN",
        "country": "Tunisia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 36,
        "economic_freedom": 54,
        "education": 23,
        "lifestyle": 38,
        "private_healthcare": 23,
        "safety_security": 60,
        "climate_resilience_score": 0.326213592,
        "safety_and_security": 0.636697998,
        "total_business_opportunity": 0.530890455,
        "open_for_business": 0.524926686,
        "entrepreneurship": 0.018463303,
        "gdp_2021": 0.002034131,
        "gdp_per_capita": 0.021259789,
        "gdp_growth_annual_percentage_2021": 0.432016211,
        "haq": 0.628787879,
        "domestic_private_health_expenditure_per_capita": 0.014515116,
        "domestic_private_health_expenditure": 0.475998099,
        "global_health_security_index": 0.258764608,
        "insurance_companies_number": 0.036423841,
        "number_of_private_hospitals": 0.001883721,
        "health_care_system": 0.022,
        "health_care_index": 0.11425486,
        "insurance_companies_number_vs_population_density": 0.004205336,
        "number_of_private_hospitals_vs_population_density": 0.001735279,
        "land_area": 0.009486524,
        "innovation_index": 0.310891089,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.594202899,
        "quality_index": 0.4765625,
        "opportunity_index": 0.12723591,
        "school_enrollment_secondary": 0.11434828,
        "school_enrollment_primary": 0.067307692,
        "best_countries_for_education": 0.005,
        "economic_freedom_index": 0.628992629,
        "demographic_pressures_indicator": 0.379310345,
        "cost_of_living": 0.104775407,
        "happiness_index": 0.413547237,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.710857651,
        "ccpi": 0.4045961,
        "population_density_per_km2": 0.002836165,
        "quality_of_life": 0.065531915
    },
    {
        "iso_code": "COL",
        "country": "Colombia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 21,
        "climate_resilience": 36,
        "economic_freedom": 65,
        "education": 22,
        "lifestyle": 48,
        "private_healthcare": 32,
        "safety_security": 45,
        "climate_resilience_score": 0.324271845,
        "safety_and_security": 0.337147528,
        "total_business_opportunity": 0.306598334,
        "open_for_business": 0.305962854,
        "entrepreneurship": 0.038302752,
        "gdp_2021": 0.013665805,
        "gdp_per_capita": 0.033983181,
        "gdp_growth_annual_percentage_2021": 0.578318136,
        "haq": 0.593939394,
        "domestic_private_health_expenditure_per_capita": 0.020645923,
        "domestic_private_health_expenditure": 0.30513308,
        "global_health_security_index": 0.621035058,
        "insurance_companies_number": 0.079470199,
        "number_of_private_hospitals": 0.010465116,
        "health_care_system": 0.013,
        "health_care_index": 0.265658747,
        "insurance_companies_number_vs_population_density": 0.015081207,
        "number_of_private_hospitals_vs_population_density": 0.016096779,
        "land_area": 0.067747963,
        "innovation_index": 0.330693069,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.031787389,
        "education_index": 0.623188406,
        "quality_index": 0.1328125,
        "opportunity_index": 0.020587243,
        "school_enrollment_secondary": 0.212200209,
        "school_enrollment_primary": 0.201513912,
        "best_countries_for_education": 0.015,
        "economic_freedom_index": 0.762899263,
        "demographic_pressures_indicator": 0.781609195,
        "cost_of_living": 0.121546388,
        "happiness_index": 0.554367201,
        "human_development_index": 0.666666667,
        "standard_of_living_index_by_world_population_review": 0.675603614,
        "ccpi": 0.67270195,
        "population_density_per_km2": 0.001673447,
        "quality_of_life": 0.075744681
    },
    {
        "iso_code": "PAN",
        "country": "Panama",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 100000, "eur" : 92800}
        },
        "business_opportunity": 42,
        "climate_resilience": 36,
        "economic_freedom": 65,
        "education": 26,
        "lifestyle": 55,
        "private_healthcare": 28,
        "safety_security": 62,
        "climate_resilience_score": 0.322330097,
        "safety_and_security": 0.685737638,
        "total_business_opportunity": 0.598129404,
        "open_for_business": 0.771912675,
        "entrepreneurship": 0.063073395,
        "gdp_2021": 0.00276317,
        "gdp_per_capita": 0.082326582,
        "gdp_growth_annual_percentage_2021": 0.675177305,
        "haq": 0.542424242,
        "domestic_private_health_expenditure_per_capita": 0.060873529,
        "domestic_private_health_expenditure": 0.372504753,
        "global_health_security_index": 0.626043406,
        "insurance_companies_number": 0.03807947,
        "number_of_private_hospitals": 0.000302326,
        "health_care_system": 0.005,
        "health_care_index": 0.123326134,
        "insurance_companies_number_vs_population_density": 0.005655452,
        "number_of_private_hospitals_vs_population_density": 0.000363582,
        "land_area": 0.004529349,
        "innovation_index": 0.257425743,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.652173913,
        "quality_index": 0.54453125,
        "opportunity_index": 0.263854202,
        "school_enrollment_secondary": 0.065213764,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.027,
        "economic_freedom_index": 0.766584767,
        "demographic_pressures_indicator": 0.402298851,
        "cost_of_living": 0.594591791,
        "happiness_index": 0.778966132,
        "human_development_index": 0.754385965,
        "standard_of_living_index_by_world_population_review": 0.687305584,
        "ccpi": 0.432938719,
        "population_density_per_km2": 0.002161773,
        "quality_of_life": 0.072583587
    },
    {
        "iso_code": "PER",
        "country": "Peru",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 28,
        "climate_resilience": 35,
        "economic_freedom": 67,
        "education": 32,
        "lifestyle": 50,
        "private_healthcare": 30,
        "safety_security": 58,
        "climate_resilience_score": 0.314563107,
        "safety_and_security": 0.597874949,
        "total_business_opportunity": 0.354644459,
        "open_for_business": 0.536982731,
        "entrepreneurship": 0.019266055,
        "gdp_2021": 0.009705429,
        "gdp_per_capita": 0.037217632,
        "gdp_growth_annual_percentage_2021": 0.63485309,
        "haq": 0.621212121,
        "domestic_private_health_expenditure_per_capita": 0.020243403,
        "domestic_private_health_expenditure": 0.409576996,
        "global_health_security_index": 0.649415693,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.009534884,
        "health_care_system": 0.016,
        "health_care_index": 0.093304536,
        "insurance_companies_number_vs_population_density": 0.00275522,
        "number_of_private_hospitals_vs_population_density": 0.025996133,
        "land_area": 0.078158989,
        "innovation_index": 0.320792079,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.03960396,
        "education_index": 0.710144928,
        "quality_index": 0.571484375,
        "opportunity_index": 0.297401283,
        "school_enrollment_secondary": 0.280500521,
        "school_enrollment_primary": 0.26544599,
        "best_countries_for_education": 0.02,
        "economic_freedom_index": 0.78009828,
        "demographic_pressures_indicator": 0.75862069,
        "cost_of_living": 0.157336008,
        "happiness_index": 0.625668449,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.699451933,
        "ccpi": 0.487256267,
        "population_density_per_km2": 0.000908302,
        "quality_of_life": 0.093495441
    },
    {
        "iso_code": "JOR",
        "country": "Jordan",
        "cpi": true, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": 750000, "eur": 695900},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 23,
        "climate_resilience": 35,
        "economic_freedom": 60,
        "education": 21,
        "lifestyle": 41,
        "private_healthcare": 31,
        "safety_security": 63,
        "climate_resilience_score": 0.312621359,
        "safety_and_security": 0.696771557,
        "total_business_opportunity": 0.318001281,
        "open_for_business": 0.41544477,
        "entrepreneurship": 0.029816514,
        "gdp_2021": 0.001964711,
        "gdp_per_capita": 0.024035783,
        "gdp_growth_annual_percentage_2021": 0.409118541,
        "haq": 0.725757576,
        "domestic_private_health_expenditure_per_capita": 0.022684443,
        "domestic_private_health_expenditure": 0.513902091,
        "global_health_security_index": 0.447412354,
        "insurance_companies_number": 0.039735099,
        "number_of_private_hospitals": 0.00155814,
        "health_care_system": 0.05,
        "health_care_index": 0.206695464,
        "insurance_companies_number_vs_population_density": 0.003045244,
        "number_of_private_hospitals_vs_population_density": 0.000958535,
        "land_area": 0.005421034,
        "innovation_index": 0.263366337,
        "number_of_universities_in_top_1000": 0.055248619,
        "number_of_top_tier_international_schools": 0.0109432,
        "education_index": 0.608695652,
        "quality_index": 0.0234375,
        "opportunity_index": 0.009449882,
        "school_enrollment_secondary": 0.224087591,
        "school_enrollment_primary": 0.352291326,
        "best_countries_for_education": 0.04,
        "economic_freedom_index": 0.701474202,
        "demographic_pressures_indicator": 0.609195402,
        "cost_of_living": 0.30758325,
        "happiness_index": 0.308377897,
        "human_development_index": 0.596491228,
        "standard_of_living_index_by_world_population_review": 0.586579766,
        "ccpi": 0.4045961,
        "population_density_per_km2": 0.004311016,
        "quality_of_life": 0.06443769
    },
    {
        "iso_code": "TTO",
        "country": "Trinidad and Tobago",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 35,
        "economic_freedom": 59,
        "education": 25,
        "lifestyle": 48,
        "private_healthcare": 28,
        "safety_security": 60,
        "climate_resilience_score": 0.312621359,
        "safety_and_security": 0.633020025,
        "total_business_opportunity": 0.575631006,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000927495,
        "gdp_per_capita": 0.086515997,
        "gdp_growth_annual_percentage_2021": 0.344275583,
        "haq": 0.507575758,
        "domestic_private_health_expenditure_per_capita": 0.095497875,
        "domestic_private_health_expenditure": 0.6121673,
        "global_health_security_index": 0.347245409,
        "insurance_companies_number": 0.03807947,
        "number_of_private_hospitals": 0.000093,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001160093,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.00031322,
        "innovation_index": 0.194059406,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.695652174,
        "quality_index": 0.48046875,
        "opportunity_index": 0.127573405,
        "school_enrollment_secondary": 0.134264859,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.685503686,
        "demographic_pressures_indicator": 0.310344828,
        "cost_of_living": 0.418582939,
        "happiness_index": 0.714795009,
        "human_development_index": 0.719298246,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.010306491,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "KGZ",
        "country": "Kyrgyzstan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 35,
        "economic_freedom": 56,
        "education": 23,
        "lifestyle": 36,
        "private_healthcare": 28,
        "safety_security": 59,
        "climate_resilience_score": 0.312621359,
        "safety_and_security": 0.62362076,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000368773,
        "gdp_per_capita": 0.005992688,
        "gdp_growth_annual_percentage_2021": 0.437487335,
        "haq": 0.481818182,
        "domestic_private_health_expenditure_per_capita": 0.003796496,
        "domestic_private_health_expenditure": 0.520674905,
        "global_health_security_index": 0.440734558,
        "insurance_companies_number": 0.016556291,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.004205336,
        "number_of_private_hospitals_vs_population_density": 0.0000496,
        "land_area": 0.011711613,
        "innovation_index": 0.188118812,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.695652174,
        "quality_index": 0.5,
        "opportunity_index": 0.141748228,
        "school_enrollment_secondary": 0.028779979,
        "school_enrollment_primary": 0.021276596,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.648648649,
        "demographic_pressures_indicator": 0.540229885,
        "cost_of_living": 0.1419482,
        "happiness_index": 0.602495544,
        "human_development_index": 0.543859649,
        "standard_of_living_index_by_world_population_review": 0.196415346,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001243979,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "ATG",
        "country": "Antigua and Barbuda",
        "cpi": true, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": 100000, "eur": 92800},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        "business_opportunity": 31,
        "climate_resilience": 35,
        "economic_freedom": 64,
        "education": 31,
        "lifestyle": 50,
        "private_healthcare": 26,
        "safety_security": 65,
        "climate_resilience_score": 0.302912621,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000612,
        "gdp_per_capita": 0.084542418,
        "gdp_growth_annual_percentage_2021": 0.47112462,
        "haq": 0.577272727,
        "domestic_private_health_expenditure_per_capita": 0.047533955,
        "domestic_private_health_expenditure": 0.464234791,
        "global_health_security_index": 0.233722872,
        "insurance_companies_number": 0.024834437,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001015081,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000268,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.608695652,
        "quality_index": 0.53203125,
        "opportunity_index": 0.256901789,
        "school_enrollment_secondary": 0.186444213,
        "school_enrollment_primary": 0.498772504,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.310344828,
        "cost_of_living": 0.586119852,
        "happiness_index": 0.684135472,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.008439004,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "FJI",
        "country": "Fiji",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 35,
        "economic_freedom": 56,
        "education": 29,
        "lifestyle": 43,
        "private_healthcare": 18,
        "safety_security": 65,
        "climate_resilience_score": 0.300970874,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000196948,
        "gdp_per_capita": 0.027956939,
        "gdp_growth_annual_percentage_2021": 0.281661601,
        "haq": 0.272727273,
        "domestic_private_health_expenditure_per_capita": 0.009259485,
        "domestic_private_health_expenditure": 0.296577947,
        "global_health_security_index": 0.16360601,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001450116,
        "number_of_private_hospitals_vs_population_density": 0.0000992,
        "land_area": 0.001115571,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.739130435,
        "quality_index": 0.440234375,
        "opportunity_index": 0.233682079,
        "school_enrollment_secondary": 0.069259645,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.656019656,
        "demographic_pressures_indicator": 0.321839081,
        "cost_of_living": 0.228742349,
        "happiness_index": 0.684135472,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001795339,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "BIH",
        "country": "Bosnia and Herzegovina",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 35,
        "economic_freedom": 63,
        "education": 26,
        "lifestyle": 47,
        "private_healthcare": 26,
        "safety_security": 63,
        "climate_resilience_score": 0.299029126,
        "safety_and_security": 0.696362893,
        "total_business_opportunity": 0.627008328,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000978795,
        "gdp_per_capita": 0.038510156,
        "gdp_growth_annual_percentage_2021": 0.508206687,
        "haq": 0.751515152,
        "domestic_private_health_expenditure_per_capita": 0.024521703,
        "domestic_private_health_expenditure": 0.324263308,
        "global_health_security_index": 0.323873122,
        "insurance_companies_number": 0.021523179,
        "number_of_private_hospitals": 0,
        "health_care_system": 0.0696,
        "health_care_index": 0.047732181,
        "insurance_companies_number_vs_population_density": 0.002900232,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.003126334,
        "innovation_index": 0.289108911,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.666666667,
        "quality_index": 0.53046875,
        "opportunity_index": 0.256091799,
        "school_enrollment_secondary": 0.027737226,
        "school_enrollment_primary": 0.016468903,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.742014742,
        "demographic_pressures_indicator": 0.586206897,
        "cost_of_living": 0.166845327,
        "happiness_index": 0.636363636,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002339105,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MDA",
        "country": "Moldova",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 32,
        "climate_resilience": 35,
        "economic_freedom": 61,
        "education": 26,
        "lifestyle": 45,
        "private_healthcare": 31,
        "safety_security": 62,
        "climate_resilience_score": 0.299029126,
        "safety_and_security": 0.683285656,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000592107,
        "gdp_per_capita": 0.029274657,
        "gdp_growth_annual_percentage_2021": 0.646808511,
        "haq": 0.674242424,
        "domestic_private_health_expenditure_per_capita": 0.015416212,
        "domestic_private_health_expenditure": 0.409576996,
        "global_health_security_index": 0.417362271,
        "insurance_companies_number": 0.011589404,
        "number_of_private_hospitals": 0.00027907,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001160093,
        "number_of_private_hospitals_vs_population_density": 0.000214844,
        "land_area": 0.002008006,
        "innovation_index": 0.342574257,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.666666667,
        "quality_index": 0.4828125,
        "opportunity_index": 0.24400945,
        "school_enrollment_secondary": 0.017518248,
        "school_enrollment_primary": 0.015548282,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.716216216,
        "demographic_pressures_indicator": 0.505747126,
        "cost_of_living": 0.152149106,
        "happiness_index": 0.673796791,
        "human_development_index": 0.631578947,
        "standard_of_living_index_by_world_population_review": 0.599614872,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.003321453,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "VNM",
        "country": "Vietnam",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 38,
        "climate_resilience": 35,
        "economic_freedom": 61,
        "education": 27,
        "lifestyle": 43,
        "private_healthcare": 25,
        "safety_security": 64,
        "climate_resilience_score": 0.299029126,
        "safety_and_security": 0.722517368,
        "total_business_opportunity": 0.557206919,
        "open_for_business": 0.727924405,
        "entrepreneurship": 0.083944954,
        "gdp_2021": 0.015766822,
        "gdp_per_capita": 0.019931924,
        "gdp_growth_annual_percentage_2021": 0.416818642,
        "haq": 0.571212121,
        "domestic_private_health_expenditure_per_capita": 0.014630993,
        "domestic_private_health_expenditure": 0.627257605,
        "global_health_security_index": 0.449081803,
        "insurance_companies_number": 0.117549669,
        "number_of_private_hospitals": 0.004232558,
        "health_care_system": 0.014,
        "health_care_index": 0.074082073,
        "insurance_companies_number_vs_population_density": 0.003190255,
        "number_of_private_hospitals_vs_population_density": 0.000942009,
        "land_area": 0.018933384,
        "innovation_index": 0.435643564,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.009379885,
        "education_index": 0.550724638,
        "quality_index": 0.528125,
        "opportunity_index": 0.253661829,
        "school_enrollment_secondary": 0.131741397,
        "school_enrollment_primary": 0.010842881,
        "best_countries_for_education": 0.025,
        "economic_freedom_index": 0.707616708,
        "demographic_pressures_indicator": 0.390804598,
        "cost_of_living": 0.145060341,
        "happiness_index": 0.598930481,
        "human_development_index": 0.543859649,
        "standard_of_living_index_by_world_population_review": 0.695304399,
        "ccpi": 0.521935933,
        "population_density_per_km2": 0.011940827,
        "quality_of_life": 0.191367781
    },
    {
        "iso_code": "ALB",
        "country": "Albania",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 34,
        "economic_freedom": 67,
        "education": 24,
        "lifestyle": 41,
        "private_healthcare": 30,
        "safety_security": 65,
        "climate_resilience_score": 0.295145631,
        "safety_and_security": 0.73273396,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000791308,
        "gdp_per_capita": 0.036076909,
        "gdp_growth_annual_percentage_2021": 0.537386018,
        "haq": 0.751515152,
        "domestic_private_health_expenditure_per_capita": 0.035243067,
        "domestic_private_health_expenditure": 0.501663498,
        "global_health_security_index": 0.484140234,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.000302326,
        "health_care_system": 0.0696,
        "health_care_index": 0.050971922,
        "insurance_companies_number_vs_population_density": 0.000725058,
        "number_of_private_hospitals_vs_population_density": 0.000214844,
        "land_area": 0.001673065,
        "innovation_index": 0.257425743,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.724637681,
        "quality_index": 0.396484375,
        "opportunity_index": 0.096523793,
        "school_enrollment_secondary": 0.090719499,
        "school_enrollment_primary": 0.079173486,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.781326781,
        "demographic_pressures_indicator": 0.356321839,
        "cost_of_living": 0.159237871,
        "happiness_index": 0.549019608,
        "human_development_index": 0.719298246,
        "standard_of_living_index_by_world_population_review": 0.554140127,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.003815475,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "CPV",
        "country": "Cape Verde Islands",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 34,
        "economic_freedom": 67,
        "education": 20,
        "lifestyle": 49,
        "private_healthcare": 25,
        "safety_security": 65,
        "climate_resilience_score": 0.295145631,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000815,
        "gdp_per_capita": 0.01850063,
        "gdp_growth_annual_percentage_2021": 0.505167173,
        "haq": 0.501515152,
        "domestic_private_health_expenditure_per_capita": 0.00684284,
        "domestic_private_health_expenditure": 0.296459126,
        "global_health_security_index": 0.302170284,
        "insurance_companies_number": 0.006622517,
        "number_of_private_hospitals": 0.000139535,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000435035,
        "number_of_private_hospitals_vs_population_density": 0.0000661,
        "land_area": 0.000246052,
        "innovation_index": 0.211881188,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.449275362,
        "quality_index": 0.43671875,
        "opportunity_index": 0.231387108,
        "school_enrollment_secondary": 0.076642336,
        "school_enrollment_primary": 0.01391162,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.782555283,
        "demographic_pressures_indicator": 0.597701149,
        "cost_of_living": 0.383657803,
        "happiness_index": 0.684135472,
        "human_development_index": 0.557894737,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.005213242,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "UZB",
        "country": "Uzbekistan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 34,
        "economic_freedom": 56,
        "education": 25,
        "lifestyle": 41,
        "private_healthcare": 28,
        "safety_security": 60,
        "climate_resilience_score": 0.295145631,
        "safety_and_security": 0.634654679,
        "total_business_opportunity": 0.575912876,
        "open_for_business": 0.396220267,
        "entrepreneurship": 0.008944954,
        "gdp_2021": 0.003008162,
        "gdp_per_capita": 0.01006772,
        "gdp_growth_annual_percentage_2021": 0.514690983,
        "haq": 0.510606061,
        "domestic_private_health_expenditure_per_capita": 0.008184574,
        "domestic_private_health_expenditure": 0.664448669,
        "global_health_security_index": 0.383973289,
        "insurance_companies_number": 0.016556291,
        "number_of_private_hospitals": 0.009302326,
        "health_care_system": 0.014,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001885151,
        "number_of_private_hospitals_vs_population_density": 0.008345866,
        "land_area": 0.026901024,
        "innovation_index": 0.245544555,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.695652174,
        "quality_index": 0.559375,
        "opportunity_index": 0.28079649,
        "school_enrollment_secondary": 0,
        "school_enrollment_primary": 0.002454992,
        "best_countries_for_education": 0.01,
        "economic_freedom_index": 0.647420147,
        "demographic_pressures_indicator": 0.367816092,
        "cost_of_living": 0.149382759,
        "happiness_index": 0.714795009,
        "human_development_index": 0.578947368,
        "standard_of_living_index_by_world_population_review": 0.640497704,
        "ccpi": 0.444707521,
        "population_density_per_km2": 0.002928058,
        "quality_of_life": 0.023951368
    },
    {
        "iso_code": "VEN",
        "country": "Venezuela",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 17,
        "climate_resilience": 34,
        "economic_freedom": 25,
        "education": 25,
        "lifestyle": 45,
        "private_healthcare": 16,
        "safety_security": 44,
        "climate_resilience_score": 0.293203884,
        "safety_and_security": 0.308949734,
        "total_business_opportunity": 0,
        "open_for_business": 0.426132291,
        "entrepreneurship": 0.071123853,
        "gdp_2021": 0.01175716,
        "gdp_per_capita": 0.019432407,
        "gdp_growth_annual_percentage_2021": 0.459858156,
        "haq": 0.546969697,
        "domestic_private_health_expenditure_per_capita": 0.027267682,
        "domestic_private_health_expenditure": 0.611692015,
        "global_health_security_index": 0.081803005,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.000325581,
        "health_care_system": 0.0342,
        "health_care_index": 0,
        "insurance_companies_number_vs_population_density": 0.001305104,
        "number_of_private_hospitals_vs_population_density": 0.000710638,
        "land_area": 0.053859473,
        "innovation_index": 0.20990099,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.006774362,
        "education_index": 0.652173913,
        "quality_index": 0.457421875,
        "opportunity_index": 0.183125211,
        "school_enrollment_secondary": 0.275995829,
        "school_enrollment_primary": 0.073854337,
        "best_countries_for_education": 0.0288,
        "economic_freedom_index": 0.267813268,
        "demographic_pressures_indicator": 0.632183908,
        "cost_of_living": 0.24551333,
        "happiness_index": 0.52228164,
        "human_development_index": 0.561403509,
        "standard_of_living_index_by_world_population_review": 0.623759443,
        "ccpi": 0.599582173,
        "population_density_per_km2": 0.001154363,
        "quality_of_life": 0.109471125
    },
    {
        "iso_code": "EGY",
        "country": "Egypt",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 34,
        "climate_resilience": 34,
        "economic_freedom": 49,
        "education": 26,
        "lifestyle": 41,
        "private_healthcare": 19,
        "safety_security": 53,
        "climate_resilience_score": 0.293203884,
        "safety_and_security": 0.495300368,
        "total_business_opportunity": 0.748520179,
        "open_for_business": 0.37829912,
        "entrepreneurship": 0.082454128,
        "gdp_2021": 0.017571709,
        "gdp_per_capita": 0.02098317,
        "gdp_growth_annual_percentage_2021": 0.431813577,
        "haq": 0.490909091,
        "domestic_private_health_expenditure_per_capita": 0.015669312,
        "domestic_private_health_expenditure": 0.816539924,
        "global_health_security_index": 0.20033389,
        "insurance_companies_number": 0.052980132,
        "number_of_private_hospitals": 0.026906977,
        "health_care_system": 0.041,
        "health_care_index": 0.011231102,
        "insurance_companies_number_vs_population_density": 0.00449536,
        "number_of_private_hospitals_vs_population_density": 0.018261746,
        "land_area": 0.060783873,
        "innovation_index": 0.2,
        "number_of_universities_in_top_1000": 0.066298343,
        "number_of_top_tier_international_schools": 0.02084419,
        "education_index": 0.536231884,
        "quality_index": 0.6015625,
        "opportunity_index": 0.38164023,
        "school_enrollment_secondary": 0.080291971,
        "school_enrollment_primary": 0.094312602,
        "best_countries_for_education": 0.027,
        "economic_freedom_index": 0.566339066,
        "demographic_pressures_indicator": 0.655172414,
        "cost_of_living": 0.12777067,
        "happiness_index": 0.329768271,
        "human_development_index": 0.561403509,
        "standard_of_living_index_by_world_population_review": 0.677381129,
        "ccpi": 0.70525766,
        "population_density_per_km2": 0.003895597,
        "quality_of_life": 0.108449848
    },
    {
        "iso_code": "BWA",
        "country": "Botswana",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 28,
        "climate_resilience": 34,
        "economic_freedom": 65,
        "education": 17,
        "lifestyle": 41,
        "private_healthcare": 21,
        "safety_security": 64,
        "climate_resilience_score": 0.283495146,
        "safety_and_security": 0.716387413,
        "total_business_opportunity": 0.298654709,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000763207,
        "gdp_per_capita": 0.040995636,
        "gdp_growth_annual_percentage_2021": 0.594528875,
        "haq": 0.340909091,
        "domestic_private_health_expenditure_per_capita": 0.010666781,
        "domestic_private_health_expenditure": 0.153160646,
        "global_health_security_index": 0.293823038,
        "insurance_companies_number": 0.03807947,
        "number_of_private_hospitals": 0.000232558,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.078886311,
        "number_of_private_hospitals_vs_population_density": 0.003900246,
        "land_area": 0.034605488,
        "innovation_index": 0.156435644,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.623188406,
        "quality_index": 0,
        "opportunity_index": 0,
        "school_enrollment_secondary": 0.243295099,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.759213759,
        "demographic_pressures_indicator": 0.75862069,
        "cost_of_living": 0.197793838,
        "happiness_index": 0.229946524,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.548511332,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.0000794,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "DZA",
        "country": "Algeria",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 33,
        "economic_freedom": 46,
        "education": 23,
        "lifestyle": 45,
        "private_healthcare": 20,
        "safety_security": 57,
        "climate_resilience_score": 0.275728155,
        "safety_and_security": 0.575398447,
        "total_business_opportunity": 0.624548366,
        "open_for_business": 0.392831541,
        "entrepreneurship": 0.212866973,
        "gdp_2021": 0.00730213,
        "gdp_per_capita": 0.020341319,
        "gdp_growth_annual_percentage_2021": 0.442350557,
        "haq": 0.531818182,
        "domestic_private_health_expenditure_per_capita": 0.012641263,
        "domestic_private_health_expenditure": 0.386406844,
        "global_health_security_index": 0.170283806,
        "insurance_companies_number": 0.013245033,
        "number_of_private_hospitals": 0.013372093,
        "health_care_system": 0.1152,
        "health_care_index": 0.068898488,
        "insurance_companies_number_vs_population_density": 0.006235499,
        "number_of_private_hospitals_vs_population_density": 0.050719728,
        "land_area": 0.145433201,
        "innovation_index": 0.097029703,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.608695652,
        "quality_index": 0.513671875,
        "opportunity_index": 0.250894364,
        "school_enrollment_secondary": 0.194723671,
        "school_enrollment_primary": 0.01309329,
        "best_countries_for_education": 0.1096,
        "economic_freedom_index": 0.525798526,
        "demographic_pressures_indicator": 0.459770115,
        "cost_of_living": 0.125004322,
        "happiness_index": 0.541889483,
        "human_development_index": 0.631578947,
        "standard_of_living_index_by_world_population_review": 0.731891572,
        "ccpi": 0.360027855,
        "population_density_per_km2": 0.000629963,
        "quality_of_life": 0.180717325
    },
    {
        "iso_code": "PRY",
        "country": "Paraguay",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 33,
        "economic_freedom": 63,
        "education": 26,
        "lifestyle": 45,
        "private_healthcare": 29,
        "safety_security": 60,
        "climate_resilience_score": 0.273786408,
        "safety_and_security": 0.644871271,
        "total_business_opportunity": 0.598821268,
        "open_for_business": 0.505571848,
        "entrepreneurship": 0.146376147,
        "gdp_2021": 0.001692627,
        "gdp_per_capita": 0.029767994,
        "gdp_growth_annual_percentage_2021": 0.449442756,
        "haq": 0.481818182,
        "domestic_private_health_expenditure_per_capita": 0.031385889,
        "domestic_private_health_expenditure": 0.612523764,
        "global_health_security_index": 0.405676127,
        "insurance_companies_number": 0.266556291,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0878,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.128480278,
        "number_of_private_hospitals_vs_population_density": 0.0000992,
        "land_area": 0.024259799,
        "innovation_index": 0.225742574,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.565217391,
        "quality_index": 0.56328125,
        "opportunity_index": 0.285723929,
        "school_enrollment_secondary": 0.106465068,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.083,
        "economic_freedom_index": 0.735872236,
        "demographic_pressures_indicator": 0.540229885,
        "cost_of_living": 0.164078979,
        "happiness_index": 0.606060606,
        "human_development_index": 0.596491228,
        "standard_of_living_index_by_world_population_review": 0.62272256,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.000608699,
        "quality_of_life": 0.145702128
    },
    {
        "iso_code": "PHL",
        "country": "Philippines",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 33,
        "economic_freedom": 61,
        "education": 31,
        "lifestyle": 53,
        "private_healthcare": 25,
        "safety_security": 53,
        "climate_resilience_score": 0.273786408,
        "safety_and_security": 0.496526359,
        "total_business_opportunity": 0.419090327,
        "open_for_business": 0.642554578,
        "entrepreneurship": 0.093004587,
        "gdp_2021": 0.017134401,
        "gdp_per_capita": 0.01909486,
        "gdp_growth_annual_percentage_2021": 0.479837893,
        "haq": 0.354545455,
        "domestic_private_health_expenditure_per_capita": 0.012191478,
        "domestic_private_health_expenditure": 0.671934411,
        "global_health_security_index": 0.495826377,
        "insurance_companies_number": 0.155629139,
        "number_of_private_hospitals": 0.062697674,
        "health_care_system": 0.014,
        "health_care_index": 0.229805616,
        "insurance_companies_number_vs_population_density": 0.00362529,
        "number_of_private_hospitals_vs_population_density": 0.011965162,
        "land_area": 0.018206749,
        "innovation_index": 0.401980198,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.013027619,
        "education_index": 0.623188406,
        "quality_index": 0.58671875,
        "opportunity_index": 0.332230847,
        "school_enrollment_secondary": 0.256934307,
        "school_enrollment_primary": 0.09103928,
        "best_countries_for_education": 0.024,
        "economic_freedom_index": 0.713759214,
        "demographic_pressures_indicator": 0.781609195,
        "cost_of_living": 0.216120889,
        "happiness_index": 0.675579323,
        "human_development_index": 0.578947368,
        "standard_of_living_index_by_world_population_review": 0.754406755,
        "ccpi": 0.692026462,
        "population_density_per_km2": 0.01406083,
        "quality_of_life": 0.174346505
    },
    {
        "iso_code": "CUB",
        "country": "Cuba",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 43,
        "climate_resilience": 33,
        "economic_freedom": 30,
        "education": 36,
        "lifestyle": 49,
        "private_healthcare": 33,
        "safety_security": 58,
        "climate_resilience_score": 0.27184466,
        "safety_and_security": 0.601144258,
        "total_business_opportunity": 0.666700833,
        "open_for_business": 0.560443141,
        "entrepreneurship": 0.28587156,
        "gdp_2021": 0.017337088,
        "gdp_per_capita": 0.137549927,
        "gdp_growth_annual_percentage_2021": 0.45929078,
        "haq": 0.68030303,
        "domestic_private_health_expenditure_per_capita": 0.016068782,
        "domestic_private_health_expenditure": 0.096839354,
        "global_health_security_index": 0.242070117,
        "insurance_companies_number": 0.016556291,
        "number_of_private_hospitals": 0,
        "health_care_system": 0.186,
        "health_care_index": 0.527170626,
        "insurance_companies_number_vs_population_density": 0.001305104,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.006338181,
        "innovation_index": 0.496633663,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.782608696,
        "quality_index": 0.553515625,
        "opportunity_index": 0.295916301,
        "school_enrollment_secondary": 0.250594369,
        "school_enrollment_primary": 0.058510638,
        "best_countries_for_education": 0.2688,
        "economic_freedom_index": 0.325552826,
        "demographic_pressures_indicator": 0.517241379,
        "cost_of_living": 0.267817006,
        "happiness_index": 0.577540107,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.610131832,
        "ccpi": 0.388300836,
        "population_density_per_km2": 0.004058879,
        "quality_of_life": 0.280753799
    },
    {
        "iso_code": "JAM",
        "country": "Jamaica",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 33,
        "economic_freedom": 67,
        "education": 25,
        "lifestyle": 44,
        "private_healthcare": 25,
        "safety_security": 60,
        "climate_resilience_score": 0.27184466,
        "safety_and_security": 0.63914998,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000590325,
        "gdp_per_capita": 0.025078208,
        "gdp_growth_annual_percentage_2021": 0.457548126,
        "haq": 0.531818182,
        "domestic_private_health_expenditure_per_capita": 0.015965103,
        "domestic_private_health_expenditure": 0.365019011,
        "global_health_security_index": 0.263772955,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.004651163,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000290023,
        "number_of_private_hospitals_vs_population_density": 0.001206432,
        "land_area": 0.000661272,
        "innovation_index": 0.289108911,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.637681159,
        "quality_index": 0.4828125,
        "opportunity_index": 0.24400945,
        "school_enrollment_secondary": 0.020229406,
        "school_enrollment_primary": 0.093903437,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.791154791,
        "demographic_pressures_indicator": 0.436781609,
        "cost_of_living": 0.350461634,
        "happiness_index": 0.647058824,
        "human_development_index": 0.596491228,
        "standard_of_living_index_by_world_population_review": 0.495630277,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.010344464,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "DOM",
        "country": "Dominican Republic",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 33,
        "economic_freedom": 63,
        "education": 20,
        "lifestyle": 47,
        "private_healthcare": 21,
        "safety_security": 60,
        "climate_resilience_score": 0.266019418,
        "safety_and_security": 0.63914998,
        "total_business_opportunity": 0.597386291,
        "open_for_business": 0.585206908,
        "entrepreneurship": 0.010665138,
        "gdp_2021": 0.004095504,
        "gdp_per_capita": 0.048238241,
        "gdp_growth_annual_percentage_2021": 0.612968592,
        "haq": 0.513636364,
        "domestic_private_health_expenditure_per_capita": 0.040043118,
        "domestic_private_health_expenditure": 0.615850761,
        "global_health_security_index": 0.30884808,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.004,
        "health_care_index": 0.055075594,
        "insurance_companies_number_vs_population_density": 0.000290023,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.002949865,
        "innovation_index": 0.2,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.608695652,
        "quality_index": 0.23828125,
        "opportunity_index": 0.057036787,
        "school_enrollment_secondary": 0.185714286,
        "school_enrollment_primary": 0.237827332,
        "best_countries_for_education": 0,
        "economic_freedom_index": 0.737100737,
        "demographic_pressures_indicator": 0.620689655,
        "cost_of_living": 0.137279989,
        "happiness_index": 0.68627451,
        "human_development_index": 0.649122807,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.419185237,
        "population_density_per_km2": 0.008528619,
        "quality_of_life": 0.099696049
    },
    {
        "iso_code": "WSM",
        "country": "Samoa",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 28,
        "climate_resilience": 32,
        "economic_freedom": 68,
        "education": 29,
        "lifestyle": 56,
        "private_healthcare": 22,
        "safety_security": 65,
        "climate_resilience_score": 0.258252427,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000315,
        "gdp_per_capita": 0.021344943,
        "gdp_growth_annual_percentage_2021": 0.200607903,
        "haq": 0.507575758,
        "domestic_private_health_expenditure_per_capita": 0.003900175,
        "domestic_private_health_expenditure": 0.099572243,
        "global_health_security_index": 0.213689483,
        "insurance_companies_number": 0.006622517,
        "number_of_private_hospitals": 0.000116279,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.00087007,
        "number_of_private_hospitals_vs_population_density": 0.000115685,
        "land_area": 0.000172778,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.666666667,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.235933264,
        "school_enrollment_primary": 0.205400982,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.802211302,
        "demographic_pressures_indicator": 0.413793103,
        "cost_of_living": 0.979286974,
        "happiness_index": 0.684135472,
        "human_development_index": 0.578947368,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002604153,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MDV",
        "country": "Maldives",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 32,
        "economic_freedom": 47,
        "education": 16,
        "lifestyle": 44,
        "private_healthcare": 28,
        "safety_security": 65,
        "climate_resilience_score": 0.25631068,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000209887,
        "gdp_per_capita": 0.05049161,
        "gdp_growth_annual_percentage_2021": 0.991691996,
        "haq": 0.710606061,
        "domestic_private_health_expenditure_per_capita": 0.024302146,
        "domestic_private_health_expenditure": 0.197362167,
        "global_health_security_index": 0.267111853,
        "insurance_companies_number": 0.014900662,
        "number_of_private_hospitals": 0.001162791,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0.0000496,
        "land_area": 0.0000183,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.463768116,
        "quality_index": 0.029296875,
        "opportunity_index": 0.015524806,
        "school_enrollment_secondary": 0.048800834,
        "school_enrollment_primary": 0.039484452,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.544226044,
        "demographic_pressures_indicator": 0.482758621,
        "cost_of_living": 0.336284104,
        "happiness_index": 0.538324421,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.534735595,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.068727535,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SUR",
        "country": "Suriname",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 32,
        "economic_freedom": 48,
        "education": 25,
        "lifestyle": 38,
        "private_healthcare": 24,
        "safety_security": 52,
        "climate_resilience_score": 0.25631068,
        "safety_and_security": 0.476747037,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000121718,
        "gdp_per_capita": 0.026517689,
        "gdp_growth_annual_percentage_2021": 0.293819656,
        "haq": 0.425757576,
        "domestic_private_health_expenditure_per_capita": 0.025273378,
        "domestic_private_health_expenditure": 0.296459126,
        "global_health_security_index": 0.317195326,
        "insurance_companies_number": 0.033112583,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.076421114,
        "number_of_private_hospitals_vs_population_density": 0.000875903,
        "land_area": 0.009525603,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.623188406,
        "quality_index": 0.43671875,
        "opportunity_index": 0.231387108,
        "school_enrollment_secondary": 0.011157456,
        "school_enrollment_primary": 0.018207856,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.554054054,
        "demographic_pressures_indicator": 0.517241379,
        "cost_of_living": 0.244130157,
        "happiness_index": 0.729055259,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.075544364,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.0000627,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "LKA",
        "country": "Sri Lanka",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 37,
        "climate_resilience": 32,
        "economic_freedom": 53,
        "education": 21,
        "lifestyle": 41,
        "private_healthcare": 27,
        "safety_security": 60,
        "climate_resilience_score": 0.25631068,
        "safety_and_security": 0.62689007,
        "total_business_opportunity": 0.597386291,
        "open_for_business": 0.714239166,
        "entrepreneurship": 0.020756881,
        "gdp_2021": 0.003672621,
        "gdp_per_capita": 0.020627797,
        "gdp_growth_annual_percentage_2021": 0.438500507,
        "haq": 0.66969697,
        "domestic_private_health_expenditure_per_capita": 0.012011563,
        "domestic_private_health_expenditure": 0.581986692,
        "global_health_security_index": 0.302170284,
        "insurance_companies_number": 0.026490066,
        "number_of_private_hospitals": 0.00327907,
        "health_care_system": 0.014,
        "health_care_index": 0.226781858,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.000644532,
        "land_area": 0.003777496,
        "innovation_index": 0.2,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.724637681,
        "quality_index": 0.240234375,
        "opportunity_index": 0.060749241,
        "school_enrollment_secondary": 0.204004171,
        "school_enrollment_primary": 0.031505728,
        "best_countries_for_education": 0.029,
        "economic_freedom_index": 0.617936118,
        "demographic_pressures_indicator": 0.620689655,
        "cost_of_living": 0.084200699,
        "happiness_index": 0.342245989,
        "human_development_index": 0.684210526,
        "standard_of_living_index_by_world_population_review": 0.616353133,
        "ccpi": 0.437604457,
        "population_density_per_km2": 0.013518204,
        "quality_of_life": 0.090334347
    },
    {
        "iso_code": "BTN",
        "country": "Bhutan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 65,
        "climate_resilience": 32,
        "economic_freedom": 59,
        "education": 44,
        "lifestyle": 52,
        "private_healthcare": 44,
        "safety_security": 70,
        "climate_resilience_score": 0.252427185,
        "safety_and_security": 0.847159788,
        "total_business_opportunity": 0.911159513,
        "open_for_business": 0.830954708,
        "entrepreneurship": 0.591972477,
        "gdp_2021": 0.019808674,
        "gdp_per_capita": 0.289110027,
        "gdp_growth_annual_percentage_2021": 0.509057751,
        "haq": 0.365151515,
        "domestic_private_health_expenditure_per_capita": 0.002855758,
        "domestic_private_health_expenditure": 0.202352662,
        "global_health_security_index": 0.397328882,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.000697674,
        "health_care_system": 0.7416,
        "health_care_index": 0.636803456,
        "insurance_companies_number_vs_population_density": 0.002175174,
        "number_of_private_hospitals_vs_population_density": 0.002429391,
        "land_area": 0.002328868,
        "innovation_index": 0.746930693,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.362318841,
        "quality_index": 0.78125,
        "opportunity_index": 0.626527168,
        "school_enrollment_secondary": 0.106152242,
        "school_enrollment_primary": 0.043269231,
        "best_countries_for_education": 0.763,
        "economic_freedom_index": 0.691646192,
        "demographic_pressures_indicator": 0.505747126,
        "cost_of_living": 0.187247139,
        "happiness_index": 0.516934046,
        "human_development_index": 0.456140351,
        "standard_of_living_index_by_world_population_review": 0.7292253,
        "ccpi": 0.655779944,
        "population_density_per_km2": 0.000695276,
        "quality_of_life": 0.727465046
    },
    {
        "iso_code": "ECU",
        "country": "Ecuador",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 32,
        "climate_resilience": 32,
        "economic_freedom": 54,
        "education": 28,
        "lifestyle": 47,
        "private_healthcare": 31,
        "safety_security": 60,
        "climate_resilience_score": 0.244660194,
        "safety_and_security": 0.639967307,
        "total_business_opportunity": 0.602946829,
        "open_for_business": 0.503747149,
        "entrepreneurship": 0.009977064,
        "gdp_2021": 0.004613959,
        "gdp_per_capita": 0.032851164,
        "gdp_growth_annual_percentage_2021": 0.450253293,
        "haq": 0.493939394,
        "domestic_private_health_expenditure_per_capita": 0.027693072,
        "domestic_private_health_expenditure": 0.424073194,
        "global_health_security_index": 0.580968281,
        "insurance_companies_number": 0.263245033,
        "number_of_private_hospitals": 0.000627907,
        "health_care_system": 0,
        "health_care_index": 0.342332613,
        "insurance_companies_number_vs_population_density": 0.032047564,
        "number_of_private_hospitals_vs_population_density": 0.000611479,
        "land_area": 0.015165265,
        "innovation_index": 0.205940594,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.041688379,
        "education_index": 0.652173913,
        "quality_index": 0.5515625,
        "opportunity_index": 0.271684104,
        "school_enrollment_secondary": 0.269968717,
        "school_enrollment_primary": 0.247545008,
        "best_countries_for_education": 0,
        "economic_freedom_index": 0.63022113,
        "demographic_pressures_indicator": 0.655172414,
        "cost_of_living": 0.198312528,
        "happiness_index": 0.579322638,
        "human_development_index": 0.649122807,
        "standard_of_living_index_by_world_population_review": 0.651310917,
        "ccpi": 0.419185237,
        "population_density_per_km2": 0.002653897,
        "quality_of_life": 0.065167173
    },
    {
        "iso_code": "TJK",
        "country": "Tajikistan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 31,
        "economic_freedom": 50,
        "education": 25,
        "lifestyle": 36,
        "private_healthcare": 25,
        "safety_security": 59,
        "climate_resilience_score": 0.238834952,
        "safety_and_security": 0.622394769,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000377594,
        "gdp_per_capita": 0.003806773,
        "gdp_growth_annual_percentage_2021": 0.550759878,
        "haq": 0.454545455,
        "domestic_private_health_expenditure_per_capita": 0.006144529,
        "domestic_private_health_expenditure": 0.81891635,
        "global_health_security_index": 0.222036728,
        "insurance_companies_number": 0.029801325,
        "number_of_private_hospitals": 0.000116279,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.003770302,
        "number_of_private_hospitals_vs_population_density": 0.000115685,
        "land_area": 0.008474731,
        "innovation_index": 0.176237624,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.623188406,
        "quality_index": 0.534375,
        "opportunity_index": 0.258926763,
        "school_enrollment_secondary": 0.102523462,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.573710074,
        "demographic_pressures_indicator": 0.689655172,
        "cost_of_living": 0.149382759,
        "happiness_index": 0.554367201,
        "human_development_index": 0.49122807,
        "standard_of_living_index_by_world_population_review": 0.148866835,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002586306,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "IRQ",
        "country": "Iraq",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 22,
        "climate_resilience": 31,
        "economic_freedom": 57,
        "education": 26,
        "lifestyle": 44,
        "private_healthcare": 16,
        "safety_security": 37,
        "climate_resilience_score": 0.236893204,
        "safety_and_security": 0.162239477,
        "total_business_opportunity": 0.514772582,
        "open_for_business": 0.195177582,
        "entrepreneurship": 0.015366972,
        "gdp_2021": 0.00903748,
        "gdp_per_capita": 0.027740279,
        "gdp_growth_annual_percentage_2021": 0.420668693,
        "haq": 0.477272727,
        "domestic_private_health_expenditure_per_capita": 0.018761397,
        "domestic_private_health_expenditure": 0.566302281,
        "global_health_security_index": 0.133555927,
        "insurance_companies_number": 0.049668874,
        "number_of_private_hospitals": 0.002093023,
        "health_care_system": 0.027,
        "health_care_index": 0.002807775,
        "insurance_companies_number_vs_population_density": 0.004640371,
        "number_of_private_hospitals_vs_population_density": 0.001570014,
        "land_area": 0.02650858,
        "innovation_index": 0.406732673,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.449275362,
        "quality_index": 0.571484375,
        "opportunity_index": 0.297401283,
        "school_enrollment_secondary": 0.055766423,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.015,
        "economic_freedom_index": 0.666093366,
        "demographic_pressures_indicator": 0.827586207,
        "cost_of_living": 0.183270514,
        "happiness_index": 0.518716578,
        "human_development_index": 0.49122807,
        "standard_of_living_index_by_world_population_review": 0.641978966,
        "ccpi": 0.34143454,
        "population_density_per_km2": 0.003520809,
        "quality_of_life": 0
    },
    {
        "iso_code": "NAM",
        "country": "Namibia",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 300000, "eur" : 278300}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 31,
        "economic_freedom": 59,
        "education": 21,
        "lifestyle": 41,
        "private_healthcare": 23,
        "safety_security": 62,
        "climate_resilience_score": 0.229126214,
        "safety_and_security": 0.672660401,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000529359,
        "gdp_per_capita": 0.025900455,
        "gdp_growth_annual_percentage_2021": 0.413576494,
        "haq": 0.38030303,
        "domestic_private_health_expenditure_per_capita": 0.030972696,
        "domestic_private_health_expenditure": 0.546696768,
        "global_health_security_index": 0.238731219,
        "insurance_companies_number": 0.026490066,
        "number_of_private_hospitals": 0.000627907,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.073810905,
        "number_of_private_hospitals_vs_population_density": 0.014196235,
        "land_area": 0.050271485,
        "innovation_index": 0.184158416,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.47826087,
        "quality_index": 0.492578125,
        "opportunity_index": 0.245426932,
        "school_enrollment_secondary": 0.114452555,
        "school_enrollment_primary": 0.060658756,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.69041769,
        "demographic_pressures_indicator": 0.816091954,
        "cost_of_living": 0.214910612,
        "happiness_index": 0.411764706,
        "human_development_index": 0.456140351,
        "standard_of_living_index_by_world_population_review": 0.454747445,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000038,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "GHA",
        "country": "Ghana",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 31,
        "economic_freedom": 60,
        "education": 23,
        "lifestyle": 39,
        "private_healthcare": 23,
        "safety_security": 65,
        "climate_resilience_score": 0.229126214,
        "safety_and_security": 0.733551287,
        "total_business_opportunity": 0.597386291,
        "open_for_business": 0.5066797,
        "entrepreneurship": 0.129311927,
        "gdp_2021": 0.003371502,
        "gdp_per_capita": 0.012732616,
        "gdp_growth_annual_percentage_2021": 0.472948328,
        "haq": 0.31969697,
        "domestic_private_health_expenditure_per_capita": 0.004978136,
        "domestic_private_health_expenditure": 0.547053232,
        "global_health_security_index": 0.305509182,
        "insurance_companies_number": 0.041390728,
        "number_of_private_hospitals": 0.030232558,
        "health_care_system": 0.0612,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.002610209,
        "number_of_private_hospitals_vs_population_density": 0.015402667,
        "land_area": 0.013893959,
        "innovation_index": 0.144554455,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.006253257,
        "education_index": 0.449275362,
        "quality_index": 0.5453125,
        "opportunity_index": 0.263921701,
        "school_enrollment_secondary": 0.16725756,
        "school_enrollment_primary": 0.284881342,
        "best_countries_for_education": 0.0592,
        "economic_freedom_index": 0.697788698,
        "demographic_pressures_indicator": 0.67816092,
        "cost_of_living": 0.146097721,
        "happiness_index": 0.392156863,
        "human_development_index": 0.385964912,
        "standard_of_living_index_by_world_population_review": 0.599614872,
        "ccpi": 0.405222841,
        "population_density_per_km2": 0.005214381,
        "quality_of_life": 0.134079027
    },
    {
        "iso_code": "SLV",
        "country": "El Salvador",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 32,
        "climate_resilience": 31,
        "economic_freedom": 60,
        "education": 23,
        "lifestyle": 46,
        "private_healthcare": 27,
        "safety_security": 55,
        "climate_resilience_score": 0.229126214,
        "safety_and_security": 0.540662035,
        "total_business_opportunity": 0.627008328,
        "open_for_business": 0.442815249,
        "entrepreneurship": 0,
        "gdp_2021": 0.001246904,
        "gdp_per_capita": 0.024051234,
        "gdp_growth_annual_percentage_2021": 0.583181358,
        "haq": 0.542424242,
        "domestic_private_health_expenditure_per_capita": 0.01582788,
        "domestic_private_health_expenditure": 0.397338403,
        "global_health_security_index": 0.414023372,
        "insurance_companies_number": 0.011589404,
        "number_of_private_hospitals": 0.000697674,
        "health_care_system": 0.006,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000290023,
        "number_of_private_hospitals_vs_population_density": 0.000165265,
        "land_area": 0.001265172,
        "innovation_index": 0.198019802,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.449275362,
        "quality_index": 0.566015625,
        "opportunity_index": 0.294701316,
        "school_enrollment_secondary": 0.172158498,
        "school_enrollment_primary": 0.135945172,
        "best_countries_for_education": 0.018,
        "economic_freedom_index": 0.695331695,
        "demographic_pressures_indicator": 0.666666667,
        "cost_of_living": 0.2576161,
        "happiness_index": 0.757575758,
        "human_development_index": 0.49122807,
        "standard_of_living_index_by_world_population_review": 0.554584506,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.011864882,
        "quality_of_life": 0.026139818
    },
    {
        "iso_code": "LBN",
        "country": "Lebanon",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 21,
        "climate_resilience": 31,
        "economic_freedom": 47,
        "education": 25,
        "lifestyle": 38,
        "private_healthcare": 29,
        "safety_security": 48,
        "climate_resilience_score": 0.221359223,
        "safety_and_security": 0.383735186,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.31769306,
        "entrepreneurship": 0.025229358,
        "gdp_2021": 0.000783332,
        "gdp_per_capita": 0.014030675,
        "gdp_growth_annual_percentage_2021": 0.151165147,
        "haq": 0.778787879,
        "domestic_private_health_expenditure_per_capita": 0.050092397,
        "domestic_private_health_expenditure": 0.566658745,
        "global_health_security_index": 0.29048414,
        "insurance_companies_number": 0.033112583,
        "number_of_private_hospitals": 0.003139535,
        "health_care_system": 0.016,
        "health_care_index": 0.198920086,
        "insurance_companies_number_vs_population_density": 0.000435035,
        "number_of_private_hospitals_vs_population_density": 0.000330529,
        "land_area": 0.000624635,
        "innovation_index": 0.2,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.014069828,
        "education_index": 0.507246377,
        "quality_index": 0.162109375,
        "opportunity_index": 0.026662167,
        "school_enrollment_secondary": 0.615328467,
        "school_enrollment_primary": 0.734860884,
        "best_countries_for_education": 0.012,
        "economic_freedom_index": 0.544226044,
        "demographic_pressures_indicator": 0.505747126,
        "cost_of_living": 0.486704243,
        "happiness_index": 0,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.669826692,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.02504513,
        "quality_of_life": 0.012644377
    },
    {
        "iso_code": "GTM",
        "country": "Guatemala",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 32,
        "climate_resilience": 30,
        "economic_freedom": 63,
        "education": 25,
        "lifestyle": 47,
        "private_healthcare": 22,
        "safety_security": 57,
        "climate_resilience_score": 0.219417476,
        "safety_and_security": 0.578259093,
        "total_business_opportunity": 0.597386291,
        "open_for_business": 0.517758227,
        "entrepreneurship": 0.000229358,
        "gdp_2021": 0.003736436,
        "gdp_per_capita": 0.027608773,
        "gdp_growth_annual_percentage_2021": 0.51691996,
        "haq": 0.410606061,
        "domestic_private_health_expenditure_per_capita": 0.024498832,
        "domestic_private_health_expenditure": 0.692371673,
        "global_health_security_index": 0.21869783,
        "insurance_companies_number": 0.124172185,
        "number_of_private_hospitals": 0.001046512,
        "health_care_system": 0.012,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.006815545,
        "number_of_private_hospitals_vs_population_density": 0.000462741,
        "land_area": 0.006543348,
        "innovation_index": 0.18019802,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.391304348,
        "quality_index": 0.5265625,
        "opportunity_index": 0.253526831,
        "school_enrollment_secondary": 0.655995829,
        "school_enrollment_primary": 0.124283961,
        "best_countries_for_education": 0.006,
        "economic_freedom_index": 0.73955774,
        "demographic_pressures_indicator": 0.655172414,
        "cost_of_living": 0.274732875,
        "happiness_index": 0.727272727,
        "human_development_index": 0.473684211,
        "standard_of_living_index_by_world_population_review": 0.630425122,
        "ccpi": 0.405222841,
        "population_density_per_km2": 0.005981805,
        "quality_of_life": 0.065653495
    },
    {
        "iso_code": "GAB",
        "country": "Gabon",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 30,
        "economic_freedom": 56,
        "education": 20,
        "lifestyle": 39,
        "private_healthcare": 19,
        "safety_security": 61,
        "climate_resilience_score": 0.209708738,
        "safety_and_security": 0.646097262,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000791712,
        "gdp_per_capita": 0.044855161,
        "gdp_growth_annual_percentage_2021": 0.394934144,
        "haq": 0.345454546,
        "domestic_private_health_expenditure_per_capita": 0.012238743,
        "domestic_private_health_expenditure": 0.435836502,
        "global_health_security_index": 0.096828047,
        "insurance_companies_number": 0.006622517,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.006525522,
        "number_of_private_hospitals_vs_population_density": 0.000380109,
        "land_area": 0.015733749,
        "innovation_index": 0.332277228,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.579710145,
        "quality_index": 0.11328125,
        "opportunity_index": 0.016199798,
        "school_enrollment_secondary": 0.186944734,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.648648649,
        "demographic_pressures_indicator": 0.620689655,
        "cost_of_living": 0,
        "happiness_index": 0.516934046,
        "human_development_index": 0.543859649,
        "standard_of_living_index_by_world_population_review": 0.540808769,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000254416,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "BLZ",
        "country": "Belize",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 30,
        "economic_freedom": 57,
        "education": 35,
        "lifestyle": 36,
        "private_healthcare": 23,
        "safety_security": 65,
        "climate_resilience_score": 0.20776699,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000751,
        "gdp_per_capita": 0.024120245,
        "gdp_growth_annual_percentage_2021": 0.561904762,
        "haq": 0.45,
        "domestic_private_health_expenditure_per_capita": 0.011555679,
        "domestic_private_health_expenditure": 0.293488593,
        "global_health_security_index": 0.228714524,
        "insurance_companies_number": 0.028145695,
        "number_of_private_hospitals": 0.002325581,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.013921114,
        "number_of_private_hospitals_vs_population_density": 0.009304401,
        "land_area": 0.001392791,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.652173913,
        "quality_index": 0.53203125,
        "opportunity_index": 0.256901789,
        "school_enrollment_secondary": 0.06734098,
        "school_enrollment_primary": 0.94905892,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.658476659,
        "demographic_pressures_indicator": 0.459770115,
        "cost_of_living": 0.28337771,
        "happiness_index": 0.673796791,
        "human_development_index": 0.578947368,
        "standard_of_living_index_by_world_population_review": 0.047844764,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.00059275,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "GUY",
        "country": "Guyana",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 30,
        "economic_freedom": 60,
        "education": 25,
        "lifestyle": 38,
        "private_healthcare": 21,
        "safety_security": 57,
        "climate_resilience_score": 0.205825243,
        "safety_and_security": 0.577850429,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00031945,
        "gdp_per_capita": 0.052683348,
        "gdp_growth_annual_percentage_2021": 0.768186424,
        "haq": 0.321212121,
        "domestic_private_health_expenditure_per_capita": 0.018224704,
        "domestic_private_health_expenditure": 0.420865019,
        "global_health_security_index": 0.247078464,
        "insurance_companies_number": 0.031456954,
        "number_of_private_hospitals": 0.000232558,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.068590487,
        "number_of_private_hospitals_vs_population_density": 0.00411509,
        "land_area": 0.012019975,
        "innovation_index": 0.295445545,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.507246377,
        "quality_index": 0.534375,
        "opportunity_index": 0.258926763,
        "school_enrollment_secondary": 0.102523462,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.694103194,
        "demographic_pressures_indicator": 0.551724138,
        "cost_of_living": 0.325045818,
        "happiness_index": 0.679144385,
        "human_development_index": 0.50877193,
        "standard_of_living_index_by_world_population_review": 0.089023848,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000071,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "TLS",
        "country": "Timor-Leste",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 30,
        "economic_freedom": 46,
        "education": 24,
        "lifestyle": 51,
        "private_healthcare": 19,
        "safety_security": 63,
        "climate_resilience_score": 0.205825243,
        "safety_and_security": 0.700858194,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000825,
        "gdp_per_capita": 0.007039609,
        "gdp_growth_annual_percentage_2021": 0.453495441,
        "haq": 0.348484849,
        "domestic_private_health_expenditure_per_capita": 0.001257875,
        "domestic_private_health_expenditure": 0.126188213,
        "global_health_security_index": 0.196994992,
        "insurance_companies_number": 0.003311258,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000290023,
        "number_of_private_hospitals_vs_population_density": 0.0000496,
        "land_area": 0.000907961,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.376811594,
        "quality_index": 0.43671875,
        "opportunity_index": 0.231387108,
        "school_enrollment_secondary": 0.255370177,
        "school_enrollment_primary": 0.13195581,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.531941032,
        "demographic_pressures_indicator": 0.885057471,
        "cost_of_living": 0.381064352,
        "happiness_index": 0.684135472,
        "human_development_index": 0.385964912,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.003350312,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "TKM",
        "country": "Turkmenistan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 39,
        "climate_resilience": 30,
        "economic_freedom": 46,
        "education": 20,
        "lifestyle": 56,
        "private_healthcare": 30,
        "safety_security": 58,
        "climate_resilience_score": 0.205825243,
        "safety_and_security": 0.587658357,
        "total_business_opportunity": 0.743830878,
        "open_for_business": 0.514304334,
        "entrepreneurship": 0.125321101,
        "gdp_2021": 0.014774356,
        "gdp_per_capita": 0.044957368,
        "gdp_growth_annual_percentage_2021": 0.465288754,
        "haq": 0.446969697,
        "domestic_private_health_expenditure_per_capita": 0.061855434,
        "domestic_private_health_expenditure": 0.944272814,
        "global_health_security_index": 0.265442404,
        "insurance_companies_number": 0.001655629,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.087,
        "health_care_index": 0.455032397,
        "insurance_companies_number_vs_population_density": 0.001160093,
        "number_of_private_hospitals_vs_population_density": 0.000132212,
        "land_area": 0.028694712,
        "innovation_index": 0.332673267,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.579710145,
        "quality_index": 0.095703125,
        "opportunity_index": 0.015862302,
        "school_enrollment_secondary": 0.111699687,
        "school_enrollment_primary": 0.146276596,
        "best_countries_for_education": 0.124,
        "economic_freedom_index": 0.530712531,
        "demographic_pressures_indicator": 0.528735632,
        "cost_of_living": 0.928628238,
        "happiness_index": 0.586452763,
        "human_development_index": 0.578947368,
        "standard_of_living_index_by_world_population_review": 0.577692194,
        "ccpi": 0.660619777,
        "population_density_per_km2": 0.000413141,
        "quality_of_life": 0.171720365
    },
    {
        "iso_code": "LBY",
        "country": "Libya",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 40,
        "climate_resilience": 29,
        "economic_freedom": 51,
        "education": 17,
        "lifestyle": 42,
        "private_healthcare": 27,
        "safety_security": 41,
        "climate_resilience_score": 0.2,
        "safety_and_security": 0.25500613,
        "total_business_opportunity": 0.598821268,
        "open_for_business": 0.505571848,
        "entrepreneurship": 0.146376147,
        "gdp_2021": 0.001818421,
        "gdp_per_capita": 0.03333297,
        "gdp_growth_annual_percentage_2021": 1,
        "haq": 0.625757576,
        "domestic_private_health_expenditure_per_capita": 0.026505638,
        "domestic_private_health_expenditure": 0.670722434,
        "global_health_security_index": 0.155258765,
        "insurance_companies_number": 0.009933775,
        "number_of_private_hospitals": 0.001627907,
        "health_care_system": 0.0878,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.022041763,
        "number_of_private_hospitals_vs_population_density": 0.029251847,
        "land_area": 0.107440531,
        "innovation_index": 0.293861386,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.52173913,
        "quality_index": 0.017578125,
        "opportunity_index": 0.004724941,
        "school_enrollment_secondary": 0.077163712,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.083,
        "economic_freedom_index": 0.586240786,
        "demographic_pressures_indicator": 0.563218391,
        "cost_of_living": 0.125695909,
        "happiness_index": 0.561497326,
        "human_development_index": 0.578947368,
        "standard_of_living_index_by_world_population_review": 0.574137165,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.0000687,
        "quality_of_life": 0.145702128
    },
    {
        "iso_code": "NGA",
        "country": "Nigeria",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 39,
        "climate_resilience": 29,
        "economic_freedom": 54,
        "education": 23,
        "lifestyle": 46,
        "private_healthcare": 26,
        "safety_security": 46,
        "climate_resilience_score": 0.2,
        "safety_and_security": 0.338782182,
        "total_business_opportunity": 0.56033312,
        "open_for_business": 0.480417074,
        "entrepreneurship": 0.366353211,
        "gdp_2021": 0.019164775,
        "gdp_per_capita": 0.010655608,
        "gdp_growth_annual_percentage_2021": 0.438297872,
        "haq": 0.343939394,
        "domestic_private_health_expenditure_per_capita": 0.007182848,
        "domestic_private_health_expenditure": 0.818203422,
        "global_health_security_index": 0.367278798,
        "insurance_companies_number": 0.09602649,
        "number_of_private_hospitals": 0.060465116,
        "health_care_system": 0.3108,
        "health_care_index": 0.050971922,
        "insurance_companies_number_vs_population_density": 0.00362529,
        "number_of_private_hospitals_vs_population_density": 0.018509643,
        "land_area": 0.055613166,
        "innovation_index": 0.100990099,
        "number_of_universities_in_top_1000": 0.016574586,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.362318841,
        "quality_index": 0.50546875,
        "opportunity_index": 0.249544381,
        "school_enrollment_secondary": 0.236809176,
        "school_enrollment_primary": 0.201923077,
        "best_countries_for_education": 0.2998,
        "economic_freedom_index": 0.631449631,
        "demographic_pressures_indicator": 0.942528736,
        "cost_of_living": 0.187074242,
        "happiness_index": 0.409982175,
        "human_development_index": 0.263157895,
        "standard_of_living_index_by_world_population_review": 0.650866538,
        "ccpi": 0.429770195,
        "population_density_per_km2": 0.008732532,
        "quality_of_life": 0.299452888
    },
    {
        "iso_code": "DJI",
        "country": "Djibouti",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 29,
        "economic_freedom": 55,
        "education": 18,
        "lifestyle": 27,
        "private_healthcare": 17,
        "safety_security": 56,
        "climate_resilience_score": 0.190291262,
        "safety_and_security": 0.548017981,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000143851,
        "gdp_per_capita": 0.018027587,
        "gdp_growth_annual_percentage_2021": 0.451671733,
        "haq": 0.243939394,
        "domestic_private_health_expenditure_per_capita": 0.001823538,
        "domestic_private_health_expenditure": 0.274952472,
        "global_health_security_index": 0.153589316,
        "insurance_companies_number": 0.006622517,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001305104,
        "number_of_private_hospitals_vs_population_density": 0.000115685,
        "land_area": 0.001415384,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.115942029,
        "quality_index": 0.435546875,
        "opportunity_index": 0.231387108,
        "school_enrollment_secondary": 0.108863399,
        "school_enrollment_primary": 0.13809329,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.642506143,
        "demographic_pressures_indicator": 0.67816092,
        "cost_of_living": 0.133303365,
        "happiness_index": 0.390374332,
        "human_development_index": 0.228070175,
        "standard_of_living_index_by_world_population_review": 0.056880462,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001560669,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SLB",
        "country": "Solomon Islands",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 29,
        "economic_freedom": 57,
        "education": 24,
        "lifestyle": 43,
        "private_healthcare": 14,
        "safety_security": 65,
        "climate_resilience_score": 0.184466019,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000688,
        "gdp_per_capita": 0.012108119,
        "gdp_growth_annual_percentage_2021": 0.360688956,
        "haq": 0.21969697,
        "domestic_private_health_expenditure_per_capita": 0,
        "domestic_private_health_expenditure": 0.011882129,
        "global_health_security_index": 0.121869783,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.000093,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.002900232,
        "number_of_private_hospitals_vs_population_density": 0.000264423,
        "land_area": 0.001709091,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.31884058,
        "quality_index": 0.53203125,
        "opportunity_index": 0.256901789,
        "school_enrollment_secondary": 0.089301356,
        "school_enrollment_primary": 0.252761866,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.657248157,
        "demographic_pressures_indicator": 0.701149425,
        "cost_of_living": 0.162350012,
        "happiness_index": 0.684135472,
        "human_development_index": 0.315789474,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000873747,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "STP",
        "country": "Sao Tome and Principe",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 29,
        "economic_freedom": 60,
        "education": 25,
        "lifestyle": 45,
        "private_healthcare": 18,
        "safety_security": 65,
        "climate_resilience_score": 0.184466019,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000021,
        "gdp_per_capita": 0.012755908,
        "gdp_growth_annual_percentage_2021": 0.400810537,
        "haq": 0.318181818,
        "domestic_private_health_expenditure_per_capita": 0.00259046,
        "domestic_private_health_expenditure": 0.199382129,
        "global_health_security_index": 0.176961603,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.0000586,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.463768116,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.13632951,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.703931204,
        "demographic_pressures_indicator": 0.655172414,
        "cost_of_living": 0.237041392,
        "happiness_index": 0.684135472,
        "human_development_index": 0.421052632,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.008753796,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "RWA",
        "country": "Rwanda",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 29,
        "economic_freedom": 57,
        "education": 18,
        "lifestyle": 29,
        "private_healthcare": 20,
        "safety_security": 61,
        "climate_resilience_score": 0.182524272,
        "safety_and_security": 0.657539845,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000478659,
        "gdp_per_capita": 0.003442059,
        "gdp_growth_annual_percentage_2021": 0.584802432,
        "haq": 0.290909091,
        "domestic_private_health_expenditure_per_capita": 0.001471333,
        "domestic_private_health_expenditure": 0.283032319,
        "global_health_security_index": 0.285475793,
        "insurance_companies_number": 0.01986755,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000290023,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.001506366,
        "innovation_index": 0.176237624,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.304347826,
        "quality_index": 0.492578125,
        "opportunity_index": 0.245426932,
        "school_enrollment_secondary": 0.128884254,
        "school_enrollment_primary": 0.042246318,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.664619165,
        "demographic_pressures_indicator": 0.689655172,
        "cost_of_living": 0.160966838,
        "happiness_index": 0.1942959,
        "human_development_index": 0.263157895,
        "standard_of_living_index_by_world_population_review": 0.291956747,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.02035401,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "TON",
        "country": "Tonga",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 42,
        "climate_resilience": 29,
        "economic_freedom": 61,
        "education": 31,
        "lifestyle": 41,
        "private_healthcare": 25,
        "safety_security": 65,
        "climate_resilience_score": 0.182524272,
        "safety_and_security": 0.740825501,
        "total_business_opportunity": 0.788853299,
        "open_for_business": 0.510589769,
        "entrepreneurship": 0.228761468,
        "gdp_2021": 0.0000384,
        "gdp_per_capita": 0.037172616,
        "gdp_growth_annual_percentage_2021": 0.410010132,
        "haq": 0.507575758,
        "domestic_private_health_expenditure_per_capita": 0.004471936,
        "domestic_private_health_expenditure": 0.133673954,
        "global_health_security_index": 0.173622705,
        "insurance_companies_number": 0.001655629,
        "number_of_private_hospitals": 0.000093,
        "health_care_system": 0.1458,
        "health_care_index": 0.370064795,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0.0000496,
        "land_area": 0.0000439,
        "innovation_index": 0.438811881,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.768115942,
        "quality_index": 0.3515625,
        "opportunity_index": 0.154100574,
        "school_enrollment_secondary": 0.266527633,
        "school_enrollment_primary": 0.183306056,
        "best_countries_for_education": 0.1528,
        "economic_freedom_index": 0.71007371,
        "demographic_pressures_indicator": 0.547126437,
        "cost_of_living": 0.243265673,
        "happiness_index": 0.633868093,
        "human_development_index": 0.596491228,
        "standard_of_living_index_by_world_population_review": 0.251577544,
        "ccpi": 0.53387883,
        "population_density_per_km2": 0.005549299,
        "quality_of_life": 0.185240122
    },
    {
        "iso_code": "NPL",
        "country": "Nepal",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 29,
        "economic_freedom": 50,
        "education": 22,
        "lifestyle": 42,
        "private_healthcare": 20,
        "safety_security": 61,
        "climate_resilience_score": 0.182524272,
        "safety_and_security": 0.656722517,
        "total_business_opportunity": 0.613452915,
        "open_for_business": 0.48914956,
        "entrepreneurship": 0.142683486,
        "gdp_2021": 0.001575303,
        "gdp_per_capita": 0.005685051,
        "gdp_growth_annual_percentage_2021": 0.450455927,
        "haq": 0.336363636,
        "domestic_private_health_expenditure_per_capita": 0.004551221,
        "domestic_private_health_expenditure": 0.722908745,
        "global_health_security_index": 0.300500835,
        "insurance_companies_number": 0.041390728,
        "number_of_private_hospitals": 0.008511628,
        "health_care_system": 0.0846,
        "health_care_index": 0.100647948,
        "insurance_companies_number_vs_population_density": 0.001740139,
        "number_of_private_hospitals_vs_population_density": 0.002925185,
        "land_area": 0.008753172,
        "innovation_index": 0.148514852,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.002605524,
        "education_index": 0.391304348,
        "quality_index": 0.56328125,
        "opportunity_index": 0.286736416,
        "school_enrollment_secondary": 0.092012513,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0856,
        "economic_freedom_index": 0.573710074,
        "demographic_pressures_indicator": 0.816091954,
        "cost_of_living": 0.099934299,
        "happiness_index": 0.434937611,
        "human_development_index": 0.368421053,
        "standard_of_living_index_by_world_population_review": 0.653384684,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.007779422,
        "quality_of_life": 0.137823708
    },
    {
        "iso_code": "LSO",
        "country": "Lesotho",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 29,
        "economic_freedom": 48,
        "education": 23,
        "lifestyle": 37,
        "private_healthcare": 15,
        "safety_security": 58,
        "climate_resilience_score": 0.182524272,
        "safety_and_security": 0.598692276,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000106774,
        "gdp_per_capita": 0.005359773,
        "gdp_growth_annual_percentage_2021": 0.385005066,
        "haq": 0.107575758,
        "domestic_private_health_expenditure_per_capita": 0.002097983,
        "domestic_private_health_expenditure": 0.139496198,
        "global_health_security_index": 0.248747913,
        "insurance_companies_number": 0.014900662,
        "number_of_private_hospitals": 0.000232558,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001885151,
        "number_of_private_hospitals_vs_population_density": 0.000231371,
        "land_area": 0.001853807,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.405797101,
        "quality_index": 0.43671875,
        "opportunity_index": 0.231387108,
        "school_enrollment_secondary": 0.062794578,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.554054054,
        "demographic_pressures_indicator": 0.873563218,
        "cost_of_living": 0.110480999,
        "happiness_index": 0.237076649,
        "human_development_index": 0.245614035,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002619342,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "PAK",
        "country": "Pakistan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 37,
        "climate_resilience": 28,
        "economic_freedom": 49,
        "education": 16,
        "lifestyle": 41,
        "private_healthcare": 14,
        "safety_security": 44,
        "climate_resilience_score": 0.180582524,
        "safety_and_security": 0.312627707,
        "total_business_opportunity": 0.574554773,
        "open_for_business": 0.565917237,
        "entrepreneurship": 0.178486239,
        "gdp_2021": 0.01505825,
        "gdp_per_capita": 0.007501468,
        "gdp_growth_annual_percentage_2021": 0.486524823,
        "haq": 0.21969697,
        "domestic_private_health_expenditure_per_capita": 0.003081413,
        "domestic_private_health_expenditure": 0.69486692,
        "global_health_security_index": 0.240400668,
        "insurance_companies_number": 0.089403974,
        "number_of_private_hospitals": 0.01627907,
        "health_care_system": 0.069,
        "health_care_index": 0.002159827,
        "insurance_companies_number_vs_population_density": 0.002610209,
        "number_of_private_hospitals_vs_population_density": 0.003966352,
        "land_area": 0.04707124,
        "innovation_index": 0.186138614,
        "number_of_universities_in_top_1000": 0.038674033,
        "number_of_top_tier_international_schools": 0.016154247,
        "education_index": 0.217391304,
        "quality_index": 0.150390625,
        "opportunity_index": 0.022274722,
        "school_enrollment_secondary": 0.337643379,
        "school_enrollment_primary": 0.355973813,
        "best_countries_for_education": 0.0578,
        "economic_freedom_index": 0.562653563,
        "demographic_pressures_indicator": 0.793103448,
        "cost_of_living": 0.402157751,
        "happiness_index": 0.411764706,
        "human_development_index": 0.298245614,
        "standard_of_living_index_by_world_population_review": 0.37964746,
        "ccpi": 0.392305014,
        "population_density_per_km2": 0.01101164,
        "quality_of_life": 0.201677812
    },
    {
        "iso_code": "BOL",
        "country": "Bolivia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 36,
        "climate_resilience": 28,
        "economic_freedom": 43,
        "education": 26,
        "lifestyle": 45,
        "private_healthcare": 24,
        "safety_security": 60,
        "climate_resilience_score": 0.170873786,
        "safety_and_security": 0.639558643,
        "total_business_opportunity": 0.598821268,
        "open_for_business": 0.505571848,
        "entrepreneurship": 0.146376147,
        "gdp_2021": 0.001754437,
        "gdp_per_capita": 0.018322655,
        "gdp_growth_annual_percentage_2021": 0.488145897,
        "haq": 0.463636364,
        "domestic_private_health_expenditure_per_capita": 0.009774833,
        "domestic_private_health_expenditure": 0.299429658,
        "global_health_security_index": 0.232053422,
        "insurance_companies_number": 0.216887417,
        "number_of_private_hospitals": 0.000581395,
        "health_care_system": 0.0878,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.17386891,
        "number_of_private_hospitals_vs_population_density": 0.003784561,
        "land_area": 0.066148146,
        "innovation_index": 0.166336634,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.652173913,
        "quality_index": 0.56328125,
        "opportunity_index": 0.285723929,
        "school_enrollment_secondary": 0.118978102,
        "school_enrollment_primary": 0.105155483,
        "best_countries_for_education": 0.083,
        "economic_freedom_index": 0.491400491,
        "demographic_pressures_indicator": 0.67816092,
        "cost_of_living": 0.190013486,
        "happiness_index": 0.604278075,
        "human_development_index": 0.578947368,
        "standard_of_living_index_by_world_population_review": 0.484550437,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.000333398,
        "quality_of_life": 0.145702128
    },
    {
        "iso_code": "BGD",
        "country": "Bangladesh",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 45,
        "climate_resilience": 28,
        "economic_freedom": 53,
        "education": 24,
        "lifestyle": 48,
        "private_healthcare": 25,
        "safety_security": 59,
        "climate_resilience_score": 0.170873786,
        "safety_and_security": 0.607682877,
        "total_business_opportunity": 0.610506086,
        "open_for_business": 0.578820463,
        "entrepreneurship": 0.444059633,
        "gdp_2021": 0.018098851,
        "gdp_per_capita": 0.013065563,
        "gdp_growth_annual_percentage_2021": 0.504964539,
        "haq": 0.35,
        "domestic_private_health_expenditure_per_capita": 0.004674721,
        "domestic_private_health_expenditure": 0.865256654,
        "global_health_security_index": 0.325542571,
        "insurance_companies_number": 0.05794702,
        "number_of_private_hospitals": 0.022674419,
        "health_care_system": 0.3496,
        "health_care_index": 0.010151188,
        "insurance_companies_number_vs_population_density": 0.000435035,
        "number_of_private_hospitals_vs_population_density": 0.001256012,
        "land_area": 0.007948379,
        "innovation_index": 0.102970297,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.003647733,
        "education_index": 0.405797101,
        "quality_index": 0.50546875,
        "opportunity_index": 0.249544381,
        "school_enrollment_secondary": 0.072116788,
        "school_enrollment_primary": 0.244476268,
        "best_countries_for_education": 0.353,
        "economic_freedom_index": 0.610565111,
        "demographic_pressures_indicator": 0.724137931,
        "cost_of_living": 0.117742661,
        "happiness_index": 0.55258467,
        "human_development_index": 0.421052632,
        "standard_of_living_index_by_world_population_review": 0.676492372,
        "ccpi": 0.514449861,
        "population_density_per_km2": 0.048432002,
        "quality_of_life": 0.412158055
    },
    {
        "iso_code": "NIC",
        "country": "Nicaragua",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 28,
        "economic_freedom": 55,
        "education": 25,
        "lifestyle": 40,
        "private_healthcare": 27,
        "safety_security": 53,
        "climate_resilience_score": 0.170873786,
        "safety_and_security": 0.498569677,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000606623,
        "gdp_per_capita": 0.010688585,
        "gdp_growth_annual_percentage_2021": 0.573860182,
        "haq": 0.540909091,
        "domestic_private_health_expenditure_per_capita": 0.008323321,
        "domestic_private_health_expenditure": 0.402923004,
        "global_health_security_index": 0.338898164,
        "insurance_companies_number": 0.094370861,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.014791183,
        "number_of_private_hospitals_vs_population_density": 0.0000331,
        "land_area": 0.007348142,
        "innovation_index": 0.368712871,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.463768116,
        "quality_index": 0.4828125,
        "opportunity_index": 0.24400945,
        "school_enrollment_secondary": 0.080875912,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.636363636,
        "demographic_pressures_indicator": 0.459770115,
        "cost_of_living": 0.162350012,
        "happiness_index": 0.698752228,
        "human_development_index": 0.473684211,
        "standard_of_living_index_by_world_population_review": 0.459368982,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002033806,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SEN",
        "country": "Senegal",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 28,
        "economic_freedom": 60,
        "education": 18,
        "lifestyle": 37,
        "private_healthcare": 21,
        "safety_security": 62,
        "climate_resilience_score": 0.168932039,
        "safety_and_security": 0.669391091,
        "total_business_opportunity": 0.627008328,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.001198567,
        "gdp_per_capita": 0.007896564,
        "gdp_growth_annual_percentage_2021": 0.487132725,
        "haq": 0.239393939,
        "domestic_private_health_expenditure_per_capita": 0.004551221,
        "domestic_private_health_expenditure": 0.648645437,
        "global_health_security_index": 0.280467446,
        "insurance_companies_number": 0.074503311,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.00725058,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.011756188,
        "innovation_index": 0.164356436,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.144927536,
        "quality_index": 0.566015625,
        "opportunity_index": 0.294701316,
        "school_enrollment_secondary": 0.090093848,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.7002457,
        "demographic_pressures_indicator": 0.701149425,
        "cost_of_living": 0.262630105,
        "happiness_index": 0.484848485,
        "human_development_index": 0.210526316,
        "standard_of_living_index_by_world_population_review": 0.459368982,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.003310441,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "VUT",
        "country": "Vanuatu",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 28,
        "economic_freedom": 63,
        "education": 25,
        "lifestyle": 47,
        "private_healthcare": 16,
        "safety_security": 65,
        "climate_resilience_score": 0.168932039,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00004,
        "gdp_per_capita": 0.016665476,
        "gdp_growth_annual_percentage_2021": 0.375075988,
        "haq": 0.21969697,
        "domestic_private_health_expenditure_per_capita": 0.001268548,
        "domestic_private_health_expenditure": 0.109790875,
        "global_health_security_index": 0.165275459,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001740139,
        "number_of_private_hospitals_vs_population_density": 0.0000661,
        "land_area": 0.000744316,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.449275362,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.235933264,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.735872236,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.547218092,
        "happiness_index": 0.684135472,
        "human_development_index": 0.385964912,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000898429,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "LAO",
        "country": "Laos",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 28,
        "economic_freedom": 49,
        "education": 19,
        "lifestyle": 36,
        "private_healthcare": 21,
        "safety_security": 64,
        "climate_resilience_score": 0.163106796,
        "safety_and_security": 0.713118104,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000815969,
        "gdp_per_capita": 0.013343969,
        "gdp_growth_annual_percentage_2021": 0.415602837,
        "haq": 0.246969697,
        "domestic_private_health_expenditure_per_capita": 0.003767526,
        "domestic_private_health_expenditure": 0.468393536,
        "global_health_security_index": 0.313856427,
        "insurance_companies_number": 0.036423841,
        "number_of_private_hospitals": 0.000395349,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.0100058,
        "number_of_private_hospitals_vs_population_density": 0.000875903,
        "land_area": 0.014093021,
        "innovation_index": 0.102970297,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.333333333,
        "quality_index": 0.555078125,
        "opportunity_index": 0.27276409,
        "school_enrollment_secondary": 0.157831074,
        "school_enrollment_primary": 0.063420622,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.567567568,
        "demographic_pressures_indicator": 0.620689655,
        "cost_of_living": 0.073308206,
        "happiness_index": 0.490196078,
        "human_development_index": 0.385964912,
        "standard_of_living_index_by_world_population_review": 0.459368982,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001132719,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "GNQ",
        "country": "Equatorial Guinea",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 28,
        "economic_freedom": 47,
        "education": 22,
        "lifestyle": 42,
        "private_healthcare": 18,
        "safety_security": 63,
        "climate_resilience_score": 0.163106796,
        "safety_and_security": 0.691050266,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0005308,
        "gdp_per_capita": 0.047422451,
        "gdp_growth_annual_percentage_2021": 0.34508612,
        "haq": 0.3,
        "domestic_private_health_expenditure_per_capita": 0.029661456,
        "domestic_private_health_expenditure": 0.895793726,
        "global_health_security_index": 0.023372287,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001450116,
        "number_of_private_hospitals_vs_population_density": 0.0000992,
        "land_area": 0.001712755,
        "innovation_index": 0.308910891,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.31884058,
        "quality_index": 0.492578125,
        "opportunity_index": 0.245426932,
        "school_enrollment_secondary": 0.114452555,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.542997543,
        "demographic_pressures_indicator": 0.862068966,
        "cost_of_living": 0.110480999,
        "happiness_index": 0.684135472,
        "human_development_index": 0.350877193,
        "standard_of_living_index_by_world_population_review": 0.374018664,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001881536,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "TGO",
        "country": "Togo",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 28,
        "economic_freedom": 57,
        "education": 21,
        "lifestyle": 30,
        "private_healthcare": 20,
        "safety_security": 58,
        "climate_resilience_score": 0.163106796,
        "safety_and_security": 0.596648958,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00036311,
        "gdp_per_capita": 0.00435586,
        "gdp_growth_annual_percentage_2021": 0.470921986,
        "haq": 0.237878788,
        "domestic_private_health_expenditure_per_capita": 0.005325767,
        "domestic_private_health_expenditure": 0.871791825,
        "global_health_security_index": 0.196994992,
        "insurance_companies_number": 0.018211921,
        "number_of_private_hospitals": 0.00827907,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001015081,
        "number_of_private_hospitals_vs_population_density": 0.003768035,
        "land_area": 0.003321121,
        "innovation_index": 0.085148515,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.391304348,
        "quality_index": 0.534375,
        "opportunity_index": 0.258926763,
        "school_enrollment_secondary": 0.102523462,
        "school_enrollment_primary": 0.315671031,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.665847666,
        "demographic_pressures_indicator": 0.701149425,
        "cost_of_living": 0.250181542,
        "happiness_index": 0.331550802,
        "human_development_index": 0.228070175,
        "standard_of_living_index_by_world_population_review": 0.139238631,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.005837889,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "HND",
        "country": "Honduras",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 38,
        "climate_resilience": 28,
        "economic_freedom": 60,
        "education": 21,
        "lifestyle": 43,
        "private_healthcare": 22,
        "safety_security": 55,
        "climate_resilience_score": 0.163106796,
        "safety_and_security": 0.525132816,
        "total_business_opportunity": 0.627008328,
        "open_for_business": 0.524796351,
        "entrepreneurship": 0.139449541,
        "gdp_2021": 0.001236107,
        "gdp_per_capita": 0.014956525,
        "gdp_growth_annual_percentage_2021": 0.618237082,
        "haq": 0.383333333,
        "domestic_private_health_expenditure_per_capita": 0.016053535,
        "domestic_private_health_expenditure": 0.662428707,
        "global_health_security_index": 0.170283806,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.000093,
        "health_care_system": 0.0766,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.00087007,
        "number_of_private_hospitals_vs_population_density": 0.0000661,
        "land_area": 0.00683217,
        "innovation_index": 0.154455446,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.362318841,
        "quality_index": 0.566015625,
        "opportunity_index": 0.294701316,
        "school_enrollment_secondary": 0.118873827,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0806,
        "economic_freedom_index": 0.694103194,
        "demographic_pressures_indicator": 0.632183908,
        "cost_of_living": 0.233756354,
        "happiness_index": 0.700534759,
        "human_development_index": 0.421052632,
        "standard_of_living_index_by_world_population_review": 0.459368982,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.003333984,
        "quality_of_life": 0.147744681
    },
    {
        "iso_code": "CIV",
        "country": "Cote d’Ivoire",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 34,
        "climate_resilience": 27,
        "economic_freedom": 62,
        "education": 23,
        "lifestyle": 43,
        "private_healthcare": 20,
        "safety_security": 57,
        "climate_resilience_score": 0.161165049,
        "safety_and_security": 0.576215774,
        "total_business_opportunity": 0.575912876,
        "open_for_business": 0.446334311,
        "entrepreneurship": 0.157041284,
        "gdp_2021": 0.003031032,
        "gdp_per_capita": 0.013502111,
        "gdp_growth_annual_percentage_2021": 0.506585613,
        "haq": 0.209090909,
        "domestic_private_health_expenditure_per_capita": 0.00578775,
        "domestic_private_health_expenditure": 0.632604563,
        "global_health_security_index": 0.25375626,
        "insurance_companies_number": 0.086092715,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.083,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.008845708,
        "number_of_private_hospitals_vs_population_density": 0.0000331,
        "land_area": 0.019417604,
        "innovation_index": 0.118811881,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.289855073,
        "quality_index": 0.559375,
        "opportunity_index": 0.28079649,
        "school_enrollment_secondary": 0.526903024,
        "school_enrollment_primary": 0.14811784,
        "best_countries_for_education": 0.0924,
        "economic_freedom_index": 0.71990172,
        "demographic_pressures_indicator": 0.827586207,
        "cost_of_living": 0.243611467,
        "happiness_index": 0.513368984,
        "human_development_index": 0.263157895,
        "standard_of_living_index_by_world_population_review": 0.571619019,
        "ccpi": 0.444707521,
        "population_density_per_km2": 0.003149058,
        "quality_of_life": 0.14181155
    },
    {
        "iso_code": "KEN",
        "country": "Kenya",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 27,
        "economic_freedom": 53,
        "education": 23,
        "lifestyle": 41,
        "private_healthcare": 17,
        "safety_security": 54,
        "climate_resilience_score": 0.159223301,
        "safety_and_security": 0.511238251,
        "total_business_opportunity": 0.602946829,
        "open_for_business": 0.521016618,
        "entrepreneurship": 0.0125,
        "gdp_2021": 0.004795782,
        "gdp_per_capita": 0.010204761,
        "gdp_growth_annual_percentage_2021": 0.516717325,
        "haq": 0.304545455,
        "domestic_private_health_expenditure_per_capita": 0.003929144,
        "domestic_private_health_expenditure": 0.392942015,
        "global_health_security_index": 0.380634391,
        "insurance_companies_number": 0.029801325,
        "number_of_private_hospitals": 0.002395349,
        "health_care_system": 0.002,
        "health_care_index": 0.059179266,
        "insurance_companies_number_vs_population_density": 0.00275522,
        "number_of_private_hospitals_vs_population_density": 0.001768332,
        "land_area": 0.034752647,
        "innovation_index": 0.247524753,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.005732152,
        "education_index": 0.405797101,
        "quality_index": 0.5515625,
        "opportunity_index": 0.271684104,
        "school_enrollment_secondary": 0.124337852,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.01,
        "economic_freedom_index": 0.609336609,
        "demographic_pressures_indicator": 0.816091954,
        "cost_of_living": 0.198312528,
        "happiness_index": 0.406417112,
        "human_development_index": 0.368421053,
        "standard_of_living_index_by_world_population_review": 0.64064583,
        "ccpi": 0.498885794,
        "population_density_per_km2": 0.00358726,
        "quality_of_life": 0.053981763
    },
    {
        "iso_code": "ZMB",
        "country": "Zambia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 27,
        "economic_freedom": 49,
        "education": 17,
        "lifestyle": 35,
        "private_healthcare": 16,
        "safety_security": 63,
        "climate_resilience_score": 0.159223301,
        "safety_and_security": 0.700040866,
        "total_business_opportunity": 0.575631006,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000919287,
        "gdp_per_capita": 0.005095549,
        "gdp_growth_annual_percentage_2021": 0.436676798,
        "haq": 0.196969697,
        "domestic_private_health_expenditure_per_capita": 0.001126751,
        "domestic_private_health_expenditure": 0.16361692,
        "global_health_security_index": 0.175292154,
        "insurance_companies_number": 0.011589404,
        "number_of_private_hospitals": 0.005813953,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.004060325,
        "number_of_private_hospitals_vs_population_density": 0.016228991,
        "land_area": 0.045392653,
        "innovation_index": 0.095049505,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.449275362,
        "quality_index": 0.345703125,
        "opportunity_index": 0.087748903,
        "school_enrollment_secondary": 0.134264859,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.561425061,
        "demographic_pressures_indicator": 0.91954023,
        "cost_of_living": 0.20609288,
        "happiness_index": 0.160427808,
        "human_development_index": 0.333333333,
        "standard_of_living_index_by_world_population_review": 0.361516812,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000885139,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SWZ",
        "country": "eSwatini",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 27,
        "economic_freedom": 51,
        "education": 24,
        "lifestyle": 34,
        "private_healthcare": 17,
        "safety_security": 59,
        "climate_resilience_score": 0.153398058,
        "safety_and_security": 0.621577442,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000212135,
        "gdp_per_capita": 0.022934725,
        "gdp_growth_annual_percentage_2021": 0.514893617,
        "haq": 0.201515152,
        "domestic_private_health_expenditure_per_capita": 0.00873194,
        "domestic_private_health_expenditure": 0.246078897,
        "global_health_security_index": 0.222036728,
        "insurance_companies_number": 0.006622517,
        "number_of_private_hospitals": 0.000255814,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.00087007,
        "number_of_private_hospitals_vs_population_density": 0.000264423,
        "land_area": 0.001050235,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.449275362,
        "quality_index": 0.471484375,
        "opportunity_index": 0.240161998,
        "school_enrollment_secondary": 0.069259645,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.594594595,
        "demographic_pressures_indicator": 0.885057471,
        "cost_of_living": 0.15353228,
        "happiness_index": 0.395721925,
        "human_development_index": 0.385964912,
        "standard_of_living_index_by_world_population_review": 0.092134499,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002506943,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MRT",
        "country": "Mauritania",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 27,
        "economic_freedom": 55,
        "education": 22,
        "lifestyle": 31,
        "private_healthcare": 21,
        "safety_security": 56,
        "climate_resilience_score": 0.153398058,
        "safety_and_security": 0.556191255,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000355039,
        "gdp_per_capita": 0.008568453,
        "gdp_growth_annual_percentage_2021": 0.410942249,
        "haq": 0.354545455,
        "domestic_private_health_expenditure_per_capita": 0.003883403,
        "domestic_private_health_expenditure": 0.572837453,
        "global_health_security_index": 0.170283806,
        "insurance_companies_number": 0.021523179,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.04074826,
        "number_of_private_hospitals_vs_population_density": 0.00107422,
        "land_area": 0.062936299,
        "innovation_index": 0.295445545,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.217391304,
        "quality_index": 0.534375,
        "opportunity_index": 0.258926763,
        "school_enrollment_secondary": 0.255161627,
        "school_enrollment_primary": 0.160188216,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.642506143,
        "demographic_pressures_indicator": 0.827586207,
        "cost_of_living": 0.162350012,
        "happiness_index": 0.351158645,
        "human_development_index": 0.280701754,
        "standard_of_living_index_by_world_population_review": 0.096726411,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.0000946,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "TZA",
        "country": "Tanzania",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 27,
        "economic_freedom": 60,
        "education": 19,
        "lifestyle": 39,
        "private_healthcare": 20,
        "safety_security": 60,
        "climate_resilience_score": 0.149514563,
        "safety_and_security": 0.634654679,
        "total_business_opportunity": 0.575912876,
        "open_for_business": 0.446334311,
        "entrepreneurship": 0.157041284,
        "gdp_2021": 0.002944507,
        "gdp_per_capita": 0.005181509,
        "gdp_growth_annual_percentage_2021": 0.45106383,
        "haq": 0.322727273,
        "domestic_private_health_expenditure_per_capita": 0.000826386,
        "domestic_private_health_expenditure": 0.243940114,
        "global_health_security_index": 0.25542571,
        "insurance_companies_number": 0.049668874,
        "number_of_private_hospitals": 0.002093023,
        "health_care_system": 0.083,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.006235499,
        "number_of_private_hospitals_vs_population_density": 0.002148441,
        "land_area": 0.054088454,
        "innovation_index": 0.20990099,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.260869565,
        "quality_index": 0.559375,
        "opportunity_index": 0.28079649,
        "school_enrollment_secondary": 0.051094891,
        "school_enrollment_primary": 0.039893617,
        "best_countries_for_education": 0.0924,
        "economic_freedom_index": 0.694103194,
        "demographic_pressures_indicator": 0.873563218,
        "cost_of_living": 0.166499533,
        "happiness_index": 0.267379679,
        "human_development_index": 0.245614035,
        "standard_of_living_index_by_world_population_review": 0.645237743,
        "ccpi": 0.444707521,
        "population_density_per_km2": 0.002555168,
        "quality_of_life": 0.14181155
    },
    {
        "iso_code": "CMR",
        "country": "Cameroon",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 27,
        "economic_freedom": 53,
        "education": 20,
        "lifestyle": 41,
        "private_healthcare": 22,
        "safety_security": 46,
        "climate_resilience_score": 0.149514563,
        "safety_and_security": 0.345320801,
        "total_business_opportunity": 0.530890455,
        "open_for_business": 0.505571848,
        "entrepreneurship": 0.146376147,
        "gdp_2021": 0.001964491,
        "gdp_per_capita": 0.008214982,
        "gdp_growth_annual_percentage_2021": 0.435055724,
        "haq": 0.239393939,
        "domestic_private_health_expenditure_per_capita": 0.006199418,
        "domestic_private_health_expenditure": 0.950570342,
        "global_health_security_index": 0.210350584,
        "insurance_companies_number": 0.041390728,
        "number_of_private_hospitals": 0.001162791,
        "health_care_system": 0.0878,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.006235499,
        "number_of_private_hospitals_vs_population_density": 0.001437803,
        "land_area": 0.028864464,
        "innovation_index": 0.093069307,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.434782609,
        "quality_index": 0.4390625,
        "opportunity_index": 0.232467094,
        "school_enrollment_secondary": 0.11434828,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.083,
        "economic_freedom_index": 0.613022113,
        "demographic_pressures_indicator": 0.862068966,
        "cost_of_living": 0.069566721,
        "happiness_index": 0.495543672,
        "human_development_index": 0.298245614,
        "standard_of_living_index_by_world_population_review": 0.578580951,
        "ccpi": 0.4045961,
        "population_density_per_km2": 0.002105574,
        "quality_of_life": 0.145702128
    },
    {
        "iso_code": "GIN",
        "country": "Guinea",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 27,
        "economic_freedom": 54,
        "education": 16,
        "lifestyle": 36,
        "private_healthcare": 18,
        "safety_security": 53,
        "climate_resilience_score": 0.14368932,
        "safety_and_security": 0.499387005,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000686528,
        "gdp_per_capita": 0.005405261,
        "gdp_growth_annual_percentage_2021": 0.427558257,
        "haq": 0.151515152,
        "domestic_private_health_expenditure_per_capita": 0.003788872,
        "domestic_private_health_expenditure": 0.763307985,
        "global_health_security_index": 0.180300501,
        "insurance_companies_number": 0.001655629,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000290023,
        "number_of_private_hospitals_vs_population_density": 0.0000826,
        "land_area": 0.015004062,
        "innovation_index": 0.033663366,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.144927536,
        "quality_index": 0.529296875,
        "opportunity_index": 0.254539318,
        "school_enrollment_secondary": 0.20919708,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.628992629,
        "demographic_pressures_indicator": 0.896551724,
        "cost_of_living": 0.064317577,
        "happiness_index": 0.49197861,
        "human_development_index": 0.157894737,
        "standard_of_living_index_by_world_population_review": 0.435639165,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002004567,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "ETH",
        "country": "Ethiopia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 26,
        "economic_freedom": 50,
        "education": 16,
        "lifestyle": 43,
        "private_healthcare": 22,
        "safety_security": 44,
        "climate_resilience_score": 0.141747573,
        "safety_and_security": 0.305680425,
        "total_business_opportunity": 0.602946829,
        "open_for_business": 0.52720756,
        "entrepreneurship": 0.126857798,
        "gdp_2021": 0.004835964,
        "gdp_per_capita": 0.00407705,
        "gdp_growth_annual_percentage_2021": 0.478622087,
        "haq": 0.236363636,
        "domestic_private_health_expenditure_per_capita": 0.001174017,
        "domestic_private_health_expenditure": 0.484196768,
        "global_health_security_index": 0.3639399,
        "insurance_companies_number": 0.028145695,
        "number_of_private_hospitals": 0.00072093,
        "health_care_system": 0.0632,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.002320186,
        "number_of_private_hospitals_vs_population_density": 0.000495794,
        "land_area": 0.06895701,
        "innovation_index": 0.071287129,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.130434783,
        "quality_index": 0.5515625,
        "opportunity_index": 0.271684104,
        "school_enrollment_secondary": 0.124337852,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0546,
        "economic_freedom_index": 0.572481573,
        "demographic_pressures_indicator": 0.965517241,
        "cost_of_living": 0.247069401,
        "happiness_index": 0.422459893,
        "human_development_index": 0.175438597,
        "standard_of_living_index_by_world_population_review": 0.614723745,
        "ccpi": 0.498885794,
        "population_density_per_km2": 0.003882307,
        "quality_of_life": 0.139744681
    },
    {
        "iso_code": "FSM",
        "country": "Micronesia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 26,
        "economic_freedom": 61,
        "education": 25,
        "lifestyle": 42,
        "private_healthcare": 19,
        "safety_security": 65,
        "climate_resilience_score": 0.139805825,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000148,
        "gdp_per_capita": 0.01867872,
        "gdp_growth_annual_percentage_2021": 0.299696049,
        "haq": 0.381818182,
        "domestic_private_health_expenditure_per_capita": 0.001224332,
        "domestic_private_health_expenditure": 0.004990494,
        "global_health_security_index": 0.208681135,
        "insurance_companies_number": 0.003311258,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.0000427,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.47826087,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.13632951,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.712530713,
        "demographic_pressures_indicator": 0.551724138,
        "cost_of_living": 0.16719112,
        "happiness_index": 0.684135472,
        "human_development_index": 0.403508772,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.006225209,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "GMB",
        "country": "Gambia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 26,
        "economic_freedom": 58,
        "education": 22,
        "lifestyle": 32,
        "private_healthcare": 20,
        "safety_security": 64,
        "climate_resilience_score": 0.137864078,
        "safety_and_security": 0.720065386,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000876,
        "gdp_per_capita": 0.003452206,
        "gdp_growth_annual_percentage_2021": 0.478419453,
        "haq": 0.31969697,
        "domestic_private_health_expenditure_per_capita": 0.000658669,
        "domestic_private_health_expenditure": 0.297528517,
        "global_health_security_index": 0.212020033,
        "insurance_companies_number": 0.018211921,
        "number_of_private_hospitals": 0.000534884,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.000148738,
        "land_area": 0.000617918,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.231884058,
        "quality_index": 0.43671875,
        "opportunity_index": 0.231387108,
        "school_enrollment_secondary": 0.112137643,
        "school_enrollment_primary": 0.307180851,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.675675676,
        "demographic_pressures_indicator": 0.827586207,
        "cost_of_living": 0.165462153,
        "happiness_index": 0.531194296,
        "human_development_index": 0.192982456,
        "standard_of_living_index_by_world_population_review": 0.047252259,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.009250097,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SYR",
        "country": "Syria",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 32,
        "climate_resilience": 26,
        "economic_freedom": 65,
        "education": 18,
        "lifestyle": 24,
        "private_healthcare": 24,
        "safety_security": 33,
        "climate_resilience_score": 0.133980583,
        "safety_and_security": 0.080915407,
        "total_business_opportunity": 0.573068546,
        "open_for_business": 0.47637667,
        "entrepreneurship": 0.037270642,
        "gdp_2021": 0.001126656,
        "gdp_per_capita": 0.034228748,
        "gdp_growth_annual_percentage_2021": 0.514285714,
        "haq": 0.696969697,
        "domestic_private_health_expenditure_per_capita": 0.024386919,
        "domestic_private_health_expenditure": 0.550237643,
        "global_health_security_index": 0.011686144,
        "insurance_companies_number": 0.024834437,
        "number_of_private_hospitals": 0.009139535,
        "health_care_system": 0.0256,
        "health_care_index": 0.308077754,
        "insurance_companies_number_vs_population_density": 0.002175174,
        "number_of_private_hospitals_vs_population_density": 0.006527955,
        "land_area": 0.011212739,
        "innovation_index": 0.189306931,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.246376812,
        "quality_index": 0.573828125,
        "opportunity_index": 0.223489706,
        "school_enrollment_secondary": 0.066131387,
        "school_enrollment_primary": 0.065711948,
        "best_countries_for_education": 0.0372,
        "economic_freedom_index": 0.757002457,
        "demographic_pressures_indicator": 0.689655172,
        "cost_of_living": 0.102700647,
        "happiness_index": 0.228163993,
        "human_development_index": 0.315789474,
        "standard_of_living_index_by_world_population_review": 0,
        "ccpi": 0.57433844,
        "population_density_per_km2": 0.00369776,
        "quality_of_life": 0.092790274
    },
    {
        "iso_code": "KHM",
        "country": "Cambodia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 34,
        "climate_resilience": 26,
        "economic_freedom": 57,
        "education": 19,
        "lifestyle": 39,
        "private_healthcare": 22,
        "safety_security": 62,
        "climate_resilience_score": 0.133980583,
        "safety_and_security": 0.683285656,
        "total_business_opportunity": 0.627008328,
        "open_for_business": 0.593678723,
        "entrepreneurship": 0.013646789,
        "gdp_2021": 0.001169678,
        "gdp_per_capita": 0.007807144,
        "gdp_growth_annual_percentage_2021": 0.425734549,
        "haq": 0.334848485,
        "domestic_private_health_expenditure_per_capita": 0.011366616,
        "domestic_private_health_expenditure": 0.793132129,
        "global_health_security_index": 0.252086811,
        "insurance_companies_number": 0.026490066,
        "number_of_private_hospitals": 0.001255814,
        "health_care_system": 0.01,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.002465197,
        "number_of_private_hospitals_vs_population_density": 0.000925482,
        "land_area": 0.01077859,
        "innovation_index": 0.154455446,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.333333333,
        "quality_index": 0.566015625,
        "opportunity_index": 0.294701316,
        "school_enrollment_secondary": 0.090093848,
        "school_enrollment_primary": 0.053293781,
        "best_countries_for_education": 0.015,
        "economic_freedom_index": 0.664619165,
        "demographic_pressures_indicator": 0.643678161,
        "cost_of_living": 0.258826377,
        "happiness_index": 0.424242424,
        "human_development_index": 0.350877193,
        "standard_of_living_index_by_world_population_review": 0.557398904,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.003564097,
        "quality_of_life": 0.114042553
    },
    {
        "iso_code": "AGO",
        "country": "Angola",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 26,
        "economic_freedom": 53,
        "education": 19,
        "lifestyle": 45,
        "private_healthcare": 20,
        "safety_security": 60,
        "climate_resilience_score": 0.130097087,
        "safety_and_security": 0.642419289,
        "total_business_opportunity": 0.575912876,
        "open_for_business": 0.446334311,
        "entrepreneurship": 0.157041284,
        "gdp_2021": 0.003152016,
        "gdp_per_capita": 0.010960477,
        "gdp_growth_annual_percentage_2021": 0.37852077,
        "haq": 0.183333333,
        "domestic_private_health_expenditure_per_capita": 0.00545994,
        "domestic_private_health_expenditure": 0.631772814,
        "global_health_security_index": 0.21869783,
        "insurance_companies_number": 0.028145695,
        "number_of_private_hospitals": 0.076209302,
        "health_care_system": 0.083,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.008990719,
        "number_of_private_hospitals_vs_population_density": 0.198962138,
        "land_area": 0.076125633,
        "innovation_index": 0,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.362318841,
        "quality_index": 0.559375,
        "opportunity_index": 0.28079649,
        "school_enrollment_secondary": 0.151115746,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0924,
        "economic_freedom_index": 0.609336609,
        "demographic_pressures_indicator": 0.908045977,
        "cost_of_living": 0.443134272,
        "happiness_index": 0.286987522,
        "human_development_index": 0.333333333,
        "standard_of_living_index_by_world_population_review": 0.607613687,
        "ccpi": 0.444707521,
        "population_density_per_km2": 0.00095235,
        "quality_of_life": 0.14181155
    },
    {
        "iso_code": "PNG",
        "country": "Papua New Guinea",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 34,
        "climate_resilience": 26,
        "economic_freedom": 55,
        "education": 20,
        "lifestyle": 37,
        "private_healthcare": 14,
        "safety_security": 59,
        "climate_resilience_score": 0.130097087,
        "safety_and_security": 0.616264814,
        "total_business_opportunity": 0.627008328,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.001153728,
        "gdp_per_capita": 0.015448478,
        "gdp_growth_annual_percentage_2021": 0.39473151,
        "haq": 0.151515152,
        "domestic_private_health_expenditure_per_capita": 0.000397946,
        "domestic_private_health_expenditure": 0.088878327,
        "global_health_security_index": 0.150250417,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.00362529,
        "number_of_private_hospitals_vs_population_density": 0.000247897,
        "land_area": 0.027652389,
        "innovation_index": 0.299009901,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.275362319,
        "quality_index": 0.566015625,
        "opportunity_index": 0.294701316,
        "school_enrollment_secondary": 0.028258603,
        "school_enrollment_primary": 0.012684124,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.633906634,
        "demographic_pressures_indicator": 0.735632184,
        "cost_of_living": 0.422559563,
        "happiness_index": 0.357932264,
        "human_development_index": 0.298245614,
        "standard_of_living_index_by_world_population_review": 0.273500222,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000683505,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "COM",
        "country": "Comoro Islands",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 26,
        "economic_freedom": 50,
        "education": 27,
        "lifestyle": 30,
        "private_healthcare": 20,
        "safety_security": 65,
        "climate_resilience_score": 0.126213592,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000055,
        "gdp_per_capita": 0.007252118,
        "gdp_growth_annual_percentage_2021": 0.411955421,
        "haq": 0.289393939,
        "domestic_private_health_expenditure_per_capita": 0.006730013,
        "domestic_private_health_expenditure": 0.759505703,
        "global_health_security_index": 0.148580968,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.000418605,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0.0000661,
        "land_area": 0.000113609,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.333333333,
        "quality_index": 0.53203125,
        "opportunity_index": 0.256901789,
        "school_enrollment_secondary": 0.572679875,
        "school_enrollment_primary": 0.190159575,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.582309582,
        "demographic_pressures_indicator": 0.804597701,
        "cost_of_living": 0.111345482,
        "happiness_index": 0.43315508,
        "human_development_index": 0.280701754,
        "standard_of_living_index_by_world_population_review": 0.023552066,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.018047182,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MOZ",
        "country": "Mozambique",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 26,
        "economic_freedom": 51,
        "education": 17,
        "lifestyle": 42,
        "private_healthcare": 17,
        "safety_security": 54,
        "climate_resilience_score": 0.126213592,
        "safety_and_security": 0.505925623,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000697195,
        "gdp_per_capita": 0.001519965,
        "gdp_growth_annual_percentage_2021": 0.409321175,
        "haq": 0.218181818,
        "domestic_private_health_expenditure_per_capita": 0.000375075,
        "domestic_private_health_expenditure": 0.161121673,
        "global_health_security_index": 0.240400668,
        "insurance_companies_number": 0.013245033,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.002900232,
        "number_of_private_hospitals_vs_population_density": 0.0000331,
        "land_area": 0.048017697,
        "innovation_index": 0.093069307,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.217391304,
        "quality_index": 0.529296875,
        "opportunity_index": 0.254539318,
        "school_enrollment_secondary": 0.20919708,
        "school_enrollment_primary": 0.019946809,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.593366093,
        "demographic_pressures_indicator": 0.942528736,
        "cost_of_living": 0.303952419,
        "happiness_index": 0.534759358,
        "human_development_index": 0.122807018,
        "standard_of_living_index_by_world_population_review": 0.491186491,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001471813,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MMR",
        "country": "Myanmar",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 28,
        "climate_resilience": 25,
        "economic_freedom": 50,
        "education": 7,
        "lifestyle": 37,
        "private_healthcare": 24,
        "safety_security": 47,
        "climate_resilience_score": 0.122330097,
        "safety_and_security": 0.377196567,
        "total_business_opportunity": 0.575912876,
        "open_for_business": 0.532746823,
        "entrepreneurship": 0.009288991,
        "gdp_2021": 0.002826779,
        "gdp_per_capita": 0.005479576,
        "gdp_growth_annual_percentage_2021": 0,
        "haq": 0.3,
        "domestic_private_health_expenditure_per_capita": 0.006364085,
        "domestic_private_health_expenditure": 0.873574145,
        "global_health_security_index": 0.372287145,
        "insurance_companies_number": 0.013245033,
        "number_of_private_hospitals": 0.005790698,
        "health_care_system": 0.017,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001450116,
        "number_of_private_hospitals_vs_population_density": 0.004908361,
        "land_area": 0.03986046,
        "innovation_index": 0.067326733,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.003126628,
        "education_index": 0.304347826,
        "quality_index": 0.00390625,
        "opportunity_index": 0.002024975,
        "school_enrollment_secondary": 0.057247132,
        "school_enrollment_primary": 0.050429624,
        "best_countries_for_education": 0.002,
        "economic_freedom_index": 0.572481573,
        "demographic_pressures_indicator": 0.689655172,
        "cost_of_living": 0.192779833,
        "happiness_index": 0.379679144,
        "human_development_index": 0.333333333,
        "standard_of_living_index_by_world_population_review": 0.589986669,
        "ccpi": 0.444707521,
        "population_density_per_km2": 0.003106908,
        "quality_of_life": 0.059452888
    },
    {
        "iso_code": "BEN",
        "country": "Benin",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 25,
        "economic_freedom": 61,
        "education": 19,
        "lifestyle": 35,
        "private_healthcare": 18,
        "safety_security": 58,
        "climate_resilience_score": 0.122330097,
        "safety_and_security": 0.583980384,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000770678,
        "gdp_per_capita": 0.006870225,
        "gdp_growth_annual_percentage_2021": 0.498074975,
        "haq": 0.218181818,
        "domestic_private_health_expenditure_per_capita": 0.001767124,
        "domestic_private_health_expenditure": 0.600879278,
        "global_health_security_index": 0.156928214,
        "insurance_companies_number": 0.018211921,
        "number_of_private_hospitals": 0.000162791,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001450116,
        "number_of_private_hospitals_vs_population_density": 0.0000992,
        "land_area": 0.006885294,
        "innovation_index": 0.059405941,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.333333333,
        "quality_index": 0.434375,
        "opportunity_index": 0.230577118,
        "school_enrollment_secondary": 0.228321168,
        "school_enrollment_primary": 0.259308511,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.712530713,
        "demographic_pressures_indicator": 0.770114943,
        "cost_of_living": 0.1787752,
        "happiness_index": 0.411764706,
        "human_development_index": 0.280701754,
        "standard_of_living_index_by_world_population_review": 0.323803881,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.00411166,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "BFA",
        "country": "Burkina Faso",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 25,
        "economic_freedom": 58,
        "education": 18,
        "lifestyle": 36,
        "private_healthcare": 19,
        "safety_security": 44,
        "climate_resilience_score": 0.12038835,
        "safety_and_security": 0.313853698,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000855561,
        "gdp_per_capita": 0.00392819,
        "gdp_growth_annual_percentage_2021": 0.504356636,
        "haq": 0.216666667,
        "domestic_private_health_expenditure_per_capita": 0.002149823,
        "domestic_private_health_expenditure": 0.474691065,
        "global_health_security_index": 0.230383973,
        "insurance_companies_number": 0.013245033,
        "number_of_private_hospitals": 0.012069767,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001450116,
        "number_of_private_hospitals_vs_population_density": 0.010923995,
        "land_area": 0.016706463,
        "innovation_index": 0.108910891,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.086956522,
        "quality_index": 0.555078125,
        "opportunity_index": 0.27276409,
        "school_enrollment_secondary": 0.414911366,
        "school_enrollment_primary": 0.207651391,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.679361179,
        "demographic_pressures_indicator": 0.816091954,
        "cost_of_living": 0.20661157,
        "happiness_index": 0.438502674,
        "human_development_index": 0.105263158,
        "standard_of_living_index_by_world_population_review": 0.486890831,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002902237,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SLE",
        "country": "Sierra Leone",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 25,
        "economic_freedom": 52,
        "education": 19,
        "lifestyle": 27,
        "private_healthcare": 20,
        "safety_security": 64,
        "climate_resilience_score": 0.118446602,
        "safety_and_security": 0.715570086,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000179913,
        "gdp_per_capita": 0.001609269,
        "gdp_growth_annual_percentage_2021": 0.426139818,
        "haq": 0.192424242,
        "domestic_private_health_expenditure_per_capita": 0.003354333,
        "domestic_private_health_expenditure": 0.636525665,
        "global_health_security_index": 0.278797997,
        "insurance_companies_number": 0.011589404,
        "number_of_private_hospitals": 0.000627907,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.00087007,
        "number_of_private_hospitals_vs_population_density": 0.000396635,
        "land_area": 0.004407409,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.231884058,
        "quality_index": 0.440234375,
        "opportunity_index": 0.233682079,
        "school_enrollment_secondary": 0.069259645,
        "school_enrollment_primary": 0.060045008,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.601965602,
        "demographic_pressures_indicator": 0.862068966,
        "cost_of_living": 0.182924721,
        "happiness_index": 0.272727273,
        "human_development_index": 0.105263158,
        "standard_of_living_index_by_world_population_review": 0.085172567,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.004201655,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MWI",
        "country": "Malawi",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 25,
        "economic_freedom": 53,
        "education": 19,
        "lifestyle": 31,
        "private_healthcare": 18,
        "safety_security": 62,
        "climate_resilience_score": 0.106796117,
        "safety_and_security": 0.677973028,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000546338,
        "gdp_per_capita": 0.002339906,
        "gdp_growth_annual_percentage_2021": 0.42006079,
        "haq": 0.278787879,
        "domestic_private_health_expenditure_per_capita": 0.000518397,
        "domestic_private_health_expenditure": 0.254277567,
        "global_health_security_index": 0.208681135,
        "insurance_companies_number": 0.011589404,
        "number_of_private_hospitals": 0.000627907,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000435035,
        "number_of_private_hospitals_vs_population_density": 0.000214844,
        "land_area": 0.005756873,
        "innovation_index": 0.156435644,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.31884058,
        "quality_index": 0.492578125,
        "opportunity_index": 0.245426932,
        "school_enrollment_secondary": 0.105735141,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.614250614,
        "demographic_pressures_indicator": 0.942528736,
        "cost_of_living": 0.220789101,
        "happiness_index": 0.260249554,
        "human_development_index": 0.157894737,
        "standard_of_living_index_by_world_population_review": 0.158495038,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.007832204,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "UGA",
        "country": "Uganda",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 24,
        "economic_freedom": 54,
        "education": 21,
        "lifestyle": 41,
        "private_healthcare": 21,
        "safety_security": 54,
        "climate_resilience_score": 0.099029126,
        "safety_and_security": 0.508786269,
        "total_business_opportunity": 0.598821268,
        "open_for_business": 0.505571848,
        "entrepreneurship": 0.146376147,
        "gdp_2021": 0.001755589,
        "gdp_per_capita": 0.003581753,
        "gdp_growth_annual_percentage_2021": 0.432826748,
        "haq": 0.216666667,
        "domestic_private_health_expenditure_per_capita": 0.001530796,
        "domestic_private_health_expenditure": 0.480275665,
        "global_health_security_index": 0.342237062,
        "insurance_companies_number": 0.014900662,
        "number_of_private_hospitals": 0.046511628,
        "health_care_system": 0.0878,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.014064024,
        "land_area": 0.012244071,
        "innovation_index": 0.099009901,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.391304348,
        "quality_index": 0.56328125,
        "opportunity_index": 0.285723929,
        "school_enrollment_secondary": 0.077163712,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.083,
        "economic_freedom_index": 0.628992629,
        "demographic_pressures_indicator": 0.873563218,
        "cost_of_living": 0.189494796,
        "happiness_index": 0.363636364,
        "human_development_index": 0.263157895,
        "standard_of_living_index_by_world_population_review": 0.617093764,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.008842652,
        "quality_of_life": 0.145702128
    },
    {
        "iso_code": "MDG",
        "country": "Madagascar",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 24,
        "economic_freedom": 59,
        "education": 22,
        "lifestyle": 38,
        "private_healthcare": 19,
        "safety_security": 60,
        "climate_resilience_score": 0.097087379,
        "safety_and_security": 0.637106661,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000633774,
        "gdp_per_capita": 0.001603389,
        "gdp_growth_annual_percentage_2021": 0.453495441,
        "haq": 0.228787879,
        "domestic_private_health_expenditure_per_capita": 0.000611404,
        "domestic_private_health_expenditure": 0.441421103,
        "global_health_security_index": 0.240400668,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001450116,
        "number_of_private_hospitals_vs_population_density": 0.0000331,
        "land_area": 0.035525688,
        "innovation_index": 0.148514852,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.347826087,
        "quality_index": 0.4828125,
        "opportunity_index": 0.24400945,
        "school_enrollment_secondary": 0.444838373,
        "school_enrollment_primary": 0.201309329,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.686732187,
        "demographic_pressures_indicator": 0.942528736,
        "cost_of_living": 0.138663163,
        "happiness_index": 0.385026738,
        "human_development_index": 0.245614035,
        "standard_of_living_index_by_world_population_review": 0.420678418,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001774074,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "COG",
        "country": "Congo (Rep.)",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 24,
        "economic_freedom": 49,
        "education": 26,
        "lifestyle": 51,
        "private_healthcare": 18,
        "safety_security": 56,
        "climate_resilience_score": 0.095145631,
        "safety_and_security": 0.559869228,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00054187,
        "gdp_per_capita": 0.011398467,
        "gdp_growth_annual_percentage_2021": 0.293414387,
        "haq": 0.225757576,
        "domestic_private_health_expenditure_per_capita": 0.003415321,
        "domestic_private_health_expenditure": 0.613355513,
        "global_health_security_index": 0.171953255,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.000209302,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.002610209,
        "number_of_private_hospitals_vs_population_density": 0.000892429,
        "land_area": 0.020852554,
        "innovation_index": 0.308910891,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.420289855,
        "quality_index": 0.492578125,
        "opportunity_index": 0.245426932,
        "school_enrollment_secondary": 0.114452555,
        "school_enrollment_primary": 0.436477087,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.558968059,
        "demographic_pressures_indicator": 0.804597701,
        "cost_of_living": 0.655278537,
        "happiness_index": 0.516934046,
        "human_development_index": 0.515789474,
        "standard_of_living_index_by_world_population_review": 0.429062361,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000547943,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "HTI",
        "country": "Haiti",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 32,
        "climate_resilience": 24,
        "economic_freedom": 50,
        "education": 21,
        "lifestyle": 30,
        "private_healthcare": 18,
        "safety_security": 55,
        "climate_resilience_score": 0.093203884,
        "safety_and_security": 0.531262771,
        "total_business_opportunity": 0.575631006,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000908039,
        "gdp_per_capita": 0.0090969,
        "gdp_growth_annual_percentage_2021": 0.327862209,
        "haq": 0.15,
        "domestic_private_health_expenditure_per_capita": 0.003628779,
        "domestic_private_health_expenditure": 0.547528517,
        "global_health_security_index": 0.240400668,
        "insurance_companies_number": 0.018211921,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000435035,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.001682834,
        "innovation_index": 0.261386139,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.304347826,
        "quality_index": 0.503515625,
        "opportunity_index": 0.248126898,
        "school_enrollment_secondary": 0.134264859,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.577395577,
        "demographic_pressures_indicator": 0.850574713,
        "cost_of_living": 0.118780041,
        "happiness_index": 0.254901961,
        "human_development_index": 0.210526316,
        "standard_of_living_index_by_world_population_review": 0.227521849,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.015820855,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "BDI",
        "country": "Burundi",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 24,
        "economic_freedom": 39,
        "education": 19,
        "lifestyle": 26,
        "private_healthcare": 15,
        "safety_security": 51,
        "climate_resilience_score": 0.089320388,
        "safety_and_security": 0.442991418,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000123453,
        "gdp_per_capita": 0,
        "gdp_growth_annual_percentage_2021": 0.400810537,
        "haq": 0.178787879,
        "domestic_private_health_expenditure_per_capita": 0.000698311,
        "domestic_private_health_expenditure": 0.457818441,
        "global_health_security_index": 0.101836394,
        "insurance_companies_number": 0.009933775,
        "number_of_private_hospitals": 0.000581395,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0.0000826,
        "land_area": 0.001568038,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.246376812,
        "quality_index": 0.43671875,
        "opportunity_index": 0.231387108,
        "school_enrollment_secondary": 0.074139729,
        "school_enrollment_primary": 0.02086743,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.447174447,
        "demographic_pressures_indicator": 0.873563218,
        "cost_of_living": 0.148345379,
        "happiness_index": 0.285204991,
        "human_development_index": 0.070175439,
        "standard_of_living_index_by_world_population_review": 0.074063102,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.018040726,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MLI",
        "country": "Mali",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 24,
        "economic_freedom": 56,
        "education": 20,
        "lifestyle": 35,
        "private_healthcare": 19,
        "safety_security": 42,
        "climate_resilience_score": 0.087378641,
        "safety_and_security": 0.26277074,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000829736,
        "gdp_per_capita": 0.003926806,
        "gdp_growth_annual_percentage_2021": 0.426545086,
        "haq": 0.257575758,
        "domestic_private_health_expenditure_per_capita": 0.00113285,
        "domestic_private_health_expenditure": 0.361929658,
        "global_health_security_index": 0.217028381,
        "insurance_companies_number": 0.026490066,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.01363109,
        "number_of_private_hospitals_vs_population_density": 0.000198318,
        "land_area": 0.074506886,
        "innovation_index": 0.089108911,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.057971014,
        "quality_index": 0.555078125,
        "opportunity_index": 0.27276409,
        "school_enrollment_secondary": 0.455474453,
        "school_enrollment_primary": 0.408449264,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.64987715,
        "demographic_pressures_indicator": 0.862068966,
        "cost_of_living": 0.129672534,
        "happiness_index": 0.344028521,
        "human_development_index": 0.070175439,
        "standard_of_living_index_by_world_population_review": 0.541253148,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000567689,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "ZWE",
        "country": "Zimbabwe",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 24,
        "economic_freedom": 33,
        "education": 23,
        "lifestyle": 39,
        "private_healthcare": 22,
        "safety_security": 53,
        "climate_resilience_score": 0.087378641,
        "safety_and_security": 0.492031058,
        "total_business_opportunity": 0.627008328,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.001137354,
        "gdp_per_capita": 0.008650089,
        "gdp_growth_annual_percentage_2021": 0.482877406,
        "haq": 0.304545455,
        "domestic_private_health_expenditure_per_capita": 0.007708868,
        "domestic_private_health_expenditure": 0.598502852,
        "global_health_security_index": 0.273789649,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.000744186,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001885151,
        "number_of_private_hospitals_vs_population_density": 0.00135517,
        "land_area": 0.023621704,
        "innovation_index": 0.136633663,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.492753623,
        "quality_index": 0.571875,
        "opportunity_index": 0.300303746,
        "school_enrollment_secondary": 0.080917623,
        "school_enrollment_primary": 0.138400164,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.36977887,
        "demographic_pressures_indicator": 0.885057471,
        "cost_of_living": 0.285106677,
        "happiness_index": 0.172905526,
        "human_development_index": 0.315789474,
        "standard_of_living_index_by_world_population_review": 0.57902533,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001400045,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SOM",
        "country": "Somalia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 23,
        "economic_freedom": 48,
        "education": 23,
        "lifestyle": 44,
        "private_healthcare": 13,
        "safety_security": 38,
        "climate_resilience_score": 0.069902913,
        "safety_and_security": 0.175316714,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000314386,
        "gdp_per_capita": 0.001204833,
        "gdp_growth_annual_percentage_2021": 0.431813577,
        "haq": 0.084848485,
        "domestic_private_health_expenditure_per_capita": 0.022595095,
        "domestic_private_health_expenditure": 0.575926806,
        "global_health_security_index": 0,
        "insurance_companies_number": 0.001655629,
        "number_of_private_hospitals": 0.081395349,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.221801715,
        "land_area": 0.038306439,
        "innovation_index": 0.295445545,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.35942029,
        "quality_index": 0.568359375,
        "opportunity_index": 0.295916301,
        "school_enrollment_secondary": 0.104483837,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.554545455,
        "demographic_pressures_indicator": 1,
        "cost_of_living": 0.390919465,
        "happiness_index": 0.443850267,
        "human_development_index": 0.347368421,
        "standard_of_living_index_by_world_population_review": 0.361516812,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000909061,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "LBR",
        "country": "Liberia",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 23,
        "economic_freedom": 48,
        "education": 13,
        "lifestyle": 30,
        "private_healthcare": 22,
        "safety_security": 61,
        "climate_resilience_score": 0.067961165,
        "safety_and_security": 0.646097262,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00014888,
        "gdp_per_capita": 0.002515345,
        "gdp_growth_annual_percentage_2021": 0.445390071,
        "haq": 0.254545455,
        "domestic_private_health_expenditure_per_capita": 0.004159374,
        "domestic_private_health_expenditure": 0.6746673,
        "global_health_security_index": 0.328881469,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001305104,
        "number_of_private_hospitals_vs_population_density": 0.0000661,
        "land_area": 0.005881439,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.260869565,
        "quality_index": 0.005859375,
        "opportunity_index": 0.004049949,
        "school_enrollment_secondary": 0.073701773,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.551597052,
        "demographic_pressures_indicator": 0.827586207,
        "cost_of_living": 0.122237975,
        "happiness_index": 0.524064171,
        "human_development_index": 0.157894737,
        "standard_of_living_index_by_world_population_review": 0.060139239,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001960899,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "AFG",
        "country": "Afghanistan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 23,
        "economic_freedom": 59,
        "education": 15,
        "lifestyle": 32,
        "private_healthcare": 21,
        "safety_security": 29,
        "climate_resilience_score": 0.067961165,
        "safety_and_security": 0,
        "total_business_opportunity": 0.553106983,
        "open_for_business": 0.494688824,
        "entrepreneurship": 0.173922018,
        "gdp_2021": 0.002515951,
        "gdp_per_capita": 0.007276944,
        "gdp_growth_annual_percentage_2021": 0.340222898,
        "haq": 0.059090909,
        "domestic_private_health_expenditure_per_capita": 0.007379534,
        "domestic_private_health_expenditure": 0.914448669,
        "global_health_security_index": 0.213689483,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.000674419,
        "health_care_system": 0.1544,
        "health_care_index": 0.395205184,
        "insurance_companies_number_vs_population_density": 0.001160093,
        "number_of_private_hospitals_vs_population_density": 0.00079327,
        "land_area": 0.039864735,
        "innovation_index": 0.205544555,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.231884058,
        "quality_index": 0.258203125,
        "opportunity_index": 0.132365845,
        "school_enrollment_secondary": 0.0455683,
        "school_enrollment_primary": 0.060863339,
        "best_countries_for_education": 0.2148,
        "economic_freedom_index": 0.686486487,
        "demographic_pressures_indicator": 0.896551724,
        "cost_of_living": 0.055672741,
        "happiness_index": 0.046345811,
        "human_development_index": 0.210526316,
        "standard_of_living_index_by_world_population_review": 0.547326322,
        "ccpi": 0.612813371,
        "population_density_per_km2": 0.00223582,
        "quality_of_life": 0.181762918
    },
    {
        "iso_code": "NER",
        "country": "Niger",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 22,
        "economic_freedom": 55,
        "education": 12,
        "lifestyle": 33,
        "private_healthcare": 18,
        "safety_security": 47,
        "climate_resilience_score": 0.060194175,
        "safety_and_security": 0.367388639,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000647409,
        "gdp_per_capita": 0.002064728,
        "gdp_growth_annual_percentage_2021": 0.391691996,
        "haq": 0.187878788,
        "domestic_private_health_expenditure_per_capita": 0.001761025,
        "domestic_private_health_expenditure": 0.553944867,
        "global_health_security_index": 0.212020033,
        "insurance_companies_number": 0.003311258,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.001450116,
        "number_of_private_hospitals_vs_population_density": 0.0000826,
        "land_area": 0.077346868,
        "innovation_index": 0.055445545,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0,
        "quality_index": 0.4828125,
        "opportunity_index": 0.24400945,
        "school_enrollment_secondary": 0.166882169,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.637592138,
        "demographic_pressures_indicator": 0.862068966,
        "cost_of_living": 0.233064767,
        "happiness_index": 0.502673797,
        "human_development_index": 0,
        "standard_of_living_index_by_world_population_review": 0.264849652,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000672113,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SDN",
        "country": "Sudan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 22,
        "economic_freedom": 32,
        "education": 22,
        "lifestyle": 29,
        "private_healthcare": 22,
        "safety_security": 40,
        "climate_resilience_score": 0.05631068,
        "safety_and_security": 0.223539027,
        "total_business_opportunity": 0.631057015,
        "open_for_business": 0.524796351,
        "entrepreneurship": 0.139449541,
        "gdp_2021": 0.001489951,
        "gdp_per_capita": 0.003041428,
        "gdp_growth_annual_percentage_2021": 0.36656535,
        "haq": 0.325757576,
        "domestic_private_health_expenditure_per_capita": 0.004474986,
        "domestic_private_health_expenditure": 0.811668251,
        "global_health_security_index": 0.205342237,
        "insurance_companies_number": 0.01986755,
        "number_of_private_hospitals": 0.000790698,
        "health_care_system": 0.0766,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.007105568,
        "number_of_private_hospitals_vs_population_density": 0.002313705,
        "land_area": 0.112917385,
        "innovation_index": 0.408712871,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.144927536,
        "quality_index": 0.56328125,
        "opportunity_index": 0.286736416,
        "school_enrollment_secondary": 0.193326382,
        "school_enrollment_primary": 0.086743044,
        "best_countries_for_education": 0.0806,
        "economic_freedom_index": 0.356265356,
        "demographic_pressures_indicator": 0.896551724,
        "cost_of_living": 0.155779937,
        "happiness_index": 0.349376114,
        "human_development_index": 0.210526316,
        "standard_of_living_index_by_world_population_review": 0.001777514,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.00084109,
        "quality_of_life": 0.147744681
    },
    {
        "iso_code": "COD",
        "country": "Congo (Dem. Rep.)",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 22,
        "economic_freedom": 48,
        "education": 23,
        "lifestyle": 48,
        "private_healthcare": 17,
        "safety_security": 37,
        "climate_resilience_score": 0.05631068,
        "safety_and_security": 0.158561504,
        "total_business_opportunity": 0.529762973,
        "open_for_business": 0.493646139,
        "entrepreneurship": 0.131009174,
        "gdp_2021": 0.002343685,
        "gdp_per_capita": 0.002002348,
        "gdp_growth_annual_percentage_2021": 0.480040527,
        "haq": 0.178787879,
        "domestic_private_health_expenditure_per_capita": 0.000835534,
        "domestic_private_health_expenditure": 0.509980989,
        "global_health_security_index": 0.168614357,
        "insurance_companies_number": 0.026490066,
        "number_of_private_hospitals": 0.000209302,
        "health_care_system": 0.0682,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.005655452,
        "number_of_private_hospitals_vs_population_density": 0.000363582,
        "land_area": 0.13842997,
        "innovation_index": 0.361980198,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.002084419,
        "education_index": 0.362318841,
        "quality_index": 0.5125,
        "opportunity_index": 0.249679379,
        "school_enrollment_secondary": 0.096350365,
        "school_enrollment_primary": 0.151493453,
        "best_countries_for_education": 0.0546,
        "economic_freedom_index": 0.547911548,
        "demographic_pressures_indicator": 0.965517241,
        "cost_of_living": 0.655278537,
        "happiness_index": 0.392513369,
        "human_development_index": 0.157894737,
        "standard_of_living_index_by_world_population_review": 0.574877796,
        "ccpi": 0.432938719,
        "population_density_per_km2": 0.001466118,
        "quality_of_life": 0.131696049
    },
    {
        "iso_code": "GNB",
        "country": "Guinea-Bissau",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 21,
        "economic_freedom": 46,
        "education": 22,
        "lifestyle": 43,
        "private_healthcare": 15,
        "safety_security": 57,
        "climate_resilience_score": 0.044660194,
        "safety_and_security": 0.57131181,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000685,
        "gdp_per_capita": 0.003321738,
        "gdp_growth_annual_percentage_2021": 0.441337386,
        "haq": 0.116666667,
        "domestic_private_health_expenditure_per_capita": 0.005929547,
        "domestic_private_health_expenditure": 0.782557034,
        "global_health_security_index": 0.09015025,
        "insurance_companies_number": 0.003311258,
        "number_of_private_hospitals": 0.000116279,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000435035,
        "number_of_private_hospitals_vs_population_density": 0.000115685,
        "land_area": 0.001717029,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.231884058,
        "quality_index": 0.53203125,
        "opportunity_index": 0.256901789,
        "school_enrollment_secondary": 0.089301356,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.528255528,
        "demographic_pressures_indicator": 0.873563218,
        "cost_of_living": 0.150938829,
        "happiness_index": 0.684135472,
        "human_development_index": 0.157894737,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.002640227,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "ERI",
        "country": "Eritrea",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 43,
        "climate_resilience": 21,
        "economic_freedom": 40,
        "education": 23,
        "lifestyle": 37,
        "private_healthcare": 21,
        "safety_security": 50,
        "climate_resilience_score": 0.033009709,
        "safety_and_security": 0.43318349,
        "total_business_opportunity": 0.666700833,
        "open_for_business": 0.560443141,
        "entrepreneurship": 0.28587156,
        "gdp_2021": 0.016748774,
        "gdp_per_capita": 0.124875125,
        "gdp_growth_annual_percentage_2021": 0.453495441,
        "haq": 0.143939394,
        "domestic_private_health_expenditure_per_capita": 0.001076436,
        "domestic_private_health_expenditure": 0.484315589,
        "global_health_security_index": 0.09015025,
        "insurance_companies_number": 0.028145695,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.186,
        "health_care_index": 0.527170626,
        "insurance_companies_number_vs_population_density": 0.006960557,
        "number_of_private_hospitals_vs_population_density": 0.0000992,
        "land_area": 0.006167208,
        "innovation_index": 0.497029703,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.028985507,
        "quality_index": 0.553515625,
        "opportunity_index": 0.295916301,
        "school_enrollment_secondary": 0.076955162,
        "school_enrollment_primary": 0.108837971,
        "best_countries_for_education": 0.2688,
        "economic_freedom_index": 0.450859951,
        "demographic_pressures_indicator": 0.770114943,
        "cost_of_living": 0.119125834,
        "happiness_index": 0.715151515,
        "human_development_index": 0.122807018,
        "standard_of_living_index_by_world_population_review": 0.183676492,
        "ccpi": 0.388300836,
        "population_density_per_km2": 0.001272838,
        "quality_of_life": 0.280753799
    },
    {
        "iso_code": "CAF",
        "country": "Central African Republic",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 19,
        "economic_freedom": 46,
        "education": 11,
        "lifestyle": 24,
        "private_healthcare": 12,
        "safety_security": 40,
        "climate_resilience_score": 0.003883495,
        "safety_and_security": 0.217817736,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000106688,
        "gdp_per_capita": 0.001583614,
        "gdp_growth_annual_percentage_2021": 0.382573455,
        "haq": 0,
        "domestic_private_health_expenditure_per_capita": 0.002890826,
        "domestic_private_health_expenditure": 0.699500951,
        "global_health_security_index": 0.043405676,
        "insurance_companies_number": 0.009933775,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.011020882,
        "number_of_private_hospitals_vs_population_density": 0.000214844,
        "land_area": 0.03804021,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.144927536,
        "quality_index": 0.01171875,
        "opportunity_index": 0.004049949,
        "school_enrollment_secondary": 0.062794578,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.524570025,
        "demographic_pressures_indicator": 0.908045977,
        "cost_of_living": 0.117915557,
        "happiness_index": 0.231729055,
        "human_development_index": 0.01754386,
        "standard_of_living_index_by_world_population_review": 0.053029181,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000218721,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "TCD",
        "country": "Chad",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 19,
        "economic_freedom": 50,
        "education": 19,
        "lifestyle": 33,
        "private_healthcare": 16,
        "safety_security": 48,
        "climate_resilience_score": 0,
        "safety_and_security": 0.393543114,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.000509517,
        "gdp_per_capita": 0.002649849,
        "gdp_growth_annual_percentage_2021": 0.340020263,
        "haq": 0.137878788,
        "domestic_private_health_expenditure_per_capita": 0.002245879,
        "domestic_private_health_expenditure": 0.710670152,
        "global_health_security_index": 0.131886478,
        "insurance_companies_number": 0.006622517,
        "number_of_private_hospitals": 0.001744186,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.004350348,
        "number_of_private_hospitals_vs_population_density": 0.009221769,
        "land_area": 0.076888905,
        "innovation_index": 0.357623762,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.057971014,
        "quality_index": 0.492578125,
        "opportunity_index": 0.245426932,
        "school_enrollment_secondary": 0.237851929,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.574938575,
        "demographic_pressures_indicator": 0.954022989,
        "cost_of_living": 0.120509008,
        "happiness_index": 0.368983957,
        "human_development_index": 0.01754386,
        "standard_of_living_index_by_world_population_review": 0.395200711,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.000428709,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "TWN",
        "country": "Taiwan (Chinese Taipei)",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 52,
        "climate_resilience": 39,
        "economic_freedom": 80,
        "education": 39,
        "lifestyle": 57,
        "private_healthcare": 55,
        "safety_security": 68,
        "climate_resilience_score": 0.391067961,
        "safety_and_security": 0.791172865,
        "total_business_opportunity": 0.9119795,
        "open_for_business": 0.630498534,
        "entrepreneurship": 0.268050459,
        "gdp_2021": 0.217689778,
        "gdp_per_capita": 0.138203251,
        "gdp_growth_annual_percentage_2021": 0.499128673,
        "haq": 0.742424242,
        "domestic_private_health_expenditure_per_capita": 0.219606079,
        "domestic_private_health_expenditure": 0.552637833,
        "global_health_security_index": 0.604340568,
        "insurance_companies_number": 0.253311258,
        "number_of_private_hospitals": 0.009604651,
        "health_care_system": 0.2224,
        "health_care_index": 0.977969762,
        "insurance_companies_number_vs_population_density": 0.003335267,
        "number_of_private_hospitals_vs_population_density": 0.001008114,
        "land_area": 0.078330609,
        "innovation_index": 0.386930693,
        "number_of_universities_in_top_1000": 0.060773481,
        "number_of_top_tier_international_schools": 0.007816571,
        "education_index": 0.744927536,
        "quality_index": 0.7734375,
        "opportunity_index": 0.509956126,
        "school_enrollment_secondary": 0.281001043,
        "school_enrollment_primary": 0.098036007,
        "best_countries_for_education": 0.2238,
        "economic_freedom_index": 0.947174447,
        "demographic_pressures_indicator": 0.567816092,
        "cost_of_living": 0.378298005,
        "happiness_index": 0.814616756,
        "human_development_index": 0.733333333,
        "standard_of_living_index_by_world_population_review": 0.650748037,
        "ccpi": 0.19968663,
        "population_density_per_km2": 0.025474219,
        "quality_of_life": 0.296510638
    },
    {
        "iso_code": "SSD",
        "country": "South Sudan",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 35,
        "climate_resilience": 23,
        "economic_freedom": 59,
        "education": 16,
        "lifestyle": 25,
        "private_healthcare": 17,
        "safety_security": 36,
        "climate_resilience_score": 0.07223301,
        "safety_and_security": 0.151205558,
        "total_business_opportunity": 0.597258168,
        "open_for_business": 0.494688824,
        "entrepreneurship": 0.173922018,
        "gdp_2021": 0.002515951,
        "gdp_per_capita": 0.007276944,
        "gdp_growth_annual_percentage_2021": 0.340222898,
        "haq": 0.154545455,
        "domestic_private_health_expenditure_per_capita": 0.000404045,
        "domestic_private_health_expenditure": 0.312381179,
        "global_health_security_index": 0.088480801,
        "insurance_companies_number": 0.023178808,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.1544,
        "health_care_index": 0.395205184,
        "insurance_companies_number_vs_population_density": 0.011310905,
        "number_of_private_hospitals_vs_population_density": 0.0000992,
        "land_area": 0.038586598,
        "innovation_index": 0.205544555,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.086956522,
        "quality_index": 0.325390625,
        "opportunity_index": 0.279649004,
        "school_enrollment_secondary": 0.162857143,
        "school_enrollment_primary": 0.0950491,
        "best_countries_for_education": 0.2148,
        "economic_freedom_index": 0.686486487,
        "demographic_pressures_indicator": 0.954022989,
        "cost_of_living": 0.11359314,
        "happiness_index": 0.114081996,
        "human_development_index": 0.070175439,
        "standard_of_living_index_by_world_population_review": 0.058806103,
        "ccpi": 0.628412256,
        "population_density_per_km2": 0.000602623,
        "quality_of_life": 0.181762918
    },
    {
        "iso_code": "XXK",
        "country": "Kosovo",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 44,
        "climate_resilience": 36,
        "economic_freedom": 60,
        "education": 32,
        "lifestyle": 52,
        "private_healthcare": 30,
        "safety_security": 61,
        "climate_resilience_score": 0.323883495,
        "safety_and_security": 0.66040049,
        "total_business_opportunity": 0.579167201,
        "open_for_business": 0.684131639,
        "entrepreneurship": 0.307385321,
        "gdp_2021": 0.021917291,
        "gdp_per_capita": 0.057007142,
        "gdp_growth_annual_percentage_2021": 0.470070922,
        "haq": 0.573636364,
        "domestic_private_health_expenditure_per_capita": 0.040727098,
        "domestic_private_health_expenditure": 0.483555133,
        "global_health_security_index": 0.453088481,
        "insurance_companies_number": 0.024834437,
        "number_of_private_hospitals": 0.036302326,
        "health_care_system": 0.235,
        "health_care_index": 0.103239741,
        "insurance_companies_number_vs_population_density": 0.001305104,
        "number_of_private_hospitals_vs_population_density": 0.016228991,
        "land_area": 0.180702652,
        "innovation_index": 0.339009901,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.591304348,
        "quality_index": 0.641796875,
        "opportunity_index": 0.359500506,
        "school_enrollment_secondary": 0.145005214,
        "school_enrollment_primary": 0.227680033,
        "best_countries_for_education": 0.2314,
        "economic_freedom_index": 0.701474202,
        "demographic_pressures_indicator": 0.574712644,
        "cost_of_living": 0.108752032,
        "happiness_index": 0.621746881,
        "human_development_index": 0.747368421,
        "standard_of_living_index_by_world_population_review": 0.720752481,
        "ccpi": 0.464867688,
        "population_density_per_km2": 0.005956364,
        "quality_of_life": 0.339379939
    },
    {
        "iso_code": "PRK",
        "country": "North Korea",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 43,
        "climate_resilience": 31,
        "economic_freedom": 3,
        "education": 30,
        "lifestyle": 49,
        "private_healthcare": 24,
        "safety_security": 41,
        "climate_resilience_score": 0.224466019,
        "safety_and_security": 0.250102166,
        "total_business_opportunity": 0.648148623,
        "open_for_business": 0.570348648,
        "entrepreneurship": 0.289105505,
        "gdp_2021": 0.00602258,
        "gdp_per_capita": 0.032223218,
        "gdp_growth_annual_percentage_2021": 0.545694022,
        "haq": 0.510606061,
        "domestic_private_health_expenditure_per_capita": 0.029720615,
        "domestic_private_health_expenditure": 0.623455323,
        "global_health_security_index": 0.001669449,
        "insurance_companies_number": 0.001655629,
        "number_of_private_hospitals": 0,
        "health_care_system": 0.18,
        "health_care_index": 0.322937365,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.007352416,
        "innovation_index": 0.256237624,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.486956522,
        "quality_index": 0.689453125,
        "opportunity_index": 0.361930476,
        "school_enrollment_secondary": 0.195724713,
        "school_enrollment_primary": 0.140548282,
        "best_countries_for_education": 0.2652,
        "economic_freedom_index": 0,
        "demographic_pressures_indicator": 0.724137931,
        "cost_of_living": 0.171686435,
        "happiness_index": 0.664884136,
        "human_development_index": 0.494736842,
        "standard_of_living_index_by_world_population_review": 0.621656051,
        "ccpi": 0.450313371,
        "population_density_per_km2": 0.008082443,
        "quality_of_life": 0.289848024
    },
    {
        "iso_code": "PSE",
        "country": "Palestinian Territory",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 31,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 31,
        "lifestyle": 48,
        "private_healthcare": 27,
        "safety_security": 49,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.409480997,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0007816,
        "gdp_per_capita": 0.019758677,
        "gdp_growth_annual_percentage_2021": 0.507193516,
        "haq": 0.634848485,
        "domestic_private_health_expenditure_per_capita": 0.035243067,
        "domestic_private_health_expenditure": 0.296815589,
        "global_health_security_index": 0.280467446,
        "insurance_companies_number": 0.016556291,
        "number_of_private_hospitals": 0.075302326,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0.006544481,
        "land_area": 0.000367565,
        "innovation_index": 0.332277228,
        "number_of_universities_in_top_1000": 0.005524862,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.623188406,
        "quality_index": 0.466796875,
        "opportunity_index": 0.235909551,
        "school_enrollment_secondary": 0.297601668,
        "school_enrollment_primary": 0.460515548,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.83908046,
        "cost_of_living": 0.337840174,
        "happiness_index": 0.409982175,
        "human_development_index": 0.561403509,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.030969977,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "YEM",
        "country": "Yemen",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 32,
        "climate_resilience": 29,
        "economic_freedom": 48,
        "education": 14,
        "lifestyle": 38,
        "private_healthcare": 17,
        "safety_security": 32,
        "climate_resilience_score": 0.194563107,
        "safety_and_security": 0.065386187,
        "total_business_opportunity": 0.575631006,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00091314,
        "gdp_per_capita": 0.002617217,
        "gdp_growth_annual_percentage_2021": 0.322593718,
        "haq": 0.318181818,
        "domestic_private_health_expenditure_per_capita": 0.022595095,
        "domestic_private_health_expenditure": 0.575926806,
        "global_health_security_index": 0.001669449,
        "insurance_companies_number": 0.021523179,
        "number_of_private_hospitals": 0.004,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.003335267,
        "number_of_private_hospitals_vs_population_density": 0.004924887,
        "land_area": 0.032238735,
        "innovation_index": 0.007920792,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.144927536,
        "quality_index": 0.503515625,
        "opportunity_index": 0.248126898,
        "school_enrollment_secondary": 0.134264859,
        "school_enrollment_primary": 0.164873159,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.554545455,
        "demographic_pressures_indicator": 0.988505747,
        "cost_of_living": 0.130191224,
        "happiness_index": 0.360071301,
        "human_development_index": 0.140350877,
        "standard_of_living_index_by_world_population_review": 0.561102059,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.00211165,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "LIE",
        "country": "Liechtenstein",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 40,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 32,
        "lifestyle": 61,
        "private_healthcare": 32,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00027675,
        "gdp_per_capita": 0.973254582,
        "gdp_growth_annual_percentage_2021": 0.640121581,
        "haq": 0.616969697,
        "domestic_private_health_expenditure_per_capita": 0.035243067,
        "domestic_private_health_expenditure": 0.296815589,
        "global_health_security_index": 0.507512521,
        "insurance_companies_number": 0.054635762,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.002030162,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.00000974,
        "innovation_index": 0.359207921,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.84057971,
        "quality_index": 0.669921875,
        "opportunity_index": 0.326695916,
        "school_enrollment_secondary": 0.038581856,
        "school_enrollment_primary": 0.032733224,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.651129016,
        "happiness_index": 0.684135472,
        "human_development_index": 0.929824561,
        "standard_of_living_index_by_world_population_review": 0.788031403,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.00899758,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "SMR",
        "country": "San Marino",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 26,
        "lifestyle": 46,
        "private_healthcare": 27,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000644,
        "gdp_per_capita": 0.261046971,
        "gdp_growth_annual_percentage_2021": 0.2295846,
        "haq": 0.616969697,
        "domestic_private_health_expenditure_per_capita": 0.082117133,
        "domestic_private_health_expenditure": 0.182271863,
        "global_health_security_index": 0.282136895,
        "insurance_companies_number": 0.203642384,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.003190255,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.00000364,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.504347826,
        "quality_index": 0.53203125,
        "opportunity_index": 0.256901789,
        "school_enrollment_secondary": 0.197559958,
        "school_enrollment_primary": 0,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.274905771,
        "happiness_index": 0.684135472,
        "human_development_index": 0.557894737,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.021442681,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "AND",
        "country": "Andorra",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 33,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 26,
        "lifestyle": 52,
        "private_healthcare": 36,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00014206,
        "gdp_per_capita": 0.246817797,
        "gdp_growth_annual_percentage_2021": 0.545694022,
        "haq": 1,
        "domestic_private_health_expenditure_per_capita": 0.127080449,
        "domestic_private_health_expenditure": 0.333531369,
        "global_health_security_index": 0.312186978,
        "insurance_companies_number": 0.056291391,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.003045244,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.0000287,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.001042209,
        "education_index": 0.68115942,
        "quality_index": 0.435546875,
        "opportunity_index": 0.231387108,
        "school_enrollment_secondary": 0.03096976,
        "school_enrollment_primary": 0.023424714,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.364984958,
        "happiness_index": 0.684135472,
        "human_development_index": 0.842105263,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.00616825,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "VAT",
        "country": "Vatican City",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 43,
        "climate_resilience": 35,
        "economic_freedom": 64,
        "education": 29,
        "lifestyle": 46,
        "private_healthcare": 27,
        "safety_security": 64,
        "climate_resilience_score": 0.30368932,
        "safety_and_security": 0.715243155,
        "total_business_opportunity": 0.788853299,
        "open_for_business": 0.510589769,
        "entrepreneurship": 0.228761468,
        "gdp_2021": 0.000392971,
        "gdp_per_capita": 0.107352832,
        "gdp_growth_annual_percentage_2021": 0.490091185,
        "haq": 0.595151515,
        "domestic_private_health_expenditure_per_capita": 0.03482469,
        "domestic_private_health_expenditure": 0.172219582,
        "global_health_security_index": 0.197662771,
        "insurance_companies_number": 0,
        "number_of_private_hospitals": 0.000372093,
        "health_care_system": 0.1458,
        "health_care_index": 0.370064795,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0,
        "innovation_index": 0.438811881,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.652173913,
        "quality_index": 0.39921875,
        "opportunity_index": 0.170097874,
        "school_enrollment_secondary": 0.20919708,
        "school_enrollment_primary": 0.148547463,
        "best_countries_for_education": 0.1528,
        "economic_freedom_index": 0.747911548,
        "demographic_pressures_indicator": 0.48045977,
        "cost_of_living": 0.223036758,
        "happiness_index": 0.699108734,
        "human_development_index": 0.652631579,
        "standard_of_living_index_by_world_population_review": 0.525522145,
        "ccpi": 0.53387883,
        "population_density_per_km2": 0.086230191,
        "quality_of_life": 0.185240122
    },
    {
        "iso_code": "VCT",
        "country": "St. Vincent and the Grenadines",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 34,
        "economic_freedom": 66,
        "education": 28,
        "lifestyle": 47,
        "private_healthcare": 24,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.0000359,
        "gdp_per_capita": 0.044737664,
        "gdp_growth_annual_percentage_2021": 0.379331307,
        "haq": 0.437878788,
        "domestic_private_health_expenditure_per_capita": 0.016799112,
        "domestic_private_health_expenditure": 0.35289924,
        "global_health_security_index": 0.292153589,
        "insurance_companies_number": 0.008278146,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000290023,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000238,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.623188406,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.293847758,
        "school_enrollment_primary": 0.114668576,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.77027027,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.277153429,
        "happiness_index": 0.684135472,
        "human_development_index": 0.614035088,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.010752668,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MAC",
        "country": "Macao (SAR China)",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 41,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 41,
        "lifestyle": 50,
        "private_healthcare": 27,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.627008328,
        "open_for_business": 0.524796351,
        "entrepreneurship": 0.139449541,
        "gdp_2021": 0.001297706,
        "gdp_per_capita": 0.260504283,
        "gdp_growth_annual_percentage_2021": 0.72887538,
        "haq": 0.616969697,
        "domestic_private_health_expenditure_per_capita": 0.035243067,
        "domestic_private_health_expenditure": 0.296815589,
        "global_health_security_index": 0.280467446,
        "insurance_companies_number": 0.041390728,
        "number_of_private_hospitals": 0.0000698,
        "health_care_system": 0.0766,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.00000198,
        "innovation_index": 0.311287129,
        "number_of_universities_in_top_1000": 0.011049724,
        "number_of_top_tier_international_schools": 0.001563314,
        "education_index": 0.504347826,
        "quality_index": 0.566015625,
        "opportunity_index": 0.294701316,
        "school_enrollment_secondary": 1,
        "school_enrollment_primary": 1,
        "best_countries_for_education": 0.0806,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.508489229,
        "happiness_index": 0.684135472,
        "human_development_index": 0.557894737,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.429805014,
        "population_density_per_km2": 0.759819494,
        "quality_of_life": 0.147744681
    },
    {
        "iso_code": "TUV",
        "country": "Tuvalu",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 26,
        "lifestyle": 43,
        "private_healthcare": 21,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0,
        "gdp_per_capita": 0.029141825,
        "gdp_growth_annual_percentage_2021": 0.424924012,
        "haq": 0.616969697,
        "domestic_private_health_expenditure_per_capita": 0.003029573,
        "domestic_private_health_expenditure": 0,
        "global_health_security_index": 0.066777963,
        "insurance_companies_number": 0.004966887,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000018,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.504347826,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.221167883,
        "school_enrollment_primary": 0.158346972,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.128116463,
        "happiness_index": 0.684135472,
        "human_development_index": 0.557894737,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.015012801,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "KIR",
        "country": "Kiribati",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 34,
        "economic_freedom": 59,
        "education": 24,
        "lifestyle": 41,
        "private_healthcare": 16,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00000512,
        "gdp_per_capita": 0.007366848,
        "gdp_growth_annual_percentage_2021": 0.353191489,
        "haq": 0.246969697,
        "domestic_private_health_expenditure_per_capita": 0.00017839,
        "domestic_private_health_expenditure": 0.005584601,
        "global_health_security_index": 0.170283806,
        "insurance_companies_number": 0.001655629,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.0000494,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.492753623,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.13632951,
        "school_enrollment_primary": 0,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.69041769,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.109097825,
        "happiness_index": 0.684135472,
        "human_development_index": 0.421052632,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.005609295,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "MHL",
        "country": "Marshall Islands",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 29,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 29,
        "lifestyle": 46,
        "private_healthcare": 18,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00000807,
        "gdp_per_capita": 0.022681744,
        "gdp_growth_annual_percentage_2021": 0.313677812,
        "haq": 0.321212121,
        "domestic_private_health_expenditure_per_capita": 0.015426885,
        "domestic_private_health_expenditure": 0.158864068,
        "global_health_security_index": 0.143572621,
        "insurance_companies_number": 0.001655629,
        "number_of_private_hospitals": 0.0000465,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0.0000165,
        "land_area": 0.000011,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.666666667,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.216684046,
        "school_enrollment_primary": 0.201616203,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.320377606,
        "happiness_index": 0.684135472,
        "human_development_index": 0.543859649,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.012495605,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "PLW",
        "country": "Palau Islands",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 28,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 33,
        "lifestyle": 51,
        "private_healthcare": 25,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00000846,
        "gdp_per_capita": 0.08075496,
        "gdp_growth_annual_percentage_2021": 0.166970618,
        "haq": 0.616969697,
        "domestic_private_health_expenditure_per_capita": 0.102349863,
        "domestic_private_health_expenditure": 0.31154943,
        "global_health_security_index": 0.158597663,
        "insurance_companies_number": 0,
        "number_of_private_hospitals": 0.000093,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0.000165265,
        "land_area": 0.0000281,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.884057971,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.2362878,
        "school_enrollment_primary": 0.226370704,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.379681179,
        "happiness_index": 0.684135472,
        "human_development_index": 0.771929825,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.001419032,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "NRU",
        "country": "Nauru",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 30,
        "climate_resilience": 34,
        "economic_freedom": 64,
        "education": 26,
        "lifestyle": 44,
        "private_healthcare": 21,
        "safety_security": 65,
        "climate_resilience_score": 0.292815534,
        "safety_and_security": 0.746138128,
        "total_business_opportunity": 0.449609225,
        "open_for_business": 0.473378951,
        "entrepreneurship": 0.131788991,
        "gdp_2021": 0.00000305,
        "gdp_per_capita": 0.069272838,
        "gdp_growth_annual_percentage_2021": 0.39473151,
        "haq": 0.616969697,
        "domestic_private_health_expenditure_per_capita": 0.00676813,
        "domestic_private_health_expenditure": 0.025665399,
        "global_health_security_index": 0.033388982,
        "insurance_companies_number": 0,
        "number_of_private_hospitals": 0.0000233,
        "health_care_system": 0.0696,
        "health_care_index": 0.299697624,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.00000119,
        "innovation_index": 0.363960396,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0,
        "education_index": 0.504347826,
        "quality_index": 0.46953125,
        "opportunity_index": 0.23840702,
        "school_enrollment_secondary": 0.133305527,
        "school_enrollment_primary": 0.167348609,
        "best_countries_for_education": 0.0632,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.496551724,
        "cost_of_living": 0.170821951,
        "happiness_index": 0.684135472,
        "human_development_index": 0.557894737,
        "standard_of_living_index_by_world_population_review": 0.601096134,
        "ccpi": 0.452263231,
        "population_density_per_km2": 0.020562479,
        "quality_of_life": 0.125884499
    },
    {
        "iso_code": "JEY",
        "country": "Jersey",
        "cpi": false, 
        "cbn": false,
        "rpi": false,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : null, "eur" : null}
        },
        
        "business_opportunity": 39,
        "climate_resilience": 39,
        "economic_freedom": 64,
        "education": 29,
        "lifestyle": 56,
        "private_healthcare": 27,
        "safety_security": 65,
        "climate_resilience_score": 0.393786408,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.532658552,
        "open_for_business": 0.685565331,
        "entrepreneurship": 0.03440367,
        "gdp_2021": 0.000498212,
        "gdp_per_capita": 0.427936611,
        "gdp_growth_annual_percentage_2021": 0.47781155,
        "haq": 0.687878788,
        "domestic_private_health_expenditure_per_capita": 0.066474047,
        "domestic_private_health_expenditure": 0.433697719,
        "global_health_security_index": 0.398998331,
        "insurance_companies_number": 0.066225166,
        "number_of_private_hospitals": 0.002790698,
        "health_care_system": 0.0304,
        "health_care_index": 0.127170626,
        "insurance_companies_number_vs_population_density": 0.000580046,
        "number_of_private_hospitals_vs_population_density": 0.000214844,
        "land_area": 0.00000727,
        "innovation_index": 0.356831683,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.779710145,
        "quality_index": 0.383984375,
        "opportunity_index": 0.127640905,
        "school_enrollment_secondary": 0.262482169,
        "school_enrollment_primary": 0.223583674,
        "best_countries_for_education": 0.057,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.308045977,
        "cost_of_living": 0.640699886,
        "happiness_index": 0.616926916,
        "human_development_index": 0.740701754,
        "standard_of_living_index_by_world_population_review": 0.957428529,
        "ccpi": 0.646901114,
        "population_density_per_km2": 0.03466356,
        "quality_of_life": 0.102857143
    },
    {
        "iso_code": "MCO",
        "country": "Monaco",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 0, "eur" : 0}
        },
        "business_opportunity": 41,
        "climate_resilience": 38,
        "economic_freedom": 64,
        "education": 28,
        "lifestyle": 60,
        "private_healthcare": 22,
        "safety_security": 65,
        "climate_resilience_score": 0.366213592,
        "safety_and_security": 0.72823866,
        "total_business_opportunity": 0.532658552,
        "open_for_business": 0.685565331,
        "entrepreneurship": 0.03440367,
        "gdp_2021": 0.000293664,
        "gdp_per_capita": 1,
        "gdp_growth_annual_percentage_2021": 0.126241135,
        "haq": 0.578484849,
        "domestic_private_health_expenditure_per_capita": 0.066030055,
        "domestic_private_health_expenditure": 0.149714829,
        "global_health_security_index": 0.288814691,
        "insurance_companies_number": 0.016556291,
        "number_of_private_hospitals": 0.000116279,
        "health_care_system": 0.0304,
        "health_care_index": 0.127170626,
        "insurance_companies_number_vs_population_density": 0,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 9.71e-8,
        "innovation_index": 0.064554455,
        "number_of_universities_in_top_1000": 0,
        "number_of_top_tier_international_schools": 0.000521105,
        "education_index": 0.901449275,
        "quality_index": 0.383984375,
        "opportunity_index": 0.127640905,
        "school_enrollment_secondary": 0.333557873,
        "school_enrollment_primary": 0.314781097,
        "best_countries_for_education": 0.057,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.317241379,
        "cost_of_living": 0.897161036,
        "happiness_index": 0.616926916,
        "human_development_index": 0.701403509,
        "standard_of_living_index_by_world_population_review": 0.957428529,
        "ccpi": 0.646901114,
        "population_density_per_km2": 1,
        "quality_of_life": 0.102857143
    },
    {
        "iso_code": "HKG",
        "country": "Hong Kong (SAR China)",
        "cpi": false, 
        "cbn": false,
        "rpi": true,
        "minimum_investment": {
            "cpi": {"usd": null, "eur": null},
            "cbn": {"usd": null, "eur": null},
            "rpi": {"usd" : 0, "eur" : 0}
        },
        "business_opportunity": 64,
        "climate_resilience": 49,
        "economic_freedom": 64,
        "education": 41,
        "lifestyle": 68,
        "private_healthcare": 39,
        "safety_security": 67,
        "climate_resilience_score": 0.581747573,
        "safety_and_security": 0.773600327,
        "total_business_opportunity": 0.934529148,
        "open_for_business": 0.882697947,
        "entrepreneurship": 0.478669725,
        "gdp_2021": 0.016006069,
        "gdp_per_capita": 0.284943407,
        "gdp_growth_annual_percentage_2021": 0.494427558,
        "haq": 0.700909091,
        "domestic_private_health_expenditure_per_capita": 0.118960523,
        "domestic_private_health_expenditure": 0.549548479,
        "global_health_security_index": 0.530217028,
        "insurance_companies_number": 0.147350993,
        "number_of_private_hospitals": 0.00027907,
        "health_care_system": 0.3134,
        "health_care_index": 0.261987041,
        "insurance_companies_number_vs_population_density": 0.000145012,
        "number_of_private_hospitals_vs_population_density": 0,
        "land_area": 0.0000641,
        "innovation_index": 0.576633663,
        "number_of_universities_in_top_1000": 0.033149171,
        "number_of_top_tier_international_schools": 0.035956227,
        "education_index": 0.913043478,
        "quality_index": 0.583984375,
        "opportunity_index": 0.204522444,
        "school_enrollment_secondary": 0.211880083,
        "school_enrollment_primary": 0.192040712,
        "best_countries_for_education": 0.3326,
        "economic_freedom_index": 0.745945946,
        "demographic_pressures_indicator": 0.365517241,
        "cost_of_living": 0.580628652,
        "happiness_index": 0.696588235,
        "human_development_index": 0.980701754,
        "standard_of_living_index_by_world_population_review": 0.990519923,
        "ccpi": 0.573885794,
        "population_density_per_km2": 0.26800826,
        "quality_of_life": 0.467112462
    }
];

export {portfolio};